import React, { ReactElement } from "react";

export function ChineseTerms(): ReactElement {
  return (
    <>
      <p><span style={{ color: "#ff0000" }}>体育博彩规则</span></p>
      <p><br /> </p>
      <p>接受投注：</p>
      <p><br /> </p>
      <p>用户只能通过自己的游戏账户下注；</p>
      <p><br /> </p>
      <p>用户所下的任何赌注都将从其自己的用户帐户余额中扣除；</p>
      <p><br /> </p>
      <p>仅当用户帐户的余额等于或大于您希望下注的金额时，才会接受投注；</p>
      <p><br /> </p>
      <p>投注是固定赔率投注，这意味着要考虑的赔率将是投注时提供的赔率，除非做出进一步的更改；</p>
      <p><br /> </p>
      <p>任何投注都将由我们自行决定是否接受，总体限制可由我们自行决定；</p>
      <p><br /> </p>
      <p>所有投注均须经我们部门接受，且不得有任何变动）；</p>
      <p><br /> </p>
      <p>要被视为有效，投注必须遵守为您投注的特定事件所设立的最低事件选择；</p>
      <p><br /> </p>
      <p>对不同体育赛事的投注必须获得授权。在这种情况下，所选赛事的最低投注数量为最低投注数量最高的体育赛事；</p>
      <p><br /> </p>
      <p>除非网站另有说明或授权，否则不允许对单个事件进行投注；21.1.11. - 除非明确授权，否则不允许对同一事件进行多个预测；</p>
      <p><br /> </p>
      <p>指定预测的唯一有效缩写是&ldquo;Palinsesto&rdquo;部分中指出的缩写；</p>
      <p><br /> </p>
      <p>不允许进行多重投注，因为单一结果会影响其他结果的结果；</p>
      <p><br /> </p>
      <p>赛事开始后接受的单注投注将被视为无效，而复注投注中只有特定赛事的相应投注将被视为无效；</p>
      <p><br /> </p>
      <p>不符合上述规则的投注、错误接受的投注、因印刷错误而更改的投注或因错误而倒置的赔率的投注将被视为无效，相应的投注金额将被退还；</p>
      <p><br /> </p>
      <p>如果由于缺乏更新或输入错误而导致投注的赔率明显不正确，或者由于技术问题导致实时投注的赔率被阻止，或者赔率彼此不兼容，我们保留取消某项赛事或整张优惠券的权利。</p>
      <p><br /> </p>
      <p>单项赛事的赔率可能会有所变更、更正或暂停。如果由于抄录或数据录入错误导致赔率的发布和定义出现错误，我们保留在最终结果确定后修改错误赔率的权利。我们将通过网站新闻或内部消息及时通知用户此类修改。对于单项投注单，如果在赛事开始前进行此类修改，用户可以申请取消。对于基本、积分或组合投注单，取消请求必须在投注单中包含的任何赛事开始前收到；</p>
      <p><br /> </p>
      <p>赛事日期、时间、实时比分和结果仅供参考。各联合会在赛事结束后公布的结果将被视为正式有效结果。结果变更后的决定将不予考虑。基于报纸或其他新闻信息机构报道的数据和时间而产生的争议将不予受理；</p>
      <p><br /> </p>
      <p>禁止为了超出或规避每项运动项目允许的最高金额而拆分复式投注或系统。任何奖金将作废；</p>
      <p><br /> </p>
      <p>禁止为了超过或逃避每张投注单允许的最高奖金金额而拆分复式投注或系统。任何奖金将被取消（作废）；21.1.21. - 如果赛事提前至公布时间（或日期）之前进行，则在实际开始前进行的投注将被视为有效；</p>
      <p><br /> </p>
      <p>如果投注明显带有欺诈意图，且用户已经知晓事件结果，我们保留取消获胜投注、关闭账户并扣留资金一年的权利。</p>
      <p><br /> </p>
      <p>如果对非单一玩法的赛事投注时，添加了如奇/偶或其他任何包含至少一个预先已获胜或无效结果的选项，以规避相关结果的投注限制，我们保留作废整个注单的权利。</p>
      <p><br /> </p>
      <p>如果由于对活动进行情况的投诉，用户希望查看活动本身的记录，则所有管理费用（包括运费）将由用户承担；</p>
      <p><br /> </p>
      <p>我们保留接受、不接受或部分接受用户发送的注册请求的权利；</p>
      <p><br /> </p>
      <p>特殊投注的规则将通过通常的披露方式不时披露；</p>
      <p><br /> </p>
      <p>如果任何项目的参赛者在比赛开始前因任何原因退出，则有关 Antepost 的预测将被视为失败；</p>
      <p><br /> </p>
      <p>在没有赛事注册的情况下，官方结果始终且无论如何都是由各个官方联合会发布的结果；</p>
      <p><br /> </p>
      <p>每个网络/联盟会员/用户每日最高赢利为 25,000 欧元（两万五千欧元），无论投注数量多少。每个网络/联盟会员/用户每周最高赢利为 50,000 欧元（五万欧元），无论投注数量多少。</p>
      <p><br /> </p>
      <p>我们保留取消账户持有人与第三方之间为逃避规则而达成的协议所获得的奖金的权利（规则不时在网站上公布）；</p>
      <p><br /> </p>
      <p>当预测结果被宣布为获胜者时，奖金将自动计算并记入用户的账户。用户必须使用网站上提供和公布的领取方式领取奖金；</p>
      <p><br /> </p>
      <p>为计算获胜预测而被视为有效的赔率是接受预测时有效的赔率；</p>
      <p><br /> </p>
      <p>若同一赛事中参赛者之间出现平局，则获胜将按照赔率除以排名相同的参赛者人数来计算；</p>
      <p><br /> </p>
      <p>无效赛事的赔率为 1.00。如果该赛事是单独预测的，则投注金额将被退还；</p>
      <p>如果单次预测获胜，奖金金额将等于投注金额乘以预测本身的赔率；</p>
      <p><br /> </p>
      <p>如果多项预测获胜，则奖金金额将等于投注金额乘以预测本身的赔率；</p>
      <p><br /> </p>
      <p>如果任何金额因错误（例如输入结果）被记入用户账户，用户有义务告知此情况。因此，由此错误产生的所有奖金将被视为无效；</p>
      <p><br /> </p>
      <p>如果主管体育组织不提供能够确定投注结果的官方信息，则保留将投注视为无效的权利。&rdquo;</p>
      <p><br /> </p>
      <p>任何通过其他博彩公司、用户集团、协会、朋友或亲戚团体或根据其他人的建议进行的、旨在诈骗的投注将被取消，相关资金将被扣留一年。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>奖励</span></p>
      <p>奖金金额是奖金的组成部分，并出现在投注摘要中。</p>
      <p>奖金按包含一定数量有效事件的倍数支付。</p>
      <p>奖金是参与收据上可验证的奖金金额的百分比增长。根据中奖多注彩票中存在的有效赛事，潜在奖金的奖金百分比如下所示。</p>
      <p>某些赔率低于一定范围的事件无助于获得奖金。</p>
      <p>可退款活动（配额 1）不计入奖金获取，奖金将在支付奖金时重新计算。</p>
      <p><span style={{ color: "#ff0000" }}>提现</span></p>
      <p><span>赛前兑现：玩家可以在一个或多个活动开始前，且没有其他活动正在进行的情况下兑现优惠券。以下是数学计算：[(潜在赢取金额 / 兑现时更新的未兑现额度) - 提前兑现优惠券的费用总额百分比]。</span></p>
      <p><span>现金兑现实时投注：玩家可以在一场或多场赛事结束前兑现优惠券。以下是数学计算公式：[(兑现时更新的潜在赢取金额/未兑现额度) - 提前领取优惠券的总费用百分比]。在现金兑现实时投注中，市场可能活跃或不活跃，这取决于赛事本身的进展。因此，公司对特定赛事现金兑现期间市场可能缺席的情况不承担任何责任。</span></p>
      <p><span>现金提取优惠券混合赛前投注 + 现场投注：不允许提取现金。</span></p>
      <p><span>附言：提现可能可用或不可用，还取决于其他动态因素，例如每场赛事的最大赔率、正在进行的赛事数量等，或公司自行决定的其他因素。</span></p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>足球</span></p>
      <p><br /> </p>
      <p>除非另有说明，所有投注均指90分钟加伤停补时。如果裁判在90分钟前吹响终场哨，且比赛结果与场上实际取得的成绩一致，则所有投注均视为有效。</p>
      <p>除非另有说明，任何体育赛事官方组织机构在赛事结束后做出的任何决定均不予考虑。尤其对于实时投注，由于市场即时报告，赛事结束后做出的任何决定均不予考虑。</p>
      <p>对于友谊赛，即使没有明确说明，即使在标准90分钟结束前结束，所有投注仍将被视为有效。（例如，比赛分为两个半场，每个半场40分钟或30分钟）。例外情况是，比赛分为三个或三个以上半场，如果没有明确说明，则将被视为无效，赔率为1.00。</p>
      <p>如果赛事暂停、取消或延期，且赛事在次日晚上 11:59 前恢复，投注仍然有效。在此时间之后，结果确定的盘口（例如，3-0 的比分暂停，将支付“大”的赔率，但不支付“1”的赔率，因为结果尚不确定）将照常进行；所有结果不确定的盘口将被视为无效，赔率为 1.00。如果暂停、取消或延期的赛事包含在复式投注中，投注仍然有效，但只有相关赛事的赔率为 1.00。已确定的结果是指比赛期间不再发生变化的结果。未确定的结果是指比赛恢复后可能发生变化的结果。</p>
      <p>此外，退款可分为两类：</p>
      <p>全额退款：赛事未举行。在这种情况下，赛事将被视为赔率为 1，投注将自动退款。</p>
      <p>时间退款：赛事在投注接受的官方时间之后进行。所有在此时间之后进行的投注将按赔率 1 计算。</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
      <p>您必须预测常规时间结束时比赛的最终结果，不包括加时赛和点球：</p>
      <p>签1主队获胜；</p>
      <p>X 符号绘制；</p>
      <p>标志 2 客队获胜。</p>
      <p><span style={{ color: "#ff0000" }}>双倍机会 1X</span></p>
      <p>预测比赛的最终结果将是常规时间结束时主队获胜或平局，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会 X2</span></p>
      <p>预测比赛的最终结果为客队获胜或在常规时间结束时打平，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会 1/2</span></p>
      <p>预测比赛的最终结果将在常规时间结束时为主队或客队获胜，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于</span></p>
      <p>您必须预测两队在比赛中的进球总数是高于（大于）还是低于（小于）所提供的让分盘口。投注仅考虑常规时间，不包括加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>大小盘主场</span></p>
      <p>您必须预测主队在比赛中的得分是高于（大）还是低于（小）。投注仅考虑常规时间，不包括加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>客人人数不足/过多</span></p>
      <p>您必须预测客队在比赛中的得分是高于（大）还是低于（小）。投注仅考虑常规时间，不包括加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 1° 时间</span></p>
      <p>您必须预测比赛上半场两队进球总数是高于（大于）还是低于（小于）提供的让分。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 2° 时间</span></p>
      <p>您必须预测比赛下半场进球总数是高于（大于）还是低于（小于）提供的让分。</p>
      <p><span style={{ color: "#ff0000" }}>打进第一个球</span></p>
      <p>投注内容是确定哪支球队将在常规时间内率先进球，不包括加时赛和点球。</p>
      <p>可预见的结果是：</p>
      <p>球队 1：主队将得分；</p>
      <p>球队 2：客队将得分；</p>
      <p>不会进球。</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球</span></p>
      <p>预测常规时间（不包括加时赛和点球）结束时两队是否至少进一球。如果两队都至少进一球，则结果为进球；反之，如果一方或双方均未进一球，则结果为无进球。</p>
      <p>示例：卡利亚里 - 佛罗伦萨：1-1。获胜结果：进球</p>
      <p>示例：卡利亚里 - 佛罗伦萨：2-0。获胜结果：无进球</p>
      <p><span style={{ color: "#ff0000" }}>上半场进球/无进球</span></p>
      <p>本投注仅考虑上半场，预测两队是否至少进一球。如果两队都至少进一球，则结果为进球；反之，如果其中一队或两队均未进一球，则结果为无进球。</p>
      <p>示例：卡利亚里 - 佛罗伦萨：1-1。获胜结果：进球</p>
      <p>示例：卡利亚里 - 佛罗伦萨：2-0。获胜结果：无进球</p>
      <p><span style={{ color: "#ff0000" }}>组合 1x2 + 大小</span></p>
      <p>投注在于确定最终结果和大小投注结果的正确组合</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 + 进球/无进球</span></p>
      <p>投注内容是确定最终结果以及常规时间（不包括加时赛和点球）结束时进球/无进球投注结果的正确组合。可能的投注结果包括：1 - 进球；1 - 无进球；X - 进球；X - 无进球；2 - 进球；2 - 无进球。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数</span></p>
      <p>您必须预测常规时间结束时两队进球总数是奇数还是偶数。</p>
      <p>示例：锡耶纳 - 亚特兰大：0-0。获胜结果：平局</p>
      <p>示例：锡耶纳 - 亚特兰大：2-1。获胜结果：单数</p>
      <p><span style={{ color: "#ff0000" }}>总目标</span></p>
      <p>它用于预测常规时间（即 90 分钟加上伤停补时）结束时比赛的进球数，选择以下选项之一：0；1；2；3；4；&gt;4。</p>
      <p>结果 &gt; 4 包括目标总和大于 4 的所有结果。</p>
      <p>示例：都灵 - 雷吉纳 0-0 获胜结果：0</p>
      <p>示例：都灵 - 雷吉纳 1-0 获胜结果：1</p>
      <p>示例：都灵 - 雷吉纳 1-1 获胜结果：2</p>
      <p>示例：都灵 - 雷吉纳 2-1 获胜结果：3</p>
      <p>示例：都灵 - 雷吉纳 2-2 获胜结果：4</p>
      <p><span style={{ color: "#ff0000" }}>上半场结果 1X2</span></p>
      <p>您必须根据以下方案预测上半场结束时（即第 45 分钟加上任何伤停补时）的 1X2 标志：</p>
      <p>上半场结束时签1，主队获胜；</p>
      <p>上半场结束时 X 标志表示两队打平；</p>
      <p>上半场结束时签2，客队获胜。</p>
      <p><span style={{ color: "#ff0000" }}>部分上半场/决赛</span></p>
      <p>您必须预测上半场的结果以及比赛的最终结果。</p>
      <p>9 种可能的结果如下：</p>
      <p>上半场结束时比分是 1-1，并且比赛结束时主队领先；</p>
      <p>1-X 上半场结束主队领先，最终结果为平局；</p>
      <p>上半场结束主队1-2领先，最终客队获胜；</p>
      <p>上半场结束时X-1为平局，最终结果为主队胜利；</p>
      <p>上半场结束时 XX 分，比赛结束时结果为平局；</p>
      <p>上半场结束时 X-2 为平局，最终结果为客队获胜；</p>
      <p>上半场结束客队2-1领先，最终结果为主队胜利；</p>
      <p>2-X 上半场结束时客队领先，最终结果为平局；</p>
      <p>上半场结束时比分是 2-2，全场比赛结束时客队领先。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 让分盘</span></p>
      <p>投注包括在常规时间（包括任何伤停补时）结束时预测比赛结果，提供 1X2 结果，并在比赛结束时计算特许经营商提前输入的进球让分。</p>
      <p>示例</p>
      <p>尤文图斯-恩波利1X2让分</p>
      <p>尤文图斯让一球</p>
      <p>尤文图斯以 2 个或更多净胜球获胜（2-0、3-0、3-1、4-0 等。获胜结果：1</p>
      <p>尤文图斯以1个净胜球获胜（1-0、2-1、3-2、4-3等）。获胜结果：X</p>
      <p>恩波利平局或获胜（0-0、1-1、0-1、0-2 等）。获胜结果：2</p>
      <p><span style={{ color: "#ff0000" }}>进球 - 主队/客队 - 是/否</span></p>
      <p>该投注预测一支球队在特定比赛结束时（不包括加时赛）是否会至少进一球。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>精确结果</span></p>
      <p>您必须预测常规时间、90 分钟加上任何伤停补时结束时比赛的准确结果（“其他”选项包括列表中未出现的任何结果）。</p>
      <p><span style={{ color: "#ff0000" }}>精确结果“上半场”</span></p>
      <p>投注内容为预测某场比赛上半场结束时的结果。可能的结果是：</p>
      <p>0-0；0-1；0-2；1-2；1-0；2-0；2-1；1-1；2-2；更多.</p>
      <p><span style={{ color: "#ff0000" }}>获胜者为 0 – 是/否</span></p>
      <p>投注内容是确定在特定比赛的常规时间结束时（不包括加时赛和点球），所预测的球队是否会取得胜利，同时对方球队是否会得分。</p>
      <p><span style={{ color: "#ff0000" }}>第一个进球的分钟</span></p>
      <p>此投注预测比赛首个进球将在哪个时间段出现。投注包含6个对应时间段的事件以及1个无进球事件。</p>
      <p>可能的结果（分钟范围）：</p>
      <p>0 - 15</p>
      <p>16 - 30</p>
      <p>31 - 上半场结束</p>
      <p>46 - 60</p>
      <p>61 - 75</p>
      <p>76 - 游戏结束</p>
      <p>没有目标</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球 2°时间</span></p>
      <p>本投注仅预测下半场双方球队是否得分。投注结果以下半场结束时（包括伤停补时）的结果为准，且仅与下半场的部分结果相关。</p>
      <p><span style={{ color: "#ff0000" }}>进球最多的半场</span></p>
      <p>投注内容是比较比赛中的进球数。选择“1”符号，您预测上半场的进球数将大于下半场的进球数。选择“X”符号，您预测上半场的进球数将等于下半场的进球数。选择“2”符号，您预测上半场的进球数将少于下半场的进球数。</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球特辑</span></p>
      <p>本投注根据进球/无进球规则，预测上半场进球/无进球和下半场进球/无进球投注结果的正确组合。共有四种可预测结果。</p>
      <p><span style={{ color: "#ff0000" }}>部分/最终正确结果</span></p>
      <p>您必须同时预测上半场和比赛结束时的准确结果（不包括加时赛和任何点球）。列表中显示的第二个结果与决赛有关。</p>
      <p><span style={{ color: "#ff0000" }}>精确结果 10 个结果 下半场</span></p>
      <p>本投注通过从已提供的结果中选择，预测下半场比赛的准确结果。投注有效结果为下半场结束时（加上恢复时间）的结果，且仅与下半场的部分结果相关。</p>
      <p><span style={{ color: "#ff0000" }}>单/偶数庄家</span></p>
      <p>您必须预测主队进球数是单数还是双数。投注以常规时间计算，包括伤停补时。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数客人</span></p>
      <p>您必须预测客队进球数是单数还是双数。投注以常规时间计算，包括伤停补时。</p>
      <p><span style={{ color: "#ff0000" }}>上半场单/双</span></p>
      <p>您必须预测上半场（45分钟，包括伤停补时）两队进球总数是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>下半场单/双</span></p>
      <p>您必须预测两队在下半场（45分钟，包括伤停补时）的进球总数是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>上半场进球总数</span></p>
      <p>您必须预测上半场（45分钟，包括伤停补时）以下结果中的准确进球数：0/1/2/2+。</p>
      <p><span style={{ color: "#ff0000" }}>下半场进球总数</span></p>
      <p>您必须预测下半场（45分钟，包括伤停补时）以下结果中的准确进球数：0/1/2/2+。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 上半场让分盘</span></p>
      <p>您必须预测上半场比赛的结果，并考虑两队中一队的让分。此投注仅与上半场结束时的结果相关，包括伤停补时。</p>
      <p><span style={{ color: "#ff0000" }}>主场目标总和</span></p>
      <p>您必须预测主队在0/1/2/2+比赛结果之间的准确进球数。投注以常规时间计算，包括任何伤停补时。</p>
      <p><span style={{ color: "#ff0000" }}>客场进球总数</span></p>
      <p>您必须预测客队在0/1/2/2+比赛结果之间的准确进球数。投注以常规时间计算，包括任何伤停补时。</p>
      <p><span style={{ color: "#ff0000" }}>两半场均超过 1.5</span></p>
      <p>您必须预测比赛上下半场是否都会至少进两球。结果有两种：是（上下半场至少进两球）和否（上下半场均未进两球）。两个半场必须独立考虑。例如：如果上半场结束时比分是 3-0，最终结果为 3-1，则意味着只有上半场至少进了两球，因为下半场的部分结果为 0-1，因此在这种情况下正确的结果为“否”。</p>
      <p><span style={{ color: "#ff0000" }}>两半均低于 1.5</span></p>
      <p>您需要预测比赛上下半场进球数是否都会少于两个。结果有两种：是（上下半场进球数均少于两个）和否（上下半场进球数均不少于两个）。上下半场必须独立考虑。例如：如果上半场结束时比分是 1-0，最终结果为 2-1，则意味着只有上半场进球数少于两个，因为下半场的部分比分是 1-1。</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球 + 未进球/进球 2.5</span></p>
      <p>投注内容为确定常规时间（不包括加时赛和点球）结束时进球/无进球以及大于/小于 2.5 的投注结果的正确组合。可能的结果是：进球 + 小于 2.5；无进球 + 大于 2.5；无进球 + 小于 2.5；进球 + 大于 2.5。</p>
      <p><span style={{ color: "#ff0000" }}>MG 上半场 &ndash; 下半场 </span></p>
      <p>您必须仅以比赛上半场为参考，预测两队进球总数，以及仅以比赛下半场为参考，预测两队进球总数。</p>
      <p><span style={{ color: "#ff0000" }}> MG 上半场 - 决赛</span></p>
      <p>您必须预测仅参考上半场两队进球总数，以及整场比赛两队进球总数。</p>
      <p><span style={{ color: "#ff0000" }}>1X 双倍机会组合 + 多目标</span></p>
      <p>投注同时预测比赛（不包括加时赛和点球）是否以 1X 结束以及两队进球总数是多少</p>
      <p><span style={{ color: "#ff0000" }}>双重机会组合 X2 + 多目标</span></p>
      <p>投注同时预测比赛结果（不包括加时赛和点球）是 X 还是 2，以及两队进球总数是多少</p>
      <p><span style={{ color: "#ff0000" }}>双重机会组合 12 + 多目标</span></p>
      <p>投注同时预测比赛结果（不包括加时赛和点球）是 1 分还是 2 分，以及两队进球总数是多少</p>
      <p><span style={{ color: "#ff0000" }}>主队上半场以零比分获胜</span></p>
      <p>投注内容是确定在比赛中，主队是否将在上半场结束时领先，同时对方球队是否不会得分。</p>
      <p>此投注仅指比赛的上半场。</p>
      <p><span style={{ color: "#ff0000" }}>客队上半场以零比零获胜</span></p>
      <p>投注内容是确定在比赛中，客队是否将在上半场结束时领先，同时对方球队是否不会得分。</p>
      <p>此投注仅指比赛的上半场。</p>
      <p><span style={{ color: "#ff0000" }}>下半场主场以 0 比 0 获胜</span></p>
      <p>投注内容是确定在比赛中主队是否领先，同时对方球队是否不会得分。</p>
      <p>此投注仅适用于比赛的下半场。</p>
      <p><span style={{ color: "#ff0000" }}>客队下半场以零比分获胜</span></p>
      <p>投注内容是确定在比赛中，客队是否领先，同时对方球队是否不会得分。</p>
      <p>此投注仅适用于比赛的下半场。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 15分钟</span></p>
      <p>本投注预测赛事前15分钟结束时的结果。可能的结果是1（主队占优）、X（平局）和2（客队占优）。15:01分钟之后的进球将不参与投注。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 30分钟</span></p>
      <p>本投注预测赛事前30分钟结束时的结果。可能的结果包括1（主队占优）、X（平局）和2（客队占优）。第30分钟01分之后的进球将不参与投注。</p>
      <p><span style={{ color: "#ff0000" }}>第一张卡</span></p>
      <p>您需要预测哪支球队将在常规时间内收到第一张黄牌或红牌。结果有三种可能：第一队、第二队和无人（如果无人收到牌，则为获胜选项）。任何不在场上球员（例如，教练、替补球员或已被替换的球员）的牌将不计入结果计算。</p>
      <p><span style={{ color: "#ff0000" }}>最后一张牌</span></p>
      <p>您需要预测哪支球队将在常规时间内收到最后一张黄牌或红牌。结果有三种可能：1队、2队和无人（如果无人收到牌，则为获胜选项）。任何不在场上球员（例如，教练、替补球员或已被替换的球员）的牌将不计入结果计算。</p>
      <p><span style={{ color: "#ff0000" }}>大小牌（仅限常规）</span></p>
      <p>您必须预测在所讨论的比赛中（不包括加时赛和点球），两队所出的牌（黄牌或红牌）总数是低于（低于）还是高于（高于）提供的让分。</p>
      <p>算牌过程如下：</p>
      <p>每张黄牌算1张；</p>
      <p>每张红牌值 2；</p>
      <p>一名球员的累计分不得超过 3 分（典型的双重警告，随后被驱逐出场）。</p>
      <p><br /> </p>
      <p>替补席上的球员、已经被替换下的球员、比赛结束后、教练或技术人员所出的牌不用于投注目的。</p>
      <p><span style={{ color: "#ff0000" }}>大小主场卡（仅限常规）</span></p>
      <p>您必须预测在所讨论的比赛中（不包括加时赛和点球），主队所出的牌（黄牌或红牌）总数是低于（低于）还是高于（高于）所提供的让分。</p>
      <p>算牌过程如下：</p>
      <p>每张黄牌算1张；</p>
      <p>每张红牌值 2；</p>
      <p>一名球员的累计分不得超过 3 分（典型的双重警告，随后被驱逐出场）。</p>
      <p>替补席上的球员、已经被替换下的球员、比赛结束后、教练或技术人员所出的牌不用于投注目的。</p>
      <p><span style={{ color: "#ff0000" }}>大小牌嘉宾（仅限常规）</span></p>
      <p>您必须预测在所讨论的比赛中（不包括加时赛和点球），客队所出的牌（黄牌或红牌）总数是低于（低于）还是高于（高于）提供的让分。</p>
      <p>算牌过程如下：</p>
      <p>每张黄牌算1张；</p>
      <p>每张红牌值 2；</p>
      <p>一名球员的累计分不得超过 3 分（典型的双重警告，随后被驱逐出场）。</p>
      <p>替补席上的球员、已经被替换下的球员、比赛结束后、教练或技术人员所出的牌不用于投注目的。</p>
      <p><span style={{ color: "#ff0000" }}>上半场大小牌</span></p>
      <p>您必须预测，仅考虑比赛的上半场，两队所出的牌（黄牌或红牌）总数是低于（低于）还是高于（高于）提供的让分。</p>
      <p>算牌过程如下：</p>
      <p>每张黄牌算1张；</p>
      <p>每张红牌值 2；</p>
      <p>一名球员的累计分不得超过 3 分（典型的双重警告，随后被驱逐出场）。</p>
      <p>替补席上的球员、已经被替换下的球员、比赛结束后、教练或技术人员所出的牌不用于投注目的。</p>
      <p><span style={{ color: "#ff0000" }}>罚牌总数（赛前和现场）</span></p>
      <p>投注在于确定牌的总数，仅考虑比赛的常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>开除是/否</span></p>
      <p>您必须预测比赛期间（常规时间和加时赛）是否会出示红牌。此投注仅针对场上球员。因此，替补球员、教练、经理和技术人员的任何红牌均不参与投注。比赛结束后出示的任何红牌也不参与投注。</p>
      <p><span style={{ color: "#ff0000" }}>惩罚是/否</span></p>
      <p>您必须预测在常规时间和加时赛中是否会判罚点球。</p>
      <p><span style={{ color: "#ff0000" }}>控球率 - 1X2</span></p>
      <p>投注内容是确定在指定赛事（包括加时赛和伤停补时）结束时，哪支球队的控球率最高。符号 1 表示预测第一支球队的控球率最高，符号 2 表示预测第二支球队的控球率最高，符号 X 表示两队控球率均等。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 卡（仅限监管）</span></p>
      <p>您必须预测在参考比赛中哪支球队在经典的 1X2 格式中记录的黄牌和红牌数量最多，不包括加时赛和点球。</p>
      <p>算牌过程如下：</p>
      <p>每张黄牌算1张；</p>
      <p>每张红牌值 2；</p>
      <p>一名球员的累计分不得超过 3 分（典型的双重警告，随后被驱逐出场）。</p>
      <p>替补席上的球员、已经被替换下的球员、比赛结束后、教练或技术人员所出的牌不用于投注目的。</p>
      <p><span style={{ color: "#ff0000" }}>卡片组总数</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注内容为确定某一赛事结束时各组别的牌张总数。本投注仅指常规时间，不包括加时赛和罚时赛。</span></span></span></p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>1X2 角球</span></p>
      <p>您需要预测比赛中哪支球队将获得最多角球（不包括加时赛）。结果有三种可能：1（主队获得最多角球）、2（客队获得最多角球）和 X（两队获得相同数量的角球）。</p>
      <p><span style={{ color: "#ff0000" }}>上半场 1X2 角球</span></p>
      <p>您必须预测哪支球队将获得最多的角球数，且仅考虑比赛的上半场。</p>
      <p>共有 3 种可能的结果：1（主队获得最多角球）、2（客队获得最多角球）和 X（两队获得相同数量的角球）。</p>
      <p>如果角球被重新发球（例如由于禁区内犯规），则出于投注目的，该角球将计为一个角球。</p>
      <p>已获判但未实际执行的角球不计算在内。</p>
      <p><span style={{ color: "#ff0000" }}>角球大小（2 个选择）</span></p>
      <p>您必须预测比赛期间角球总数是高于（大于）还是低于（小于）提供的让分盘口。此投注仅考虑常规时间，不包括加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>角球大小（3 个选项）</span></p>
      <p>您必须预测比赛期间角球总数是大于（大于）、小于（小于）还是等于（正好等于）所提供的让分。此投注仅考虑常规时间，不包括加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>让分角球 (1X2)</span></p>
      <p>您需要预测哪支球队将在比赛中获得最多角球（不包括加时赛），并考虑投注中指定的让分。负数让分表示主队获胜，正数让分表示客队获胜。提供三种可能的结果：1（在最终角球结果上减去或加上让分，主队获得最多角球），2（在最终角球结果上减去或加上让分，客队获得最多角球）和 X（在最终角球结果上减去或加上让分，两队获得相同数量的角球）。</p>
      <p><span style={{ color: "#ff0000" }}>奇数/偶数角球</span></p>
      <p>您必须预测比赛期间角球总数是单数还是双数。此投注仅考虑常规时间，不包括加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>上半场单/双角球</span></p>
      <p>您必须仅考虑比赛的上半场，预测两队角球总数是奇数还是偶数。</p>
      <p>如果角球被重新发球（例如由于禁区内犯规），则出于投注目的，该角球将计为一个角球。</p>
      <p>已获判但未实际执行的角球不计算在内。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>主队角球大小</span></p>
      <p>您必须预测主队在比赛中的角球总数是高于（大于）还是低于（小于）所提供的让分盘口。投注仅考虑常规时间，不包括加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>上半场主队角球大小</span></p>
      <p>您必须仅考虑比赛的上半场，预测主队角球总数是低于（低于）还是高于（高于）所提供的让分。</p>
      <p>如果角球被重新发球（例如由于禁区内犯规），则出于投注目的，该角球将计为一个角球。</p>
      <p>已获判但未实际执行的角球不计算在内。</p>
      <p><span style={{ color: "#ff0000" }}>客队上半场角球大小</span></p>
      <p>您必须仅考虑比赛的上半场，预测客队角球总数是低于（低于）还是高于（高于）提供的让分。</p>
      <p>如果角球被重新发球（例如由于禁区内犯规），则出于投注目的，该角球将计为一个角球。</p>
      <p>已获判但未实际执行的角球不计算在内。</p>
      <p><span style={{ color: "#ff0000" }}>客场角球大小</span></p>
      <p>您必须预测客队在比赛中的角球总数是高于（大于）还是低于（小于）所提供的让分盘口。此投注仅考虑常规时间，不包括加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>角球总数</span></p>
      <p>投注内容为确定特定赛事结束时的角球总数。此投注仅指常规时间，不包括加时赛和点球。</p>
      <p>提出的假设是：</p>
      <p>6-8</p>
      <p>9-11</p>
      <p>12-14</p>
      <p>超过 14</p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 主场 O/U + 客场 O/U</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>本投注用于预测比赛（不包括加时赛和点球赛）中“U/O 角球 1 队”（其中 1 队表示主队）和“U/O 角球 2 队”（其中 2 队表示客队）两个投注结果的正确组合。共有 4 种可能的结果：- “小 + 小”：预测 1 队和2 队开出的角球数均低于预设值。 - “大小”：预测1队角球数低于预定值，而2队角球数高于预定值。 - “大小”：预测1队角球数高于预定值，而2队角球数低于预定值。 - “大小”：预测1队和2队角球数均高于预定值。只有实际角球时才会被计入，单独的分配对于确认投注无效。就报告目的以及所有其他情况而言，现行相关法律法规、规则以及参考赛事组织者发布的官方数据均有效。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角球 - 1X2 + O/U</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>本投注用于预测比赛（不包括加时赛和点球）中“1X2 角球”和“U/O 角球”投注结果的正确组合。共有 6 种可能的结果： - “1 + 小于”：预测主队的角球数将多于客队的角球数，且比赛的角球总数将小于预先设定的值。 - “1 + 大于”：预测主队的角球数将多于客队的角球数，且比赛的角球总数将高于预先设定的值。 - “X + 小于”：预测两队角球数相同，且全场比赛角球总数低于预定值。 - “X + 大于”：预测两队角球数相同，且全场比赛角球总数高于预定值。 - “2 + 小于”：预测客队角球数多于主队，且全场比赛角球总数低于预定值。 - “2 + 大于”：预测客队角球数多于主队，且全场比赛角球总数高于预定值。 角球仅在实际发出时才计算在内，单独的分配对于确认投注无效。为了报告的目的以及所有其他情况，有关此事的现行立法、法规和参考活动组织者发布的官方数据将有效。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角度 - 高/宽</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>本投注预测两队中哪支球队在上半场角球数最多，以及比赛结束时哪支球队角球数最多。本投注仅参考常规时间，不包括加时赛和点球赛。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角度 - O/U 1T + O/U 2T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>本投注预测上半场角球总数是高于（大）还是低于（小）所提供的让分盘口，以及全场比赛角球总数是高于（大）还是低于（小）所提供的让分盘口。本投注仅考虑常规时间，不包括加时赛和点球。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角度 - 房屋整体</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>此投注用于确定特定赛事结束时主队所获角球总数。此投注仅指常规时间，不包括加时赛和点球。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角落 - 客人总数</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>此投注用于确定特定赛事结束时客队所获角球总数。此投注仅指常规时间，不包括加时赛和点球。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角度 - 房屋总面积 1T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注内容为确定主队在特定赛事上半场结束时所获角球的总数。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角度 - 房屋总面积 2T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注内容为确定主队在特定赛事下半场所获角球的总数。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 客人总数 1T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注内容为确定客队在特定赛事上半场结束时所获得的角球总数。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 客人总数 2T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注内容为确定客队在特定赛事下半场所获角球总数</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角组数量</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注内容为确定特定赛事结束时各小组的角球总数。此投注仅参考常规时间，不包括加时赛和点球赛。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>AX 角球比赛</span></p>
      <p>您必须预测哪支球队将在比赛中率先获得 X 个角球（不包括加时赛和点球）。</p>
      <p>角球数 X 将始终在投注说明中显示。</p>
      <p>有 3 种可能的结果：</p>
      <p>球队 1：主队将比客队先获得 X 个角球；</p>
      <p>Team2：客队将比主队提前获得 X 个角球；</p>
      <p>均不：两队均不会获得指定数量的角球。</p>
      <p>如果角球被重新发球（例如由于禁区内犯规），则出于投注目的，该角球将计为一个角球。</p>
      <p>已获判但未实际执行的角球不计算在内。</p>
      <p><span style={{ color: "#ff0000" }}>机会组合</span></p>
      <p><span style={{ color: "#ff0000" }}>进球超过 2.5</span></p>
      <p>投注内容是预测两个选择（进球或超过 2.5）中至少一个是否会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>是：比赛将以进球（两队至少进一球）或大于 2.5（两队进球总数大于两球）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛将结束，因此无进球（两队中至少有一支球队在比赛中未得分）和小于 2.5（两队总进球数少于三个球）。</p>
      <p><span style={{ color: "#ff0000" }}>进球或低于 2.5</span></p>
      <p>投注内容是预测两个选择（进球或低于 2.5）中至少一个是否会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以进球（两队至少进一球）或小于 2.5（两队总进球数少于三个）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛将结束，因此无进球（两队中至少有一支在比赛中没有得分）和超过 2.5（两队总进球数大于两个进球）。</p>
      <p><span style={{ color: "#ff0000" }}>无进球或超过 2.5</span></p>
      <p>投注内容是预测两个选择（无进球或超过 2.5）中至少一个会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以无进球（两队中至少有一支球队在比赛中未得分）或超过 2.5（两队进球总数大于两个球）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛将结束，因此进球（两队至少进一球）和小于 2.5（两队进球总数少于三个球）。</p>
      <p><span style={{ color: "#ff0000" }}>无进球或低于 2.5</span></p>
      <p>投注内容是预测两个选择（无进球或低于 2.5）中至少一个会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以无进球（两队中至少有一支球队在比赛中未得分）或小于 2.5（两队进球总数少于三个球）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛将结束，因此进球（两队至少进一球）和超过 2.5（两队进球总数大于两球）。</p>
      <p><span style={{ color: "#ff0000" }}>主队获胜或进球</span></p>
      <p>投注内容是预测两个选择（1 或 GOAL）中至少有一个会成为比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 1（主队赢得比赛）或 GOAL（两队至少进一球）或两种结果结束。</p>
      <p>否：在所有其他情况下比赛将结束，因此 x2（主队不会获胜）和无进球（两支球队中至少有一支在比赛中没有得分）。</p>
      <p><span style={{ color: "#ff0000" }}>主队获胜或无进球</span></p>
      <p>投注内容是预测两个选择（1 或 NOGOAL）中至少一个是否会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 1（主队赢得比赛）或 NOGOAL（两队中至少有一支在比赛中未得分）或两种结果结束。</p>
      <p>否：在所有其他情况下比赛都会结束，因此 x2（主队不会获胜）和 GOAL（两队都将至少进一球）。</p>
      <p><span style={{ color: "#ff0000" }}>平局或进球</span></p>
      <p>投注内容是预测两个选择（X 或 GOAL）中至少有一个会成为比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 X（比赛将以平局结束）或 GOAL（两队均至少进一球）或两种结果结束。</p>
      <p>否：在所有其他情况下比赛都会结束，因此 12（比赛不会结束 X）和无进球（两支球队中至少有一支在比赛中没有得分）。</p>
      <p><span style={{ color: "#ff0000" }}>平局或无进球</span></p>
      <p>投注内容是预测两个选择（X 或 NOGOAL）中至少一个是否会成为比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 X 结束（比赛将以平局结束）或无进球（两支球队中至少有一支在比赛中没有得分）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛都会结束，因此 12（比赛不会结束 X）和 GOAL（两队都将至少进一球）</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或进球</span></p>
      <p>投注内容是预测两个选择（2 或 GOAL）中至少一个是否会成为比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 2（客队赢得比赛）或 GOAL（两队至少进一球）或两种结果结束。</p>
      <p>否：在所有其他情况下比赛将结束，因此 1X（客队不会获胜）和 NOGOAL（两支球队中至少有一支在比赛中没有得分）。</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或无进球</span></p>
      <p>投注内容是预测两个选择（2 或 NOGOAL）中至少一个是否会成为比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 2（客队赢得比赛）或 NOGOAL（两队中至少有一支在比赛中未得分）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛都会结束，因此 1X（客队不会获胜）和 GOAL（两队都将至少进一球）。</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或无进球</span></p>
      <p>投注内容是预测两个选择（2 或 NOGOAL）中至少一个是否会成为比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 2（客队赢得比赛）或 NOGOAL（两队中至少有一支在比赛中未得分）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛都会结束，因此 1X（客队不会获胜）和 GOAL（两队都将至少进一球）。</p>
      <p><span style={{ color: "#ff0000" }}>主队获胜或超过 2.5</span></p>
      <p>投注内容是预测两个选择（1 或超过 2.5）中至少一个是否会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 1（主队获胜）或 OVER 2.5（两队至少进一球）或两种结果结束。</p>
      <p>否：在所有其他情况下比赛都会结束，因此 x2（主队不会获胜）和 UNDER 2.5（两队总进球数少于三个球）</p>
      <p><span style={{ color: "#ff0000" }}>主队获胜或低于 2.5</span></p>
      <p>投注内容是预测两个选择（1 或低于 2.5）中至少一个是否会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 1（主队获胜）或小于 2.5（两队总进球数少于三个）或两种结果结束。</p>
      <p>否：在所有其他情况下比赛都会结束，因此 X2（主队不会获胜）和 OVER 2.5（两队总进球数将大于两个进球）</p>
      <p><span style={{ color: "#ff0000" }}>平局或大于 2.5</span></p>
      <p>投注内容是预测两个选择（X 或 OVER 2.5）中至少一个是否会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 X（比赛将以平局结束）或 OVER 2.5（两队之间的总进球数将大于两个进球）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛将结束，因此 12（比赛将不会结束 X）和低于 2.5（两队总进球数少于三个球）。</p>
      <p><span style={{ color: "#ff0000" }}>平局或低于 2.5</span></p>
      <p>投注内容是预测两个选择（X 或 UNDER 2.5）中至少一个是否会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 X（比赛将以平局结束）或 UNDER 2.5（两队的总进球数少于三个球）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛都会结束，因此 12（比赛不会结束 X）和超过 2.5（两队进球总数将大于两个进球）。</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或超过 2.5</span></p>
      <p>投注内容是预测两个选择（2 或 OVER 2.5）中至少一个是否会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 2（客队赢得比赛）或大于 2.5（两队进球总数大于两个）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛将结束，因此 1X（客队不会获胜）和 UNDER 2.5（两队总进球数少于三个球）。</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或低于 2.5</span></p>
      <p>投注内容是预测两个选择（2 或低于 2.5）中是否有至少一个会成为所讨论比赛的获胜者，不包括加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：比赛将以 2（客队赢得比赛）或小于 2.5（两队总进球数少于三个球）或两种结果结束。</p>
      <p>否：在所有其他情况下，比赛都将结束，因此 1X（客队不会获胜）和 OVER 2.5（两队进球总数将高于两个进球）。</p>
      <p><span style={{ color: "#ff0000" }}>部分/最终组合 + 小于/大于</span></p>
      <p>在参考比赛中，您必须同时预测上半场的结果和比赛的最终结果，以及两队的进球总数是低于（低于）还是高于（高于）参考让分</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 1 或高于或不得分</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会成为比赛的赢家；所有结果均符合规则，不包括加时赛和任何点球。结果包括：1. 是：比赛将以 1（主队获胜）或 大（比赛总进球数将高于附加信息中指定的阈值）或 NG（两队中至少有一支不会进球）或三种结果全部结束。2. 否：在所有其他情况下，比赛都将结束，因此 X2、小和进球</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 1 或以上或 DD</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会胜出；所有结果均符合规则，不包括加时赛和任何点球。结果包括：1. 是：比赛将以 1（主队获胜）或 大（比赛总进球数将高于附加信息中指定的阈值）或 GG（两队均至少进一球）或三种结果全部结束。2. 否：在所有其他情况下，比赛都将结束，因此为 X2、小和无进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重可能性 1 或以下或 NG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会成为比赛的胜方；所有结果均符合规则，不包括加时赛和任何点球。结果包括：1. 是：比赛将以 1（主队获胜）或 小于（比赛总进球数低于附加信息中指定的阈值）或 NG（两队中至少有一支球队不会进球）或三种结果全部结束。2. 否：在所有其他情况下，比赛都将结束，因此 X2、大于和进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 1 或 UNDER 或 GG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会成为比赛的胜者；所有结果均符合规则，不包括加时赛和任何点球。结果包括：1. 是：比赛将以 1（主队获胜）或 小于（比赛总进球数低于附加信息中指定的阈值）或 GG（两队均至少进一球）或三种结果全部结束。2. 否：在所有其他情况下，比赛都将结束，因此为 X2、大于和无进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 X 或 OVER 或 NG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会成为比赛的赢家；所有结果均符合规则，不包括加时赛和任何点球。结果包括：1. 是：比赛将以 X（平局）或 大（比赛总进球数将高于附加信息中指定的阈值）或 NG（两队中至少有一支不会进球）或三种结果全部结束。2. 否：在所有其他情况下，比赛都将结束，因此 12 和 小于 以及 进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 X 或 OVER 或 GG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会成为比赛的赢家；所有结果均符合规则，不包括加时赛和任何点球。结果包括：1. 是：比赛将以 X（平局）或 大（比赛总进球数将高于附加信息中指定的阈值）或 GG（两队均至少进一球）或三种结果全部结束。2. 否：在所有其他情况下，比赛都将结束，因此结果为 12 或以下且无进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重可能性 X 或 UNDER 或 NG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会成为比赛的赢家；所有结果均符合规则，不包括加时赛和任何点球。结果包括：1. 是：比赛将以 X（平局）或 大（比赛总进球数将高于附加信息中指定的阈值）或 GG（两队均至少进一球）或三种结果全部结束。2. 否：在所有其他情况下，比赛都将结束，因此结果为 12 或以下且无进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重可能性 X 或 UNDER 或 GG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会成为比赛的赢家；所有结果均符合规则，不包括加时赛和任何点球。结果包括：1. 是：比赛将以 X（平局）或小（比赛总进球数少于 1.5）或 GG（两队均至少进一球）或三种结果全部结束。2. 否：在所有其他情况下，比赛都将结束，因此结果为 12 或大或无进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 2 或以上或 NG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会胜出；所有结果均符合规则，不包括加时赛和任何点球。结果包括：3. 是：比赛将以 2（客队获胜）或 大（比赛总进球数将高于附加信息中指定的阈值）或 NG（两队中至少有一支不会进球）或三种结果全部结束。4. 否：在所有其他情况下，比赛都将结束，因此 1X、小和进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 2 或以上或 GG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会在相关比赛中获胜；所有结果均在常规时间内（不包括加时赛和任何点球）确定。结果包括：3. 是：比赛将以 2（客队获胜）或 大（比赛总进球数将高于附加信息中指定的阈值）或 GG（两队均至少进一球）或三种结果全部结束。4. 否：在所有其他情况下，比赛都将结束，因此结果为 1X、小和无进球。</p>
      <p><span style={{ color: "#ff0000" }}>三重可能性 2 或以下或 NG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会成为比赛的胜方；所有结果均符合规则，不包括加时赛和任何点球。结果包括：3. 是：比赛将以 2（客队获胜）或 小于（比赛总进球数低于附加信息中指定的阈值）或 NG（两队中至少有一支球队不会进球）或三种结果全部结束。4. 否：在所有其他情况下，比赛都将结束，因此 1X 和 大于 和 进球</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 2 或 UNDER 或 GG</span></p>
      <p>您必须预测投注说明中所示的三种结果中至少有一种会在相关比赛中获胜；所有结果均在常规时间内（不包括加时赛和任何点球）确定。结果包括：3. 是：比赛将以 2（客队获胜）或 小于（比赛总进球数少于 1.5）或 GG（两队均至少进一球）或三种结果全部结束。4. 否：在所有其他情况下，比赛都将结束，因此结果为 1X、大于和无进球。</p>
      <p><span style={{ color: "#ff0000" }}>裁判咨询 VAR 监控是/否</span></p>
      <p>您必须预测在本次比赛中，裁判是否会咨询（是）或不会咨询（否）。咨询是指裁判亲自前往场边监视器上查看比赛情况（“场上回放”）；投注时，仅通过耳机设备使用 VAR（“无声回放”）的情况不予考虑；如果出现“无声回放”，即裁判只是让 VAR 助理观看视频并相信他们的反应，则投注失败。投注时，所有加时赛均包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>锦标赛大小 – 单场比赛进球数：</span></p>
      <p>对于任何选定锦标赛的某一天，您必须预测所有预定比赛的总进球数是高于还是低于设定值。如果单场比赛暂停（无论暂停时的结果如何，且未在第二天晚上11:59前恢复比赛）或未开始（且未在第二天晚上11:59前开始比赛），则计入两个进球；如果进球数更高（从2开始），则该预测的投注将全额退还（赔率为1.00）。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>足球特辑和预览</span></span></p>
      <p><span style={{ color: "#ff0000" }}>警告是/否</span></p>
      <p>您必须预测在参考比赛中（不包括加时赛和点球）指定的球员是否会受到警告。</p>
      <p>直接开除不会被视为警告。</p>
      <p>替补席上的球员、已经被替换下的球员、比赛结束后、教练或技术人员所出的牌不用于投注目的。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果选定的球员没有参加比赛，对他的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>首次警告</span></p>
      <p>您必须预测哪位球员将在比赛中首先受到警告，不包括加时赛和点球。</p>
      <p>除了球员姓名之外，列表中还提供了以下结果：</p>
      <p>OTHER = 任何不在列表中的玩家</p>
      <p>无出示黄牌 = 常规时间内无球员出示黄牌</p>
      <p>如果公布名单中的球员没有上场，则对该球员的投注将被视为输掉，因此在这种情况下投注将不予退还。</p>
      <p>直接开除不会被视为警告。</p>
      <p>如果同时出现警告，则首先收到黄牌的球员将被视为首先受到警告。</p>
      <p>替补席上的球员、已经被替换下的球员、比赛结束后、教练或技术人员所出的牌不用于投注目的。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>射门</span></p>
      <p>您必须预测，除加时赛外，单个球员的射门总数是高于（大于）还是低于（小于）提供的让分。</p>
      <p>在此上下文中，“射正”的定义是指任何射入球门，或若未被守门员或最后一名球员拦截则本应入球的射门。击中球门柱或横梁的射门不算射正，除非符合上述要求。同样，被非最后一名球员拦截的射门也不算射正。</p>
      <p>仅当名单中的参考球员不参加比赛时，结果才会被视为无效。</p>
      <p>结果认证以活动组织者提供的官方数据以及 sofascore.com 上有关任何柱子和/或横杆的信息为准。</p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球队 1/球队 2 总射门数低于/高于</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您需要预测球队1（即投注说明中提到的第一支球队）的“总射门次数”（不包括加时赛）</span><span data-ccp-para="">，以及球队2（即投注说明中提到的第二支球队）的射门次数是否会低于（低于）或高于（高于）指定的让分。总射门次数是指所有射向对方球门的射门次数，无论它们是在球门“内”还是“外”。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>总射门数低于/高于</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您需要预测两队在比赛中（不包括加时赛）的“总射门次数”</span><span data-ccp-para="">是低于（低于）还是高于（高于）给定的让分。总射门次数是指所有射向对手球门的射门，无论它们是在球门“内”还是“外”。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>奇数/偶数总射门数</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您需要预测两队的总射门次数（</span><span data-ccp-para="">不包括加时赛</span><span data-ccp-para="">）是单数还是双数。0 为单数。总射门次数是指所有射向对方球门的射门，无论射门是在球门“内”还是“外”。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>协助</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测所选球员在比赛中（不包括加时赛）是否会有助攻。助攻是指直接传球，使队友得分。官方结果请仅参考赛事官方机构 (legaseriea.it) 的“总助攻”标题。如果球员未上场，则所选投注将被视为</span><span data-ccp-para="">无效</span><span data-ccp-para="">；如果该球员上场哪怕只有1分钟，投注也将被视为有效。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球员犯规次数</span></span></p>
      <p>您必须预测在指定比赛中，指定球员的犯规次数是否会超过指定值X。任何加时赛均不予计算。如果球员未参加比赛，投注将被退还。球员实际上场时，即使只上场了有限的时间，也视为参加了比赛。如果比赛未进行、暂停，且在任何情况下未按照规则规定的期限结束，且尚未取得投注所需的可证明结果，则投注将被退还。
        为了报告目的，参考赛事组织者发布的官方数据将有效，只有在没有后者的情况下，才会使用 SOFASCORE.COM 发布的资料。
        “犯规”指任何被裁判判定为违反比赛规则的违规行为，导致任意球或点球。越位不被视为犯规。如果比赛裁判员判罚了优势规则，并随后对球员进行了警告，则该比赛不计入该球员的总犯规次数。因此，必须判罚任意球或点球才能判定犯规。
      </p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>成功传球数低于/高于</span></span></p>
      <p><span data-ccp-para="">您必须预测在所讨论的比赛中（不包括加时赛）</span>&nbsp;<br /><span data-contrast="auto"><span data-ccp-para="">指定的球员是否会在所讨论的比赛中进球。完成传球的次数低于（低于）或</span><span data-ccp-para="">高于（高于）预先设定的值。</span></span>&nbsp;<br /><span data-contrast="auto"><span data-ccp-para="">如果某位球员未参加比赛（我们所说的参与，是指实际上场的球员），则该投注将被退还。</span></span>&nbsp;<br /><span data-contrast="auto"><span data-ccp-para="">如果某位球员参加了比赛，即使只参加了有限的一段时间，投注也被视为有效。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="">结果认证以活动主办方提供的官方数据为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>犯规数少于/超过</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测比赛中两支球队犯规总数（不包括加时赛）是低于（低于）还是高于（高于）给定的让分。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">为了便于报告，参考赛事组织者发布的规则和官方数据将作为依据。如果赛事官方网站上没有明确的数据，则将使用来自 sofascore.com 的数据。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>犯规数少于/超过</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测在指定比赛中（</span><span data-ccp-para="">不包括加时赛</span><span data-ccp-para="">指定球员的犯规次数是否会低于（低于）或高于（高于）预定值。如果指定球员未参加比赛，则投注将被退还。如果球员参加了比赛，即使只参加了有限的一段时间，投注也有效。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">为了便于报告，参考赛事组织者发布的规则和官方数据将作为依据。如果赛事官方网站上没有明确的数据，则将使用来自 sofascore.com 的数据。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>1x2 球员投篮</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">该投注根据传统的 1X2 方法预测比赛中（不包括加时赛）两名球员中哪一名的射门次数最多。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">在此上下文中，“射正”定义为任何射入球门的射门，或者如果没有被守门员或最后一个防守队员阻止的话本来就会射入球门的射门。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">除非符合上述要求，否则击中门柱或横梁的射门不算作射正。同样，被非最后一人位置的球员拦截的射门也不算作射正。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">仅当列表中的参考球员未参加比赛时，结果才会被视为</span><span data-ccp-para="">无效</span><span data-ccp-para="">。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者及 sofascore.com 提供的官方数据为准，以任何柱子及/或横杆信息为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球员黄牌和得分</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">本投注预测球员在比赛中是否会至少进一球并受到警告。如果出现这种情况，则“是”结果为赢。在所有其他情况下，“否”结果为赢。投注将在常规时间结束时确认。直接驱逐将不被视为警告。本投注仅针对场上球员；任何终场哨响后做出的处罚均不予考虑，</span><span data-ccp-para="">对已被替换的球员、替补球员、经理、教练和工作人员的处罚均不予考虑。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如指定球员未参加比赛，则投注将被退还。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">当球员实际上场时，即使上场时间有限，他也已参与比赛。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事主办方及sofascore.com官方提供的数据为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球员总射门数低于/高于</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测指定球员的&ldquo;总射门数&rdquo;是低于（低于）还是高于（高于）给定的点差。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">总射门次数是指所有射向对手球门的射门次数，无论射门是在球门“内”还是“外”。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">当球员实际上场时，即使上场时间有限，他也已参与比赛。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">仅当列表中的参考球员未参加比赛时，结果才会被视为</span><span data-ccp-para="">无效</span><span data-ccp-para="">。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事主办方及sofascore.com官方提供的数据为准。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注在常规时间结束时确认。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球员 X 助攻和得分</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">本投注预测球员在比赛中是否至少进一球并至少有一次助攻。如果结果为“是”，则投注结果为“否”。其他情况下，投注结果为“否”，则投注结果为“否”。常规时间结束时确认投注。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如指定球员未参加比赛，则投注将被退还。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">当球员实际上场时，即使上场时间有限，他也已参与比赛。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事主办方及sofascore.com官方提供的数据为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球员 X 得分或助攻</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">本投注预测球员在比赛中是否至少进一球或至少有一次助攻。如果出现这种情况，则结果为“是”即为获胜方。在其他情况下，结果为“否”即为获胜方。投注将在常规时间结束时确认。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如指定球员未参加比赛，则投注将被退还。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">当球员实际上场时，即使上场时间有限，他也已参与比赛。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事主办方及sofascore.com官方提供的数据为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>外线进球 是/否</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测在比赛期间（不包括加时赛），是否会出现禁区外进球。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果发生这种情况，则“是”结果将获胜。在所有其他情况下，“否”结果将获胜。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">规定进球必须在禁区外（禁区线除外）踢球。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，乌龙球将不被视为进球，因此将被视为失败结果。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>头球进球 是/否</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测在比赛期间（不包括加时赛）是否会出现头球进球。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果发生这种情况，则“是”结果将获胜。在所有其他情况下，“否”结果将获胜。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，乌龙球将不被视为进球，因此将被视为失败结果。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>恢复目标是</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测比赛下半场伤停补时阶段是否会至少出现一个进球。下半场伤停补时阶段的定义为从第90分钟01分（第91分钟）到裁判吹响终场哨的时间范围。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，乌龙球将不被视为进球，因此将被视为失败结果。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球队总射门数低于/高于</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测球队 1（即投注描述中提到的第一支球队）或球队 2（即投注描述中提到的第二支球队）的&ldquo;总射门数&rdquo;是低于（低于）还是高于（高于）指定的点差。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">总射门次数是指所有射向对手球门的射门次数，无论射门是在球门“内”还是“外”。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事主办方及sofascore.com官方提供的数据为准。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注在常规时间结束时确认。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球队射门次数少于/超过</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测球队 1（即投注描述中提到的第一支球队）或球队 2（即投注描述中提到的第二支球队）的&ldquo;射门次数&rdquo;是低于（低于）还是高于（高于）指定的点差。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">在此上下文中，“射正”定义为任何射入球门的射门，或者如果没有被守门员或最后一个防守队员阻止的话本来就会射入球门的射门。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">除非符合上述要求，否则击中门柱或横梁的射门不算作射正。同样，被非最后一人位置的球员拦截的射门也不算作射正。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事主办方及sofascore.com官方提供的数据为准。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注在常规时间结束时确认。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>控球率</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>1x2 控球</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">该投注根据传统的 1X2 方法预测两支球队中哪一支将在比赛中拥有最高的控球率。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为准。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注在常规时间结束时确认。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>U/O 球队控球率</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">此投注预测在参考比赛中，X 队的控球率是低于、等于（低于）还是高于（高于）预先设定的值。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">规定如果X队记录的控球率等于预先设定的限制，则“小于”结果将为获胜结果。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">为了报告的目的以及所有其他情况，有关此事的现行立法、法规以及参考活动组织者发布的官方数据均有效。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注在常规时间结束时确认。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>换人次数少于/超过</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">此投注预测两队在常规时间内（包括恢复时间，不包括加时赛）的换人总数是低于（结果低于）还是高于（结果高于）指定的阈值。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">报告以组织该活动的官方机构发布的内容为准。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>偶数/奇数扑救</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测指定的守门员/球员在比赛中的扑救次数是奇数还是偶数。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果某位球员未参加比赛（参加是指球员实际上场），则该投注将被退还。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果一名球员参加比赛，即使是在有限的时间内，投注也是有效的。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">为了报告的目的，参考活动组织者发布的规定和官方数据将有效。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注在常规时间结束时确认。</span></span></p>
      <p><span style={{ color: "#ff0000" }}>首个进球者</span></p>
      <p>您必须从预先定义的列表中预测在常规时间内率先进球的球员。</p>
      <p>如果某位特定球员未参加比赛（我们所说的参加，是指实际上场的球员），而该球员的最终进球是投注的对象，则该投注将被退还。</p>
      <p>如果一名球员在比赛中上场，只有当比分是 0-0 时才有效</p>
      <p><span style={{ color: "#ff0000" }}>最后一个标记</span></p>
      <p>您必须从预先定义的列表中预测在常规时间内打进最后一个球的球员。</p>
      <p>如果某位特定球员未参加比赛（我们所说的参加，是指实际上场的球员），而该球员的最终进球是投注的对象，则该投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>首个进球者 + 准确得分组合</span></p>
      <p>您必须预测哪位球员将率先进球以及比赛的确切结果。如果投注的最终进球球员未参加比赛（参与是指实际在场的球员），则该投注将被退还。</p>
      <p>如果所选球员虽然参加了比赛，但没有进球，则投注失败，即使该球员在第一个进球之前被替换下场。</p>
      <p>此投注仅计算常规时间，包括伤停补时，不包括加时赛和点球。投注以赛事描述中指定的比赛和球员为准。</p>
      <p>如果一名球员在比赛中上场，只有当比分是 0-0 时才有效</p>
      <p><span style={{ color: "#ff0000" }}>组合标记是/否 + 精确结果</span></p>
      <p>您必须预测比赛的准确结果，以及赛事描述中指定的球员是否至少进一球。投注仅计算常规时间，包括伤停补时，不包括加时赛和点球。</p>
      <p>如果在场的球员没有上场，针对该球员的投注将被退还。</p>
      <p>投注指的是赛事描述中指定的比赛，以及同一描述中指定的选手。</p>
      <p><span style={{ color: "#ff0000" }}>是/否匹配中的双倍</span></p>
      <p>您必须预测选定的球员是否会在比赛中至少进两个球。</p>
      <p>只有常规时间才被视为有效投注时间。</p>
      <p>如果所选球员未参加比赛，则投注金额将被退还。如果所选球员上场，即使上场时间有限，投注金额仍将有效。</p>
      <p><span style={{ color: "#ff0000" }}>是/否比赛中的帽子戏法</span></p>
      <p>您必须预测所选球员是否会在比赛中至少进三个球。此投注仅在常规时间有效。</p>
      <p>如果所选球员未参加比赛，则针对该球员的投注将被退还。如果所选球员上场，即使上场时间有限，针对其假设进球的投注也将被确认。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>组合首开纪录 + 最终结果 1X2</span></p>
      <p>您必须预测最终结果以及事件描述中指示的球员是否会进第一个球。</p>
      <p>投注仅计算常规时间，包括伤停补时，不包括加时赛和点球。</p>
      <p>如果投注的最终进球的球员未参加比赛（参加意味着球员实际上场），则该投注将被退还。</p>
      <p>如果一名球员在比赛中上场，只有当比分是 0-0 时才有效</p>
      <p><span style={{ color: "#ff0000" }}>组合得分 + 最终结果 1X2</span></p>
      <p>您必须预测比赛的最终结果以及事件描述中指示的球员是否会至少进一球。</p>
      <p>投注仅计算常规时间，包括伤停补时，不包括加时赛和点球。</p>
      <p>如果在场的球员没有上场，针对该球员的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者最高得分手活动</span></p>
      <p>投注内容是预测比赛结束时在常规时间和加时赛（包括伤停补时，不包括半场后的点球）中进球最多的球员。</p>
      <p>其他项目（如果存在）包括列表中未明确指出的所有结果。</p>
      <p>如果多名球员获得最多进球数，则赔率将被平分。</p>
      <p>如果梅西与另一位球员一起夺得排名的赔率为 2.50，则 2.50 的赔率将除以 2.. 2.50/2=1.25</p>
      <p>如果有 3 名选手赢得排名，赔率将除以 3...2.50/3= 0.83...等等</p>
      <p><br /> </p>
      <p>需要注意的是，报告的有效分类仅与进球有关，不包括加时赛后的点球。</p>
      <p>官方进球数以赛事官方机构公布的信息为准</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于越位</span></p>
      <p>您必须预测在比赛中两队的越位总数是高于（大于）还是低于（小于）提供的让分。</p>
      <p>当对方球队获得任意球并主罚任意球时，如果球员被判处于越位位置，则视为越位。投注结算时，优势不予考虑：必须判罚并主罚任意球。如果在上半场或比赛结束时，判罚越位但未主罚任意球，则投注结束时将不予考虑，因为“未踢任意球”。</p>
      <p>结果认证以赛事组织者和/或 sofascore.com 提供的官方数据为准</p>
      <p><span style={{ color: "#ff0000" }}>1X2 越位</span></p>
      <p>您必须使用传统的 1X2 方法预测两支球队中哪一支会在比赛中出现最多的越位次数。</p>
      <p>当对方球队获得任意球并主罚任意球时，如果球员被判处于越位位置，则视为越位。投注结算时，优势不予考虑：必须判罚并主罚任意球。如果在上半场或比赛结束时，判罚越位但未主罚任意球，则投注结束时将不予考虑，因为“未踢任意球”。</p>
      <p>结果认证以赛事组织者和/或 sofascore.com 提供的官方数据为准</p>
      <p><span style={{ color: "#ff0000" }}>驱逐“是/否”玩家 X</span></p>
      <p>本投注预测指定球员在指定比赛中是否被罚下，不包括加时赛和点球大战。替补球员、已替补球员、终场哨响后球员、教练或技术人员的罚牌不参与投注。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果选定的球员没有参加比赛，对他的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>包括球员在内的成功传球次数少于/超过</span></p>
      <p>您必须预测在指定比赛（包括加时赛）中，指定球员的传球次数是低于（低于）还是高于（高于）预设值。如果指定球员未参加比赛（我们所说的“参加”是指实际上场的球员），则投注将被退还。如果球员参加了比赛，即使只参加了有限的一段时间，投注也有效。为了便于报告，参考赛事组织者发布的规则和官方数据将有效。</p>
      <p><span style={{ color: "#ff0000" }}>球员 X 在比赛中（包括加时赛）扑救数少于/超过</span></p>
      <p>您必须预测在指定比赛（包括加时赛）中，指定的守门员/球员的扑救次数是否会低于（低于）或高于（高于）预设值。如果指定球员未参加比赛（我们所说的“参加”是指实际上场的球员），则投注将被退还。如果球员参加了比赛，即使只参加了有限的一段时间，投注也将被确认。为了便于报告，以比赛组织者发布的规则和官方数据为准。com</p>
      <p><span style={{ color: "#ff0000" }}>U/O 杆/横梁</span></p>
      <p>您必须预测在比赛中击中的木杆（门柱/横梁）数量是低于（少于）还是高于（多于）预先设定的值。</p>
      <p>为了报告的目的以及在所有其他情况下，有关此事的现行立法、法规和参考活动组织者发布的官方数据均有效</p>
      <p><span style={{ color: "#ff0000" }}>上半场换人是/否</span></p>
      <p>您必须预测该场比赛上半场结束前是否会有至少一次换人。</p>
      <p>为了结算投注，半场和下半场的变更将不予考虑。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>梦幻足球甲级联赛意大利</span></p>
      <p>为了投注的目的，国家体育日报《米兰体育报》公布的结果（梦幻投票）有效。</p>
      <p>如果玩家不参加比赛，则参考的对决将被视为无效。</p>
      <p>如果玩家掷出 sv，则参考正面交锋将被视为无效。</p>
      <p>只要有球员在任何一分钟进入正在进行的比赛，投注都将有效。</p>
      <p>如果两名球员获得相同的梦幻投票，则上场时间最长的球员将获胜（不计算额外时间）。</p>
      <p>奖励与惩罚：</p>
      <p>&middot; 每进一个球 +3 分</p>
      <p>&middot; 每扑出一个点球 +3 分</p>
      <p>&middot; 每罚一球 +3 分</p>
      <p>&middot; 每次助攻 +1 分</p>
      <p>&middot; 每次警告 -0.5 分</p>
      <p>&middot; +1 不败门将</p>
      <p>&middot; 守门员每丢一球 -1 分</p>
      <p>&middot; 每次驱逐 -1 分</p>
      <p>&middot; 每个乌龙球 -2 分</p>
      <p>&middot; 罚失点球 -3 分</p>
      <p><span style={{ color: "#ff0000" }}>梦幻足球（意大利甲级联赛除外）</span></p>
      <p>为了投注的目的，国家体育日报《米兰体育报》公布的成绩单等级将有效（如果由于某种原因报纸没有公布成绩单，则以 fantapazz 应用程序的成绩单为准），下面显示的奖金/罚分将被加到该等级上或从中扣除。</p>
      <p>如果玩家不参加比赛，则参考的对决将被视为无效。</p>
      <p>如果玩家获得 sv，则参考单挑将被视为无效。</p>
      <p>只要有球员在任何一分钟进入正在进行的比赛，投注都将有效。</p>
      <p>如果两名球员获得相同的梦幻投票，则上场时间最长的球员将获胜（不计算额外时间）。</p>
      <p>至于助攻，在冠军联赛比赛中，它们将不会计入梦幻投票的计算中。</p>
      <p>奖励与惩罚：</p>
      <p>&middot; 每进一个球 +3 分</p>
      <p>&middot; 每扑出一个点球 +3 分</p>
      <p>&middot; 每罚一球 +3 分</p>
      <p>&middot; 每次警告 -0.5 分</p>
      <p>&middot; +1 不败门将</p>
      <p>&middot; 守门员每丢一球 -1 分</p>
      <p>&middot; 每次驱逐 -1 分</p>
      <p>&middot; 每个乌龙球 -2 分</p>
      <p>&middot; 罚失点球 -3 分</p>
      <p>至于助攻，它们将不会计入梦幻投票计算中。</p>
      <p><span style={{ color: "#ff0000" }}>比赛获胜者</span></p>
      <p>它用于预测哪支球队将赢得某项体育赛事、锦标赛或比赛，并从一系列可能的结果中进行选择。“其他”选项（如果存在）包含列表中未明确指出的所有结果。</p>
      <p>最终成绩认证以赛事官方排名为准。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者组</span></p>
      <p>此投注预测哪支队伍将在赛事排名中取得最佳名次。如果已公布名单中的队伍因任何原因未参加赛事，则已接受的投注将被视为失败，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>您必须预测两支被提名的球队中哪一支将在锦标赛结束时获得更好的排名，或者将在某项赛事（例如冠军联赛、意大利杯、世界杯等）中晋级下一轮，或者在杯赛决赛中取得胜利（包括加时赛和点球大战）。</p>
      <p>最终成绩认证以赛事官方排名为准。</p>
      <p>球队降级是/否该投注用于预测某支球队是否会在本赛季结束时降级至低级联赛。</p>
      <p>结果认证以赛事官方排名为准。</p>
      <p><span style={{ color: "#ff0000" }}>球队晋级是/否</span></p>
      <p>该赌注预测某支球队是否会在足球锦标赛结束时晋级大联盟。</p>
      <p>结果认证以赛事官方排名为准。</p>
      <p>除非另有说明，赛事冠军的赛前投注始终旨在预测冠军归属。季后赛前的排名不予考虑。投注结果仅考虑票券中相关锦标赛的最终获胜者。</p>
      <p><span style={{ color: "#ff0000" }}>下一任球队教练</span></p>
      <p>您需要预测列表中哪支球队将执教指定教练。该列表始终会包含该教练在市场时段开始时所属的球队。投注结果中出现“其他”字样，表示教练与列表中未列出的球队签订了合同。对于此类投注，系统会显示指定事件发生的截止日期。投注支付以一线队官方网站上的公告为准，一旦发生转会，官网会公布相关消息。</p>
      <p><span style={{ color: "#ff0000" }}>下一支足球队</span></p>
      <p>您必须预测指定球员将效力于名单中的哪支球队。名单将始终包含该球员在市场时段开始时所属的球队。投注结果将包含“其他”，表示球员与名单中未列出的球队签约的情况。对于此类投注，将注明指定事件发生的截止日期。投注支付以一线队官方网站上的公告为准，如果球员转会至其他球队，官网将公布相关消息。</p>
      <p><span style={{ color: "#ff0000" }}>球队教练 X 日期 Y</span></p>
      <p>您必须从预先拟定的名单中预测谁将成为指定球队的下一任教练。截止日期以投注中指定的日期为准。投注结果中存在“其他”选项，表示与指定球队签约的教练不在名单中。投注结果以教练签约的球队或足协的官方新闻稿为准。</p>
      <p><span style={{ color: "#ff0000" }}>教练团队日期是/否</span></p>
      <p>此投注预测指定对象在指定日期前是否会训练（结果为“是”）或不训练（结果为“否”）赛事描述中指定的球队/国家。此类投注将指定赛事的截止日期，即指定赛事必须在此日期前完成。指定对象的新分配正式公布后，赛事将暂停。</p>
      <p>示例：</p>
      <p>&bull; 足球特辑</p>
      <p>佩普·瓜迪奥拉 巴西队主教练 (截至 2023 年 6 月 1 日)</p>
      <p>结果：是/否</p>
      <p><span style={{ color: "#ff0000" }}>团队变更是/否</span></p>
      <p>投注内容是预测在建议的日期，指定球员是否会改变/离开他的球队（是）或不会（否）</p>
      <p>. 明确规定：- 如果指定球员在指定日期前与其所在球队终止合同，则投注结果将报告为“YES”。- 如果指定球员退出比赛，则投注结果将报告为“NO”。对于此类投注，将指定指定事件发生的截止日期（日期 X）。为了便于报告和确保有效性，俱乐部发布的官方新闻稿将有效；对于未提及的所有内容，现行部长令将有效。</p>
      <p>出于报道目的以及所有其他情况，相关俱乐部发布的官方新闻稿将有效。</p>
      <p><span style={{ color: "#ff0000" }}>上半场换人是/否</span></p>
      <p>您必须预测该场比赛上半场结束前是否会有至少一次换人。</p>
      <p>为了结算投注，半场和下半场的变更将不予考虑。</p>
      <p>比赛结果以赛事组织者提供的官方数据为准。如比赛暂停，且未在一般规则规定的期限内恢复，则比赛结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>主教练在比赛中受到警告</span></p>
      <p>您必须预测在包括加时赛在内的比赛中，指定主队的教练是否会被出示黄牌。直接驱逐出场将不被视为黄牌。在投注分配方面，比赛终场哨响后的黄牌将不予考虑。结果认证以赛事组织者提供的官方数据为准。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>比赛中出场教练警告</span></p>
      <p>您必须预测在包括加时赛在内的比赛中，指定客队教练是否会被黄牌警告。直接驱逐出场将不被视为黄牌警告。在投注分配方面，比赛终场哨响后的黄牌警告将不予考虑。结果认证以赛事组织者提供的官方数据为准。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>主队教练在比赛中被罚下场</span></p>
      <p>您必须预测在指定比赛（包括加时赛）中，指定主队的教练是否会被罚下。在投注分配方面，比赛终场哨响后的警告/驱逐将不予考虑。结果认证以赛事组织者提供的官方数据为准。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>客座教练在比赛中被罚下场</span></p>
      <p>您必须预测在指定比赛（包括加时赛）中，指定客队的教练是否会被罚下。在投注分配方面，比赛终场哨响后的警告/驱逐将不予考虑。结果认证以赛事组织者提供的官方数据为准。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>主队点球得分 是/否</span></p>
      <p>您必须预测主队在比赛（包括加时赛）期间是否会罚进点球。加时赛结束时的任何点球抽签均不计算在内。结果以赛事组织者提供的官方数据为准。如果比赛暂停，且未在一般规则规定的时限内恢复，则结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>客场点球得分 是/否</span></p>
      <p>您必须预测客队在比赛期间（包括加时赛）是否会获得点球。加时赛结束时的任何点球抽签均不计算在内。结果以赛事组织者提供的官方数据为准。如果比赛暂停，且未在一般规则规定的时间内恢复，则结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>射失点球 是/否</span></p>
      <p>您必须预测主队在比赛期间（包括加时赛）是否会罚丢点球。加时赛结束时的任何点球抽签均不计算在内。结果以赛事组织者提供的官方数据为准。如果比赛暂停，且未在一般规则规定的时限内恢复，则结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>客队罚失点球 是/否</span></p>
      <p>您必须预测客队在比赛期间（包括加时赛）是否会罚丢点球。加时赛结束时的任何点球抽签均不计算在内。结果以赛事组织者提供的官方数据为准。如果比赛暂停，且未在一般规则规定的时限内恢复，则结果将被视为无效。</p>
      <p><span style={{ color: "#ff0000" }}>CASA DUO</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注内容为预测在比赛的常规时间内，主队的球员 X 或替补上场的球员是否至少进一球</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>嘉宾二重奏</span></p>
      <><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注内容为预测在比赛的常规时间内，客队的球员 X 或替补上场的球员是否至少进一球</span></span></span></>
      <p><span style={{ color: "#ff0000" }}>主队 - 进球+黄牌+助攻</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>本投注预测主队球员X在常规时间内是否至少进球一次、至少助攻一次，同时是否在比赛中被出示红牌。替补席球员或终场哨响后出示的红牌不适用于本投注。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>客队 - 进球+黄牌+助攻</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>本投注预测客队球员X在常规时间内是否至少进球一次、至少助攻一次，同时是否在比赛中被出示红牌。替补席上球员出示的红牌或终场哨响后出示的红牌不适用于本投注。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>主队 - 进球、罚牌或助攻</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>本投注预测主队球员X在常规时间内是否至少进一球、至少送出一次助攻或被出示黄牌。替补席球员出示的黄牌或终场哨响后出示的黄牌不适用于本投注。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>客队 - 进球、罚牌或助攻</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>本投注预测客队球员X在常规时间内是否至少进一球、至少送出一次助攻或被出示黄牌。替补席上球员出示的黄牌或终场哨响后出示的黄牌不适用于本投注。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>替代标记</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>该投注预测在比赛的常规时间内，替补出场的球员是否至少进一球</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>标记回家间隔 30 分钟。</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>该投注仅考虑指定的时间段，预测主队的特定球员是否会至少进一球。</span></span></span></p>
      <><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>只有指定的分钟数才用于投注目的。</span></span></span><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}><br /> </span></span></span><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>如果选定的球员没有在指定的分钟数内上场，则对他的投注将无效。将会退款。</span></span></span></>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>标记嘉宾间隔 30 分钟。</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>该投注仅考虑指定的时间段，预测客队的特定球员是否会至少进一球。</span></span></span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>只有指定的分钟数才用于投注目的。</span></span></span><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}><br /> </span></span></span><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>如果选定的球员没有在指定的分钟数内上场，则对他的投注将无效。将会退款。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>记分员进场并得分</span></p>
      <p>您必须预测所选球员是否会替补出场并至少进一球。以首发球员身份出场的球员将被视为未参加比赛（哪怕是一秒钟）。如果赛事暂停或延期，则适用足球的一般规则。</p>
      <p><span style={{ color: "#ff0000" }}>U/O PLUS </span></p>
      <p>投注内容是预测比赛期间进球数和门柱/横梁数之和是低于（小于）还是高于（大于）某个值 X。投注仅考虑常规时间，不包括加时赛和点球。示例：指数 X = 2.5；赛事“尤文图斯 - 那不勒斯”。如果“尤文图斯 - 那不勒斯”比赛以 1-1 结束，且尤文图斯球员在第 70 分钟击中门柱，则进球数和门柱/横梁数之和为 3，因此获胜结果为“大于”。如果“尤文图斯 - 那不勒斯”比赛以 1-0 结束，且两队均未击中门柱，则进球数和门柱/横梁数之和为 1，因此获胜结果为“低于”。为了报告目的以及对于所有其他情况，以赛事组织者的报告为准。在缺少主办方提供的某些数据的情况下，以 sofascore.com 发布的的数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>U/O PLUS TEMPO Y</span></p>
      <p>投注内容为预测比赛 Y 时段内进球数和门柱/横梁总数是低于（小于）还是高于（大于）某个数值 X。投注仅考虑常规时间加上伤停补时。示例：指数 X = 1.5，Y = 时段 1；赛事“AC 米兰 - 国际米兰”。如果“AC 米兰 - 国际米兰”比赛第 1 时段以 1-0 结束，且国际米兰球员在第 30 分钟击中门柱，则进球数和门柱/横梁总数为 2，因此获胜结果为“大于”。如果“AC 米兰 - 国际米兰”比赛第 1 时段以 0-0 结束，且两队均未击中门柱，则进球数和门柱/横梁总数为 0，因此获胜结果为“小于”。出于报告目的以及所有其他情况，以赛事组织者的报告为准。在缺少主办方特定数据的情况下，以sofascore.com发布的数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>U/O PLUS TEAM Y</span></p>
      <p>投注内容为预测比赛期间，Y 队的进球数和门柱/横梁总数是低于（小于）还是高于（大于）某个值 X。投注仅考虑常规时间，不包括加时赛和点球。示例：指数 X = 1.5，指数 Y = 第 2 队；赛事“AC 米兰 - 国际米兰”。如果“AC 米兰 - 国际米兰”比赛以 1-1 结束，且国际米兰球员在第 70 分钟击中门柱，则国际米兰的进球数和门柱/横梁总数为 2，因此获胜结果为“大于”。如果“AC 米兰 - 国际米兰”比赛以 1-0 结束，且没有国际米兰球员击中门柱，则国际米兰的进球数和门柱/横梁总数为 0，因此获胜结果为“小于”。出于报告目的以及所有其他情况，以赛事组织者的报告为准。在缺少主办方特定数据的情况下，以sofascore.com发布的数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球加分</span></p>
      <p>本投注预测比赛期间，两队是否均至少进球，或两队均至少击中一根门柱/横梁，或一队进球而另一队至少击中一根门柱/横梁。投注仅考虑常规时间，不包括加时赛和点球大战。例如：“AC米兰 - 国际米兰”赛事。如果“AC米兰 - 国际米兰”比赛以 1-0 结束，国际米兰击中一根门柱，则结果为“是”。如果“AC米兰 - 国际米兰”比赛以 1-0 结束，AC米兰击中一根门柱，则结果为“输”。出于报告目的以及所有其他情况，赛事组织者的报告将有效。如果组织者缺少某些数据，则以 sofascore.com 发布的为准。</p>
      <p><span style={{ color: "#ff0000" }}>加标记</span></p>
      <p>投注内容是预测在比赛的常规时间和加时赛中，相关球员或替补上场的球员是否至少进一球或击中至少一次门柱/横梁。</p>
      <p>比赛结果以赛事主办方提供的官方数据为准。未尽事宜，以足球比赛的一般规则为准。</p>
      <p>需要注意的是，如果射门击中门柱或横梁后发生偏转，则可能不被视为直接射门，因此此类结果将被视为失败。无论如何，官方认证始终以赛事组织者发布的为准，仅在赛事组织者未提供官方报告的情况下，才会以 sofascore.com 发布的资料作为替代。
      </p>
      <p><span style={{ color: "#ff0000" }}>U/O 射门得分 PLUS</span></p>
      <p>该投注预测比赛结束时（包括加时赛）球员 Y 及其可能替补球员的射门总数是低于还是高于参考指数 X。对于这种类型的投注，考虑 2 种结果：低于 – 高于。<br />
        如果出现以下情况，则会出现“低于”结果：<br />
        &bull; 球员 Y 的射门次数少于参考指数 X，因此没有被替换<br />
        &bull; 球员 Y 被替换下场，且球员 Y 和替补球员的射门总数小于参考指数 X<br />
        &bull; 球员 Y 替补出场，没有被替换，且射门次数低于参考指数 X<br />
        &bull; 球员Y替补出场，被替换下场，球员Y和替补球员的射门次数总和低于参考指数X。<br />
        如果出现以下情况，则会出现“超过”的结果：<br />
        &bull; 球员 Y 射门次数大于参考指数 X，且未被替换<br />
        &bull; 球员 Y 被替换下场，且球员 Y 和替补球员的射门总数高于参考指数 X<br />
        &bull; 球员 Y 和他的替补球员的射门次数均高于参考指数 X<br />
        &bull; 球员 Y 替补出场，射门次数大于参考指数 X，且未被替换<br />
        &bull; 球员 Y 替补出场，被替换下场，且球员 Y 和替补球员的射门次数总和高于参考指数 X。<br />
        如果球员 Y 未参加比赛，投注将被退还。球员实际上场时即视为参加比赛，即使上场时间有限。“射正”是指射向对方球门并射入球门（即使击中门柱或横梁），或者若未被守门员或最后一名球员挡出则射门会入网；任何击中门柱或横梁的射门均视为射正。比赛报告以官方组织机构（Legacalcio、欧足联、国际足联等）公布的数据为准，否则将使用 SOFASCORE 提供的数据。任何未提及的事项，将参考足球的一般规则。例如：指数 X = 2.5 - U/O 2.5 射正次数，包括击中门柱和横梁，球员 Y 及替补球员。 TS 如果球员 Y 及其替补球员的射门总数小于 2.5，则获胜结果为“小”。如果球员 Y 及其替补球员的射门总数大于 2.5，则获胜结果为“大”。<br />
      </p>
      <p>如果射门被守门员扑救或被最后一名防守球员挡出，并击中门柱/横梁，则计为一次射门。</p>
      <p><span style={{ color: "#ff0000" }}>Plus 卡</span></p>
      <p>本投注预测球员X或其替补球员在比赛中是否会至少领到一张黄牌或红牌。为了确定胜负结果，所有可能领到的黄牌或红牌，无论是在球场上还是在替补席上，在比赛的任何时间，包括半场休息、伤停补时、加时赛、点球大战以及终场哨响后，都会被纳入考量。</p>
      <p>• 如果结果为“是”，则预测会出现以下可能性之一：</p>
      <p>- 球员 X 至少收到一张牌（黄牌或红牌）[即使是在替补席上或比赛结束后]；</p>
      <p>- 球员 X 没有收到任何牌，但从替补席上场的球员收到至少一张牌（黄牌或红牌）[即使在终场哨响之后]；</p>
      <p>- 球员 X 和替补上场的球员都至少收到一张牌（黄牌或红牌）[即使是在替补席上或比赛结束后]；</p>
      <p>- 球员 X 被之前在替补席上领到黄牌的球员替换；</p>
      <p>- 球员 X 被替换下场，随后从替补席上收到一张牌（黄牌或红牌）[即使在终场哨响之后]。</p>
      <p>如果球员 X 从替补席上场替换已经收到牌的球员，且球员 X 没有收到任何牌且没有被替换，则获胜结果将为“否”。</p>
      <p>若选手 X 未参加比赛，则赌注将被退还。</p>
      <p>当球员真正上场时，即使时间很短，他仍然表示参加了比赛。</p>
      <p>出于报告目的以及所有其他情况，将适用相关赛事组织者发布的规则和官方数据。未指定的任何其他情况，均适用足球的一般规则。</p>
      <p style={{ color: "#ff0000" }}>几乎警告加</p>
      <p>本投注预测在比赛的常规时间和加时赛中，球员X或替补上场的球员是否会符合以下情况之一：在比赛期间的任何时间，无论是在场上还是在替补席上，他都会至少领到一张黄牌（红牌），包括上下半场之间的中场休息、伤停补时、加时赛、点球大战以及终场哨响后；或者球员X或替补上场的球员总共犯规2次。如果球员X未参加比赛，投注将被退还。球员在实际上场时，即使只上场了有限的时间，也视为参加了比赛。为了便于报告，官方组织机构公布的信息将作为有效数据，否则将参考SOFASCORE提供的数据。任何未提及的内容，均以一般规则为准。</p>
      <p style={{ color: "#ff0000" }}>QUASI MACATORE PLUS</p>
      <p>本投注预测在比赛的常规时间和加时赛中，相关球员X或替补上场的球员是否至少进一球，或者球员X及其可能直接替补上场的球员的射门总数是否至少达到3次。“射门”是指射入对方球门的射门，即使击中门柱或横梁后仍进入球门，或者若未被守门员或最后一名球员扑救，球仍会进入球门；任何击中门柱或横梁的射门均视为射门。如果球员X未参加比赛，投注将被退还。球员实际上场时，即使时间有限，也视为参加了比赛。比赛报告以官方组织机构公布的数据为准，否则将参考SOFASCORE提供的数据。对于任何未提及的内容，请参阅一般规则。</p>
      <p style={{ color: "#ff0000" }}>Assist Duo + Ammonito Plus</p>
      <p>本投注预测在比赛的常规时间和加时赛中，球员 X 及其替补上场的球员是否会至少有一次助攻以及至少得到一张牌（黄牌或红牌）。投注时，将球员 X 及其替补球员的助攻和得到的牌总数作为总和。如果球员 X 没有被替换下场，则只计算其助攻和牌数。注意：为确定获胜结果，将考虑球员 X 或其替补球员在球场上和替补席上、比赛期间任何时间（包括半场休息、伤停补时、加时赛、点球大战以及终场哨响后）所得到的所有牌（黄牌或红牌）。</p>
      <p>如果结果为“是”，则预测会出现以下可能性之一：</p>
      <p>- 球员 X 至少有一次助攻，并且至少得到一张牌（黄牌或红牌）；</p>
      <p>- 球员 X 至少有一次助攻但没有收到任何牌，而他的替补球员至少收到一张牌（黄牌或红牌）[即使是在替补席上或比赛结束后]；</p>
      <p>- 球员 X 没有助攻，但收到至少一张牌（黄牌或红牌）[即使是在替补席上或比赛结束后]，并且他的替补球员至少有一次助攻；</p>
      <p>- 球员 X 没有助攻，也没有得到任何牌，而他的替补球员至少有一次助攻，并得到至少一张牌（黄牌或红牌）[即使是在替补席上或比赛结束后]。</p>
      <p>如果结果为“否”，则预测会出现以下可能性之一：</p>
      <p>- 球员 X 没有助攻或得到任何牌，他的替补球员也没有助攻或得到任何牌。</p>
      <p>- 球员 X 至少有一次助攻但没有收到任何牌，他的替补球员也没有收到任何牌。</p>
      <p>- 球员 X 没有助攻，但收到至少一张牌（黄牌或红牌），并且他的替补球员没有助攻。</p>
      <p>- 球员 X 未做出任何助攻，未收到任何牌且未被替换。</p>
      <p>- 球员 X 至少有一次助攻，没有领到牌并且没有被替换下场。</p>
      <p>- 球员 X 没有助攻，至少收到一张牌并且没有被替换。</p>
      <p>如果球员X替补上场，替换已经助攻并领到红牌的球员，而球员X既没有助攻也没有领到红牌，则投注结果为“否”。如果球员X未参加比赛，投注将被退还。球员实际上场时，即使上场时间有限，也视为参加了比赛。</p>
      <p>示例：莱奥或其替补球员助攻并领到黄牌。1. 莱奥在第35分钟领到黄牌，没有助攻，在第57分钟被莫拉塔换下，莫拉塔在第80分钟助攻。获胜结果：是。2. 莱奥在第42分钟助攻，但没有领到黄牌，也没有被换下。获胜结果：否。</p>
      <p>为了报告的目的以及在所有其他情况下，有关此事的现行立法、法规和参考活动组织者发布的官方数据将有效；如果没有后者，则将使用 OPTA 提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>Assist Duo O Ammonito Plus</p>
      <p>本投注预测在比赛的常规时间和加时赛中，球员 X 或其替补球员是否会至少有一次助攻或至少得到一张牌（黄牌或红牌）。注意：为了确定胜负结果，所有可能在比赛期间（包括半场休息、伤停补时、加时赛、点球大战以及终场哨响后）在球场上和替补席上得到的牌（黄牌或红牌）均会被考虑在内。如果结果为“是”，则预测以下可能性之一：</p>
      <p>- 球员 X 至少有一次助攻；</p>
      <p>- 球员 X 至少收到一张牌（黄牌或红牌）[即使是在替补席上或比赛结束后]；</p>
      <p>- 球员 X 没有做出至少一次助攻，也没有收到至少一张牌（黄牌或红牌），但替补上场的球员做出至少一次助攻或收到至少一张牌（黄牌或红牌）[即使在终场哨响之后]；</p>
      <p>- 球员 X 和替补上场的球员均至少有一次助攻；</p>
      <p>- 球员 X 和替补上场的球员都至少收到一张牌（黄牌或红牌）[即使是在替补席上或比赛结束后]；</p>
      <p>- 球员 X 被之前在替补席上领到黄牌的球员替换；</p>
      <p>- 球员 X 被替换下场，随后从替补席上收到一张牌（黄牌或红牌）[即使在终场哨响之后]。</p>
      <p>如果结果为“否”，则预测会出现以下可能性之一：</p>
      <p>- 球员 X 和替补上场的球员没有做出任何助攻，也没有收到任何牌；</p>
      <p>- 球员 X 未做出任何助攻，未收到任何牌且未被替换。</p>
      <p>如果球员X替补上场，替换已经助攻或领到红牌的球员，而球员X没有助攻或领到红牌，也未被替换，则投注结果为“否”。如果球员X未参加比赛，投注将被退还。球员实际上场时，即使只上场了有限的时间，也视为参加了比赛。</p>
      <p>示例：R.Leao 或其替补球员完成助攻或领到红牌。1. R.Leao 没有完成助攻，也没有领到红牌，他在第 45 分钟被 Bennacer 替换下场，后者在第 70 分钟完成助攻。获胜结果：是 2. R.Leao 没有完成助攻，没有领到红牌，也没有被替换下场。获胜结果：否。</p>
      <p>为了报告的目的以及在所有其他情况下，有关此事的现行立法、法规和参考活动组织者发布的官方数据将有效；如果没有后者，则将使用 OPTA 提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>辅助双核 + 标记增强版</p>
      <p>本投注预测球员 X 或其替补上场的球员在常规比赛时间（包括加时赛）内是否至少进球一球，或至少击中一次门柱或横梁，以及球员 X 或其替补球员在常规比赛时间以及任何恢复比赛状态（包括加时赛）内是否至少有一次助攻（结果为“是”）或未有助攻（结果为“否”）。如果球员 X 未参加比赛，投注将被退还。球员在实际上场时即视为参加了比赛，即使上场时间有限。</p>
      <p>示例：莱奥或其替补球员至少进一球或至少击中一次门柱或横梁，并至少有一次助攻，包含 TS 1. 莱奥在第 35 分钟助攻但未得分（且未击中门柱/横梁）；第 70 分钟，他被莫拉塔替换，莫拉塔在第 83 分钟进球。获胜结果：是。2. 莱奥在第 35 分钟助攻但未得分（且未击中门柱/横梁）；第 70 分钟，他被莫拉塔替换，莫拉塔在第 85 分钟助攻但未得分（且未击中门柱/横梁）；获胜结果：否。</p>
      <p>就报告目的及其他所有情况而言，现行相关法律法规、规则以及参考赛事组织者发布的官方数据均有效。除门柱/横梁和助攻数据外，若无助攻数据，则将使用OPTA提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>Assist Duo O Marker Plus</p>
      <p>投注内容是预测在比赛的常规时间和加时赛中，相关球员 X 或替补上场的球员是否会至少进一球、至少击中一次门柱或横梁、或至少有一次助攻（结果为“是”）或不会（结果为“否”）。如果球员 X 未参加比赛，则投注将被退还。球员在实际上场时即已参加比赛，即使上场时间有限。示例：莫拉塔或其替补球员至少进一球、至少击中一次门柱或横梁、或至少有一次助攻。1. 莫拉塔没有进球、没有击中门柱/横梁、也没有助攻，他在第 55 分钟被莱奥换下，莱奥在第 70 分钟助攻；0. 获胜结果：是 2. 莫拉塔没有进球、没有击中门柱/横梁、没有助攻，也不是替补球员。获胜结果：否。</p>
      <p>为了报告的目的以及在所有其他情况下，有关此事的现行立法、规则和参考赛事组织者发布的官方数据将有效；仅适用于门柱/横梁和助攻，如果没有后者，则将使用 OPTA 提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>球员 X 进球者 PLUS + PLUS BOOKED</p>
      <p>投注内容为预测球员 X 或替补他上场的球员在比赛的常规时间和任何伤停补时（包括加时赛）中是否至少进一球，或是否会击中门柱或横梁，以及在比赛的任何时间，包括半场、伤停补时、任何加时赛、任何点球大战和终场哨响后，球员 X 或其替补球员是否至少领到一张牌（黄牌或红牌）（结果为“是”）或未领到（结果为“否”）。如果球员 X 未参加比赛，则投注将被退还。当球员实际上场时，即使只上场了有限的时间，他也参加了比赛。</p>
      <p>示例：球员 X 或其替补球员至少进球一次，或至少击中一次门柱或横梁（包括罚球），并至少获得一张黄牌（包括罚球、点球、替补）。终场哨响后，1. D.Vlahovic 在第 37 分钟获得一张黄牌，并于第 60 分钟被 Yildiz 替换下场，后者在第 75 分钟击中门柱。获胜结果：是。2. D.Vlahovic 进球但未获得黄牌，于第 58 分钟被 Yildiz 替换下场，后者击中门柱/横梁，未获得黄牌。获胜结果：否。</p>
      <p>就报告目的及其他所有情况而言，现行相关法律法规、规章以及参考赛事组织者发布的官方数据均有效。仅就杆/横木而言，若无后者，则将使用OPTA提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>球员为进球者或被罚黄牌者</p>
      <p>投注内容是预测在比赛的常规时间和加时赛中，相关球员 X 或替补上场的球员是否至少进一球、至少击中一杆门柱/横梁或至少收到一张牌（黄牌或红牌）。在确定获胜结果时，将考虑球员 X 或其替补球员在比赛期间任何时间（包括半场休息、伤停补时、加时赛、点球大战和终场哨响后）在球场上和替补席上得到的所有可能的牌（黄牌或红牌）。如果球员 X 或其替补球员至少进一球（或击中门柱/横梁）或至少收到一张牌（黄牌或红牌），或两者兼有，则结果为“是”即获胜。如果球员 X 及其替补球员没有进球（也没有击中门柱/横梁）并且没有收到任何牌（黄牌或红牌），则结果为“否”即获胜。如果球员X替补已进球、击中门柱/横梁或已领到黄牌的球员上场，且球员X未进球、未击中门柱/横梁或未领到黄牌且未被替换，则结果为“否”。如果球员X未参加比赛，则投注将被退还。球员实际上场时，即使时间有限，也视为参加了比赛。</p>
      <p>示例：球员 X 或其替补球员进球、击中门柱/横梁或被出示黄牌。1. D. Vlahovic 未进球（且未击中门柱/横梁），未出示黄牌；他在第 60 分钟被 Yildiz 替换下场，后者在第 75 分钟击中门柱。获胜结果：是。2. D. Vlahovic 未进球（且未击中门柱/横梁），未出示黄牌，也未被替换下场。获胜结果：否。</p>
      <p>就报告目的及其他所有情况而言，现行相关法律法规、规章以及参考赛事组织者发布的官方数据均有效。仅就杆/横木而言，若无后者，则将使用OPTA提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>助攻王+进球王+黄牌王</p>
      <p>投注内容为预测球员 X 或替补他上场的球员是否至少进一球、击中门柱或横梁，以及球员 X 或替补球员是否在常规时间和任何伤停补时（包括加时赛）内至少有一次助攻，以及球员 X 或替补球员是否在比赛的任何时间（包括半场、伤停补时、加时赛、点球大战和终场哨响后）（结果为“是”）或未（结果为“否”）在场上和替补席上至少收到一张牌（黄牌或红牌）。如果球员 X 未参加比赛，投注将被退还。当球员实际上场时，即使只上场了有限的时间，也视为参加了比赛。</p>
      <p>示例：莱奥或其替补队员至少进一球、至少击中一次门柱或横梁、至少有一次助攻，并在比赛结束后在替补席上至少得到一张牌（包括罚牌、点球）。1. 莱奥在第 35 分钟助攻；第 70 分钟被莫拉塔换下，莫拉塔在第 83 分钟进球，第 84 分钟被黄牌警告。获胜结果：是。2. 莱奥在第 35 分钟助攻；第 70 分钟被莫拉塔换下，莫拉塔在第 73 分钟击中门柱，第 85 分钟助攻；获胜结果：否。</p>
      <p>就报告目的及其他所有情况而言，现行相关法律法规、规则以及参考赛事组织者发布的官方数据均有效。除门柱/横梁和助攻数据外，若无助攻数据，则将使用OPTA提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>助攻二人组 O 得分手 Plus O 黄牌 Plus</p>
      <p>该投注用于预测所讨论的球员 X 或替补上场的任何球员是否会在比赛的常规时间和加时赛中至少进一球、至少击中一次门柱或横梁、至少有一次助攻，或者是否会在比赛的任何时间（包括中场休息、伤停补时、加时赛、点球大战和终场哨响后）（结果为“是”）或未参加（结果为“否”）领到至少一张牌（黄牌或红牌）。如果球员 X 未参加比赛，则投注将被退还。当球员实际上场时，即使只上场了有限的时间，也视为参加了比赛。</p>
      <p>示例：莫拉塔或其替补球员在比赛结束哨响后至少进球一次、至少击中一次门柱或横梁、至少有一次助攻或至少收到一张牌（包括罚球、点球、替补）。1. 莫拉塔没有进球、没有击中门柱或横梁、没有任何助攻且没有收到任何牌，在第 55 分钟被莱奥替换下场，莱奥在第 70 分钟有一次助攻。获胜结果：是。2. 莫拉塔没有进球、没有击中门柱或横梁、没有任何助攻、没有收到任何牌且未被替换下场。获胜结果：否。</p>
      <p>就报告目的及其他所有情况而言，现行相关法律法规、规则以及参考赛事组织者发布的官方数据均有效。除门柱/横梁和助攻数据外，若无助攻数据，则将使用OPTA提供的数据。</p>
      <p><span style={{ color: "#ff0000" }}>双卡</span></p>
      <p>
        投注内容是预测在比赛的常规时间内，球员 X 或替补上场的任何球员是否会在比赛中收到至少一张牌（黄牌或红牌）。
        结果的认证以赛事组织者提供的官方数据为准。
      </p>
      <p><span style={{ color: "#ff0000" }}>两人受到警告</span></p>
      <p>
        投注内容是预测在比赛的常规时间内，球员 X 或替补上场的任何球员是否会在比赛中收到至少一张黄牌。
        结果的认证以赛事组织者提供的官方数据为准。
      </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 半场进球</span></p>
      <p>您需要预测在指定的1分钟时间内，任意一支球队是否会进球。结果可能为2种：是或否。</p>
      <p>示例：尤文图斯对阵国际米兰，进球时间为 00:00 分钟至 00:59 分钟</p>
      <p>客户投注“是”，因此预测在比赛期间 00:00 至 00:59 分钟内任一队都会进球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35 分钟）至少有一个进球，则投注获胜。如果在 00:00-00:59 期间没有进球，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考 ADM 的部长条例。</p>
      <br />
      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 节中开出的角球</span></p>
      <p>您必须预测在比赛的特定1分钟内，任意一队是否会获得角球。结果可能为2种：是或否。</p>
      <p>为了结算目的，角球实际被发出的分钟数才有效，而不是角球被判出的时间。</p>
      <p>示例：尤文图斯-国际米兰角球，从 00:00 分钟到 00:59 分钟</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队将发出角球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35），至少有一个角球，则投注获胜。如果在 00:00-00:59 期间没有角球，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考 ADM 的部长条例。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>XX.XX - YY.YY 区间内提取的卡牌</span></p>
      <p>您需要预测在比赛的特定1分钟内，任何一支球队是否会被出示黄牌或红牌。结果可能有两种：是或否。</p>
      <p>为了结算投注，将考虑实际抽牌的时间，而不是犯规的时间。</p>
      <p>示例：尤文图斯对阵国际米兰的比赛卡，从 00:00 分钟到 00:59 分钟</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队都会抽出一张牌。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35），至少出现一张黄牌或红牌，则投注获胜。如果在 00:00-00:59 期间没有出现任何红牌，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考 ADM 的部长条例。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 节中任意球</span></p>
      <p>您需要预测在指定的1分钟时间内，任意球是否会由任意球产生。结果可能为2种：是或否。</p>
      <p>为了结算目的，实际踢出任意球的分钟数才有效，而不是判罚任意球的分钟数。</p>
      <p>示例：尤文图斯对阵国际米兰，从 00:00 分钟到 00:59 分钟任意球</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队将发出任意球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35），至少有一次任意球被发出，则投注获胜。如果在 00:00-00:59 期间没有任意球被发出，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考 ADM 的部长条例。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>中场休息时后场掷界外球 XX.XX - YY.YY</span></p>
      <p>您需要预测在指定的1分钟时间内，任意一队是否会发出球门球。结果可能为2种：是或否。</p>
      <p>为了结算目的，实际开出球门球的分钟数才有效，而不是判罚球的时间。</p>
      <p>示例：尤文图斯对阵国际米兰的球门球从 00:00 分钟到 00:59 分钟</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队都会发出球门球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35），至少发出一个球门球，则投注获胜。如果在 00:00-00:59 期间，没有发出球门球，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考 ADM 的部长条例。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 节中段射出侧球</span></p>
      <p>您需要预测在比赛中，在规定的1分钟内，是否有任何一支球队会掷界外球。结果可能有两种：是或否。</p>
      <p>为了结算，掷球入界的实际时间才有效，而不是判定掷球入界的时间。</p>
      <p>示例：尤文图斯对国际米兰的横向犯规（从 00:00 分钟到 00:59 分钟）</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队都会掷界外球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35 分钟），至少有一个界外球判罚，则投注获胜。如果在 00:00-00:59 期间，没有界外球判罚，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考 ADM 的部长条例。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 节中被判罚点球</span></p>
      <p>您需要预测在比赛的特定1分钟内，任意一队是否会获得点球。结果可能为2种：是或否。</p>
      <p>为了结算投注，将考虑判罚点球的分钟数。</p>
      <p>示例：尤文图斯对阵国际米兰的点球从 00:00 分钟到 00:59 分钟</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队将获得点球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35 分钟），至少判罚一次点球，则投注获胜。如果在 00:00-00:59 期间，没有判罚点球，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考 ADM 的部长条例。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 半场进球</span></p>
      <p>您需要预测在指定的1分钟时间内，任意一支球队是否会进球。结果可能为2种：是或否。</p>
      <p>示例：尤文图斯 - 米兰，从 00:00 分钟到 00:59 分钟进球</p>
      <p>客户投注“是”，因此预测在比赛期间 00:00 至 00:59 分钟内任一队都会进球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35 分钟）至少有一个进球，则投注获胜。如果在 00:00-00:59 期间没有进球，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考一般足球规则。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 节中开出的角球</span></p>
      <p>您必须预测在比赛的特定1分钟内，任意一队是否会获得角球。结果可能为2种：是或否。</p>
      <p>为了结算目的，角球实际被发出的分钟数才有效，而不是角球被判出的时间。</p>
      <p>示例：尤文图斯-那不勒斯角球，从 00:00 分钟到 00:59 分钟</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队将发出角球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35），至少有一个角球，则投注获胜。如果在 00:00-00:59 期间没有角球，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考一般足球规则。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>XX.XX - YY.YY 区间内提取的卡牌</span></p>
      <p>您需要预测在比赛的特定1分钟内，任何一支球队是否会被出示黄牌或红牌。结果可能有两种：是或否。</p>
      <p>为了结算投注，将考虑实际抽牌的时间，而不是犯规的时间。</p>
      <p>示例：NAPLES-INTER 卡从 00:00 分钟到 00:59 分钟</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队都会抽出一张牌。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35），至少出现一张黄牌或红牌，则投注获胜。如果在 00:00-00:59 期间没有出现任何红牌，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考一般足球规则。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 节中任意球</span></p>
      <p>您需要预测在指定的1分钟时间内，任意球是否会由任意球产生。结果可能为2种：是或否。</p>
      <p>为了结算目的，实际踢出任意球的分钟数才有效，而不是判罚任意球的分钟数。</p>
      <p>示例：尤文图斯对阵国际米兰，从 00:00 分钟到 00:59 分钟任意球</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队将发出任意球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35），至少有一次任意球被发出，则投注获胜。如果在 00:00-00:59 期间没有任意球被发出，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考一般足球规则。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>中场休息时后场掷界外球 XX.XX - YY.YY</span></p>
      <p>您需要预测在指定的1分钟时间内，任意一队是否会发出球门球。结果可能为2种：是或否。</p>
      <p>为了结算目的，实际开出球门球的分钟数才有效，而不是判罚球的时间。</p>
      <p>示例：罗马队对阵国际米兰队，从第 00:00 分钟到第 00:59 分钟球门球</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队都会发出球门球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35），至少发出一个球门球，则投注获胜。如果在 00:00-00:59 期间，没有发出球门球，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考一般足球规则。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 节中段射出侧球</span></p>
      <p>您需要预测在比赛中，在规定的1分钟内，是否有任何一支球队会掷界外球。结果可能有两种：是或否。</p>
      <p>为了结算，掷球入界的实际时间才有效，而不是判定掷球入界的时间。</p>
      <p>示例：米兰对阵国际米兰，第 00:00 分钟至第 00:59 分钟横向犯规</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队都会掷界外球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35 分钟），至少有一个界外球判罚，则投注获胜。如果在 00:00-00:59 期间，没有界外球判罚，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考一般足球规则。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>第 XX.XX 至 YY.YY 节中被判罚点球</span></p>
      <p>您需要预测在比赛的特定1分钟内，任意一队是否会获得点球。结果可能为2种：是或否。</p>
      <p>为了结算投注，将考虑判罚点球的分钟数。</p>
      <p>示例：尤文图斯对阵国际米兰的点球从 00:00 分钟到 00:59 分钟</p>
      <p>客户投注“是”，从而预测在 00:00 至 00:59 之间的比赛期间，任一队将获得点球。</p>
      <p>如果在 00:00-00:59 期间（例如，官方时钟显示 00:35 分钟），至少判罚一次点球，则投注获胜。如果在 00:00-00:59 期间，没有判罚点球，则投注失败。</p>
      <p>结果认证以活动组织者提供的官方数据为准。</p>
      <p>如果比赛暂停或中断，则参考一般足球规则。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}>一般说明</span></p>
      <p>在任何情况下，以及任何未明确注明的市场，均适用以下规则：第一分钟是从开球到 00:59 的分钟……第二分钟是从 01:00 到 01:59 的分钟，以此类推。如果明确注明分钟和秒，则参考市场中指定的时间范围。</p>
      <br />

      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>购物篮</span></span></p>
      <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
      <p>投注是通过选择以下两个选项之一来预测比赛的最终结果：</p>
      <p>我标记主队胜利 1 次；我标记客队胜利 2 次。</p>
      <p>有效结果是比赛结束时获得的结果（包括任何加时赛）。</p>
      <p>示例：</p>
      <p>波士顿 - 多伦多 98-90：获胜结果：1</p>
      <p>波士顿 - 多伦多 92-95：获胜结果：2</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘</span></p>
      <p>投注是通过选择以下两个选项之一来预测比赛的最终结果：</p>
      <p>签 1 为主队获胜；签 2 为客队获胜，考虑到最受欢迎的球队已被分配了一个让分，出于投注目的，该让分将从比赛结束时在场上取得的结果中扣除。</p>
      <p>有效结果是比赛结束时获得的结果（包括任何加时赛）</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 1° 时间</span></p>
      <p>此投注预测哪支球队将赢得比赛上半场，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑上半场的得分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘 2° 时间</span></p>
      <p>本投注预测哪支球队将赢得比赛下半场，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑下半场的得分，不考虑加时赛的得分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 1° 第四</span></p>
      <p>此投注预测哪支球队将赢得比赛的第一节，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑第一节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 2° 第四</span></p>
      <p>此投注预测哪支球队将赢得比赛的第二节，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑第二节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 3° 第四</span></p>
      <p>此投注预测哪支球队将赢得比赛的第三节，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑第三节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 4° 第四</span></p>
      <p>此投注预测哪支球队将赢得比赛的第四节，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑第四节的得分，不考虑加时赛的得分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T &ndash; X/Quarter</span></p>
      <p>投注内容是预测比赛特定节的最终结果。</p>
      <p>如果选择 1，则预测第一个被推荐的球队获胜；如果选择 2，则预测第二个被推荐的球队获胜。如果平局，则投注将退还。</p>
      <p>对于第一节之后的比赛，该节的赛果将用于投注认证。如果比赛暂停，与该节或未结束的节相关的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 5pt 边距</span></p>
      <p>投注是根据以下方法预测比赛的最终结果：</p>
      <p>1 场主队获胜且分差大于 5 分；</p>
      <p>X 表示其中一支球队的胜利，且分差不超过 5 分；</p>
      <p>客队以2比5领先且分差大于5分的成绩获胜；</p>
      <p>有效结果是比赛结束时获得的结果（包括任何加时赛）。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 赛前 - 直播</span></p>
      <p>该投注采用传统的 1X2 方法预测常规时间结束时比赛的最终结果：</p>
      <p>签1主队获胜；</p>
      <p>X 符号绘制；</p>
      <p>签下 2 支客队胜利。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 1°时间</span></p>
      <p>此投注用于预测上半场比赛的结果。提供三种可能的结果：1（主队领先）、2（客队领先）、X（上半场比赛结束时两队打平）。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 2°时间</span></p>
      <p>此投注预测比赛下半场的结果。提供三种可能的结果：1（主队领先）、2（客队领先）、X（下半场结束时两队打平）。投注仅考虑下半场的比分，不考虑加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 第一节（不弃牌）</span></p>
      <p>此投注用于预测比赛第一节的结果。提供三种可能的结果：1（主队领先）、2（客队领先）、X（第一节结束时两队打平）。投注仅考虑第一节的比分。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 第二节（不弃牌）</span></p>
      <p>此投注用于预测比赛第二节的结果。提供三种可能的结果：1（主队领先）、2（客队领先）、X（比赛第二节结束时两队打平）。投注仅考虑比赛第二节的比分。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 第三节（无弃牌）</span></p>
      <p>此投注用于预测比赛第三节的结果。提供三种可能的结果：1（主队领先）、2（客队领先）、X（第三节结束时两队打平）。投注仅考虑第三节的比分。</p>
      <p><span style={{ color: "#ff0000" }}>第 4 节 1X2（不弃牌）</span></p>
      <p>此投注预测比赛第四节的结果。提供三种可能的结果：1（主队领先）、2（客队领先）、X（第四节结束时两队打平）。投注仅考虑第四节的比分，不考虑加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>1X2&ndash; X/Quarter (差价 2.5)</span></p>
      <p>投注内容是预测比赛特定节的最终结果。</p>
      <p>如果使用 1 符号，则预测第一个被提议的球队将以大于 2 分的分差获胜；如果使用 2 符号，则预测第二个被提议的球队将以大于 2 分的分差获胜；如果使用 X 符号，则预测该队将打平或分差小于或等于 2 分。</p>
      <p>对于第一节之后的比赛，该节的赛果将用于投注认证。如果比赛暂停，与该节或未结束的节相关的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>U/O 积分 3 个选择（常规时间）</span></p>
      <p>您必须预测比赛结束时两队的得分总和是低于预设参数、高于预设参数还是恰好等于预设参数。投注仅考虑常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于分数（包括加时赛）（也包括现场直播）</span></p>
      <p>本投注预测比赛结束时两队得分总和是低于（低于预设参数）还是高于（高于预设参数）。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>上半场得分大小</span></p>
      <p>投注内容是预测比赛上半场两队的得分总和是否低于（低于预设点差）或高于（高于预设参数）。</p>
      <p><span style={{ color: "#ff0000" }}>下半场得分大小</span></p>
      <p>投注内容是预测比赛下半场两队的得分总和是否低于（低于预设点差）或高于（高于预设参数）。</p>
      <p><span style={{ color: "#ff0000" }}>第一节得分低于/高于</span></p>
      <p>该投注预测比赛第一节两队的得分总和是否低于（低于预设点差）或高于（高于预设参数）。</p>
      <p><span style={{ color: "#ff0000" }}>第二节得分低于/高于</span></p>
      <p>该投注预测比赛第二节两队的得分总和是否低于（低于预设点差）或高于（高于预设参数）。</p>
      <p><span style={{ color: "#ff0000" }}>第三节得分低于/高于</span></p>
      <p>该投注预测一场比赛第三节中两队的得分总和是低于（低于预设点差）还是高于（高于预设参数）。</p>
      <p><span style={{ color: "#ff0000" }}>第 4 节得分低于/高于</span></p>
      <p>该投注预测一场比赛第 4 节中两队的得分总和是低于（低于预设点差）还是高于（高于预设参数）。</p>
      <p>出于投注目的，仅考虑比赛第 4 节的得分，不考虑任何加时赛的得分。</p>
      <p><span style={{ color: "#ff0000" }}>主队得分低于/高于（包括加时赛）（也直播）</span></p>
      <p>本投注预测比赛结束时，甲队总得分是低于（低于预设参数）还是高于（高于预设参数）。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>客队得分低于/高于（包括加时赛）（也直播）</span></p>
      <p>本投注预测比赛结束时第二队的得分总和是低于（低于预设参数）还是高于（高于预设参数）。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>上半场主队得分低于/高于</span></p>
      <p>该投注预测第一队在比赛上半场的总得分是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>客队上半场得分低于/高于</span></p>
      <p>该投注预测球队 2 在比赛上半场的总得分是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>第一节主队得分低于/高于</span></p>
      <p>该投注预测第一队在比赛第一节的总得分是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>第一节客场得分大小</span></p>
      <p>该投注预测第 2 队在比赛第一节的总得分是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>奇数/偶数（包括加时赛）</span></p>
      <p>此投注预测比赛结束时两队总得分是单数还是双数。加时赛也适用于投注。</p>
      <p><span style={{ color: "#ff0000" }}>上半场单/双</span></p>
      <p>本投注预测比赛上半场两队总得分为单数还是双数。投注仅考虑上半场的得分。</p>
      <p><span style={{ color: "#ff0000" }}>下半场单/双</span></p>
      <p>本投注预测比赛下半场两队总得分为单数还是双数。投注仅考虑下半场的得分，不考虑加时赛的得分。</p>
      <p><span style={{ color: "#ff0000" }}>主队单/双分数（含加时赛）</span></p>
      <p>该投注用于预测一场比赛（包括加时赛）中球队 1 的得分总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>奇数/偶数客队积分（包括加时赛）</span></p>
      <p>该投注用于预测比赛（包括加时赛）期间第 2 队得分的总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>奇数/偶数 &ndash; X/四分之一</span></p>
      <p>该投注预测比赛某一节中两支球队的得分总和是偶数还是奇数。</p>
      <p>如果比赛暂停，与未结束的一节或多节比赛相关的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>1°时间/决赛</span></p>
      <p>本投注旨在预测比赛期间，上半场获胜方和全场获胜方的准确组合。投注仅考虑常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 结果 + U/O 分数（包括加时赛）</span></p>
      <p>该投注同时预测比赛胜负，以及两队总分将高于还是低于预设指数。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>最高分季度</span></p>
      <p>投注内容是预测比赛哪一节得分最多，将两队的得分相加。将提供 5 种可能的结果：第一节、第二节、第三节、第四节（不包括加时赛）和平局，平局是指所有节的得分相同，或两个或多个节的得分相同且高于其他节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>加时赛是/否</span></p>
      <p>此投注预测比赛是否会进入加时赛。如果常规时间结束时比分相同，则比赛进入加时赛，因此胜负结果为“是”。如果第四节结束时比分已分出胜负，则不会进行加时赛，因此胜负结果为“否”。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 直播</span></p>
      <p>投注是通过选择以下两个选项之一来预测比赛的最终结果：</p>
      <p>我签下 1 个主队获胜；我签下 2 个客队获胜。</p>
      <p>有效结果是比赛结束时获得的结果（包括任何加时赛）。</p>
      <p><span style={{ color: "#ff0000" }}>现场积分低于/高于</span></p>
      <p>本投注预测比赛结束时，甲队总得分是低于（低于预设参数）还是高于（高于预设参数）。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>现场客队得分低于/高于</span></p>
      <p>本投注预测比赛结束时第二队的得分总和是低于（低于预设参数）还是高于（高于预设参数）。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>实时分数低于/高于</span></p>
      <p>本投注预测比赛结束时两队得分总和是低于（低于预设参数）还是高于（高于预设参数）。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于分数 2° 实时节奏</span></p>
      <p>本投注预测比赛下半场两队得分总和是否低于（低于预设让分）或高于（高于预设参数）。任何加时赛也计入投注。</p>
      <p><span style={{ color: "#ff0000" }}>单/偶实时赔率</span></p>
      <p>此投注预测比赛结束时两队总得分是单数还是双数。加时赛也适用于投注。</p>
      <p><span style={{ color: "#ff0000" }}>下半场奇数/偶数直播</span></p>
      <p>本投注预测比赛下半场两队总得分为单数还是双数。下半场（包括加时赛）的比分将计入投注结果。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 2° 实时速度</span></p>
      <p>本投注预测比赛下半场的结果。提供三种可能的结果：1（主队领先）、2（客队领先）、X（下半场结束时两队打平）。投注将考虑下半场的比分，包括加时赛的比分。</p>
      <p><span style={{ color: "#ff0000" }}>点 n&deg; x 获胜</span></p>
      <p>您必须预测哪支球队将率先得分，具体分数由所提供的各种让分盘口决定。</p>
      <p>加时赛也将被视为投注目的。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>注意</span></p>
      <p><span style={{ color: "#ff0000" }}>在 NBA 直播比赛中，出于礼貌和好客的原因，球队的排列顺序是相反的，即客队排在第一位。</span></p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>篮球特辑</span></span></p>
      <p><span style={{ color: "#ff0000" }}>1X2 标记</span></p>
      <p>该投注预测在特定比赛中，两名球员中哪一人得分更高。投注结果有三种可能：标有“1”表示预测第一个被推荐的球员得分最高；标有“2”表示预测第二个被推荐的球员得分最高；标有“X”表示预测两名被推荐的球员得分相同。如果两名球员中的一人或两人均未踏上比赛场地（未进入场地），则投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>三分球命中数低于/高于的球员</span></p>
      <p>本投注预测特定球员在特定比赛中的三分球命中数是高于还是低于特定值。任何加时赛也将被计入比赛结果。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>球员得分低于/高于</span></p>
      <p>本投注预测特定球员在特定比赛中的总得分是高于（大于）还是低于（小于）给定让分。加时赛的得分也计入投注范围。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>球员篮板球低于/高于</span></p>
      <p>此投注预测特定球员在特定比赛中获得的篮板总数。任何加时赛也将被计入报告。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>助攻球员低于/高于</span></p>
      <p>此投注预测特定球员在特定比赛中的助攻总数。任何加时赛也将被计入报告。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>玩家加倍加倍是/否</span></p>
      <p>本投注预测某位球员在比赛中是否能取得“两双”（在两项主要统计数据中至少达到10分：得分、篮板、助攻、盖帽、抢断）。如果该球员在超过两项统计数据中至少达到10分，则市场结果为“是”。加时赛期间的任何进球也适用于投注。如果该球员未上场，所有投注将被退还。</p>
      <p><br /> </p>
      <p><span style={{ color: "#c00000" }}>玩家三双是/否</span></p>
      <p>本投注预测某位特定球员在比赛中是否能获得三双（在得分、篮板、助攻、盖帽、抢断、抢断这三项统计中至少获得10分）。如果该球员在超过3项统计中至少获得10分，则该投注结果为“是”。加时赛期间的任何进球也将被计入投注。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>总得分+篮板+球员助攻低于/高于</span></p>
      <p>本投注预测特定球员在特定比赛中的得分、篮板和助攻总数是高于还是低于特定值。任何加时赛也将被计入比赛结果。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>U/O 失误</span></p>
      <p>本投注预测比赛结束时双方失球总数是大于（大于）还是小于（小于）某个数值。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#c00000" }}>U/O 篮板 + 球员盖帽</span></p>
      <p>您必须预测特定球员在特定比赛中的盗球和拦网总数是大于还是小于某个数值。任何加时赛也将被计入报告范围。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>U/O 球员抢断</span></p>
      <p>您必须预测特定球员在特定比赛中的盗球次数是大于还是小于某个数值。任何加时赛也将被计入报告范围。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>U/O 玩家方块</span></p>
      <p>您必须预测特定球员在特定比赛中阻挡的球数是大于还是小于特定值。任何加时赛也将被计入报告。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>U/O 球员丢球</span></p>
      <p>该投注预测特定球员在特定比赛中丢球总数是高于（大于）还是低于（小于）某个数值。任何加时赛也将被计入报告。如果该球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>连胜得分+助攻+篮板</span></p>
      <p>投注内容是预测特定球员在特定比赛中获得的得分、篮板和助攻总数是高于还是低于某个值。</p>
      <p>任何额外的时间也将被计入报告目的。</p>
      <p>如果该球员没有上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>组合 Puntii+ 辅助</span></p>
      <p>投注内容是预测特定球员在特定比赛中获得的总分数和助攻数是高于还是低于某个值。</p>
      <p>任何额外的时间也将被计入报告目的。</p>
      <p>如果该球员没有上场，所有投注将被退还</p>
      <p><span style={{ color: "#c00000" }}>连击点数 + 篮板</span></p>
      <p>投注内容是预测特定球员在特定比赛中获得的总分数和篮板数是高于还是低于某个值。</p>
      <p>任何额外的时间也将被计入报告目的。</p>
      <p>如果该球员没有上场，所有投注将被退还</p>
      <p><span style={{ color: "#c00000" }}>点 1&deg; 第四</span></p>
      <p>投注内容是预测特定球员在第一节所得分的总和是否高于（大于）或低于（小于）所示的特定小数值 X。</p>
      <p>如果球员未上场或未参加该节比赛，所有投注将被退还。</p>
      <p>就报告而言，以组织机构通报的内容为准。任何未提及的内容，均以现行规定为准。</p>
      <p><span style={{ color: "#c00000" }}>助攻 1° 第四</span></p>
      <p>投注内容是预测特定球员在第一节的助攻总数是高于（大于）还是低于（小于）指定的特定小数值 X。</p>
      <p>如果球员未上场或未参加该节比赛，所有投注将被退还。</p>
      <p>就报告而言，以组织机构通报的内容为准。任何未提及的内容，均以现行规定为准。</p>
      <p><span style={{ color: "#c00000" }}>篮板 1° 第四</span></p>
      <p>此投注用于预测特定球员在第一节所抓到的篮板总数是高于（大于）还是低于（小于）指定的特定小数值 X。</p>
      <p>如果球员未上场或未参加该节比赛，所有投注将被退还。</p>
      <p>就报告而言，以组织机构通报的内容为准。任何未提及的内容，均以现行规定为准。</p>
      <p><br /> </p>
      <p><span style={{ color: "#c00000" }}><span style={{ fontSize: "large" }}>网球 / 网球直播</span></span></p>
      <p>如果一名球员在比赛前或比赛期间退赛（或被取消资格），则该比赛的所有投注将无效。所有已得出结果的投注除外，并将根据赛场上取得的成绩（例如，第一盘胜/负第一盘胜/负第一盘胜等）进行更新。否则，所有未获得明确结果的投注将无效，包括正面交锋记录。但是，在现场比赛中，所有截至退赛时获得的结果都将被报告，所有未获得明确结果的投注将无效，包括正面交锋记录。如果一名球员在其首场比赛前退赛，则与该球员的锦标赛冠军或晋级下一轮相关的投注将被视为无效，在其他情况下，投注将被视为有效。如果双打比赛中，四名选手中至少有一名在比赛开始前退出，而他的搭档决定与另一名选手一起参加比赛，则该赛事的所有投注将无效。</p>
      <p><span style={{ color: "#c00000" }}>正面交锋结果</span></p>
      <p>该赌注预测哪位网球选手将赢得比赛：</p>
      <p>表示网球选手“1”的胜利</p>
      <p>表示网球选手“2”的胜利</p>
      <p><span style={{ color: "#c00000" }}>HH 套装</span></p>
      <p>你必须预测哪位网球运动员将赢得参考组。</p>
      <p>如果比赛盘因两名网球运动员中的一人退出而未能开始或结束，则与该盘比赛本身相关的所有结果均视为无效。</p>
      <p><span style={{ color: "#c00000" }}>盘口投注</span></p>
      <p>投注内容是预测比赛结束时的准确比分（以局数表示）。</p>
      <p><span style={{ color: "#c00000" }}>获胜者 1&deg; 组</span></p>
      <p>该投注旨在预测哪位网球选手将赢得第一盘比赛。</p>
      <p><span style={{ color: "#c00000" }}>大小比赛</span></p>
      <p>投注内容是预测在某个事件结束时，总局数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#c00000" }}>对于上述投注，如果事件未发生或明确中断，且尚未取得可证明的投注结果，则投注金将被退还。</span></p>
      <p><span style={{ color: "#c00000" }}>如果比赛规则规定，决胜盘在出现平局时采用超级抢七计分系统，则与大多数双打比赛一样，为了报告结果，该盘将完全计为 1 局。</span></p>
      <p><br /> </p>
      <p><span style={{ color: "#c00000" }}>设置数字 2/3</span></p>
      <p>你需要预测三局两胜制比赛中两位选手的总局数。可能的结果是：“2”（比赛将以 2 局结束）和“3”（比赛将以 3 局结束）。</p>
      <p><span style={{ color: "#c00000" }}>设置编号 3/5</span></p>
      <p>你需要预测五局三胜制比赛中两位选手的总局数。可能的结果是：“3”（比赛将以 3 局结束）、“4”（比赛将以 4 局结束）和“5”（比赛将以 5 局结束）。</p>
      <p><span style={{ color: "#c00000" }}>决胜盘 1 是/否</span></p>
      <p>您必须预测所选比赛的第一盘比赛是否会以抢七局决出胜负。结果有两种：是；否。如果该盘比赛未进行或永久中断，投注将被退还，除非该盘比赛比分未达到 6-6，在这种情况下，获胜结果为“是”。</p>
      <p><span style={{ color: "#c00000" }}>精确结果集 1</span></p>
      <p>您必须预测所选比赛第一盘的准确结果（以局数计算）。如果该盘未进行或永久中断，投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>一对一让分比赛</span></p>
      <p>您必须将投注中指示的让分差应用到最终比赛结果中，以预测比赛的获胜者。</p>
      <p>注意：如果比赛规则规定，决胜盘在出现平局时采用超级抢七计分系统，则与大多数双打比赛一样，为了报告结果，该盘将完全计为 1 局。</p>
      <p><span style={{ color: "#c00000" }}>至少有一盘 6-0 或 0-6</span></p>
      <p>此投注预测一场比赛是否会以至少一盘0-6或6-0的比分结束。如果事件未发生或最终中断，且尚未出现任何可确定的投注结果，则投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>长盘/抢七直播</span></p>
      <p>预测所有盘数均已进行（3 或 5 盘），并且最后一盘将以 6-6 的比分结束。</p>
      <p><span style={{ color: "#c00000" }}>大小场次 1&deg; 盘</span></p>
      <p>投注内容为预测某项赛事首盘结束时，总局数是高于还是低于预设的分差。如果赛事未发生或最终中断，且尚未出现任何可确定的投注结果，则投注将被退还。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#c00000" }}>玩家 1 的大小局比赛</span></p>
      <p>投注内容为预测在某项赛事结束时，玩家 1 获胜的总局数是高于还是低于预设的差距。如果赛事未发生或最终中断，且尚未取得任何可确定的投注结果，则投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>大小比赛玩家 2</span></p>
      <p>投注内容为预测在某项赛事结束时，选手 2 获胜的总局数是高于还是低于预设的差距。如果赛事未发生或最终中断，且尚未取得任何可确定的投注结果，则投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>设置让分</span></p>
      <p>您必须将投注中指示的盘口让分应用到最终盘数结果中，以预测比赛的获胜者。</p>
      <p>如果网球运动员在比赛前或比赛期间退赛，则接受的盘口投注将被退还，除非结果可证实。</p>
      <p><span style={{ color: "#c00000" }}>1X2 让分盘</span></p>
      <p>您必须预测比赛结果，提供1X2结果，并在比赛结束时计算投注中指定的比赛让分。如果网球运动员在上场前或比赛期间退赛，则1X2让分盘比赛的投注将被退还，除非结果可确认。</p>
      <p><span style={{ color: "#c00000" }}>赢得至少一局</span></p>
      <p>您必须预测所选选手在比赛结束时是否会赢得至少一局比赛。</p>
      <p>如果网球运动员在比赛前或比赛期间退赛，则赢得至少一盘的投注将被退还，除非结果可证实。</p>
      <p><span style={{ color: "#c00000" }}>第 X 盘比赛中获胜的场次少于/超过</span></p>
      <p>您必须预测优势赛中获胜的总局数。结果有两种：大于或小于。如果网球选手在进入球场前或第X局比赛中退赛，则除非结果可确认，否则第X局中获胜的小于/大于局的投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>X 局 Y 局精确比分</span></p>
      <p>您必须预测指定特定比赛的准确结果。结果如下：1号选手0-0获胜，1号选手1-15获胜，1号选手30-30获胜，1号选手领先；2号选手0-0获胜；2号选手15-30获胜；2号选手领先。如果网球运动员在进入球场前或在Y盘X局比赛中退赛，则对X局Y局准确结果的投注将被退还，除非结果可确认。</p>
      <p><span style={{ color: "#c00000" }}>获胜组合 + 小于/大于</span></p>
      <p>您必须同时预测比赛的胜负，以及双方球员的总局数是高于还是低于预设的指数。如果事件未发生或最终中断，且“大小局”市场尚未出现可确定的投注结果，则投注将被退还。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>田径</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>在田径比赛中，只允许投注获胜者，即预测在已公布名单中的运动员中，哪一位将赢得比赛。</p>
      <p>注意：如果公布名单中的运动员未参加比赛或在比赛中退出，则对他的投注将被视为失败，因此不予退款。</p>
      <p>如果 2 名或 2 名以上的运动员成绩相同，则获胜者的份额必须除以第一名完成比赛的选手人数。</p>
      <p>示例：</p>
      <p>两名运动员并列完成比赛，赔率分别为 2.20 和 3.00。</p>
      <p>赔率将除以 2，因此分别变为 1.10 和 1.50。</p>
      <p><span style={{ color: "#ff0000" }}>奥运冠军</span></p>
      <p>它包括在已公布名单中的队伍中预测哪支队伍将赢得金牌。</p>
      <p>注意：如果已公布名单中的某支球队未参加比赛或在比赛期间退出，则对该球队的投注将被视为失败，因此投注将不予退还。</p>
      <p>如果两支或两支以上的队伍成绩相同，则获胜者的份额必须除以第一名完成比赛的参赛者人数。</p>
      <p>示例：两支球队的比分分别为 2.20 和 3.00。</p>
      <p>赔率将除以 2，因此分别变为 1.10 和 1.50。</p>
      <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
      <p>该投注用于预测某位运动员是否会在特定比赛或赛事中名列前三。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>投注内容是预测在两个提议之间，根据比赛/赛事结束时的排名，哪位运动员或队伍将取得最佳名次。</p>
      <p>注意：投注的有效性取决于参与两种结果的比赛，以及至少有一种结果在同一场比赛中结束。否则，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>小组冠军</span></p>
      <p>投注内容是预测在列表中列出的运动员或团队中，哪个将根据比赛/赛事结束时的排名获得最佳名次。</p>
      <p>如果公布名单中的运动员或队伍没有参赛或退出比赛，则对他的投注将被视为失败，因此不予退款。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>羽毛球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>奥运冠军</span></p>
      <p>它包括在已公布名单中的队伍中预测哪支队伍将赢得金牌。</p>
      <p>注意：如果已公布名单中的队伍未参赛或在比赛中途退赛，则该队伍的投注将被视为输注，且投注金不予退还。如果两支或两支以上队伍并列，则获胜赔率必须除以先到达的参赛人数。</p>
      <p>示例</p>
      <p>两队比分分别为 2.20 和 3.00 平。</p>
      <p>赔率将除以 2，因此分别变为 1.10 和 1.50。</p>
      <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
      <p>投注内容是预测某个运动员或团队是否会在特定比赛或赛事中名列前三。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>投注内容是预测在两个提议之间，根据比赛/赛事结束时的排名，哪位运动员或队伍将取得最佳名次。</p>
      <p>注意：投注的有效性取决于参与两种结果的比赛，以及至少有一种结果在同一场比赛中结束。否则，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
      <p>投注内容是预测在列表中列出的运动员或团队中，哪个将根据比赛/赛事结束时的排名获得最佳名次。</p>
      <p>如果公布名单中的运动员或队伍没有参赛或退出比赛，则对他的投注将被视为失败，因此不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
      <p>投注是通过从列表中排除某个特定结果来预测在比赛或体育赛事中排名第一的运动员或队伍。</p>
      <p>如果公布名单中的运动员或参赛队伍未参赛或在比赛中途退赛，则针对该运动员或参赛队伍的投注将被视为失败，且不予退款。如果公布名单中未包含所有可能的结果，则“其他”选项将始终包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者是/否</span></p>
      <p>投注内容是预测拟议的运动员或团队是否会赢得（是结果）或不会赢得（否结果）某场比赛/赛事</p>
      <p><span style={{ color: "#ff0000" }}>U/O Ori</span></p>
      <p>您必须预测特定运动员或团队赢得的金牌总数是否会低于（低于）或高于（高于）设定的限额。</p>
      <p><span style={{ color: "#ff0000" }}>U/O 奖牌</span></p>
      <p>您必须预测特定运动员或团队赢得的奖牌总数（金牌、银牌和铜牌）是否会低于（低于）或高于（高于）设定的限制。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋第一组</span></p>
      <p>该投注用于预测哪位选手将赢得比赛的第一盘。</p>
      <p>如果一名网球选手在一盘比赛中退赛，则对该网球选手的投注将被视为输掉；反之，如果一名网球选手在一盘比赛开始前退赛，则投注将被退还</p>
      <p><span style={{ color: "#ff0000" }}>投注额设为 3</span></p>
      <p>您必须预测特定比赛的准确结果（以盘数计算）。如果比赛未进行或永久中断，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>投注设置为 5</span></p>
      <p>您必须预测特定比赛的准确结果（以盘数计算）。如果比赛未进行或永久中断，投注将被退还。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>BANDY</span></span></p>
      <p><span style={{ color: "#ff0000" }}>1X2</span></p>
      <p>投注内容是预测比赛结果，不包括加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>该投注旨在预测在特定锦标赛中哪支球队将获得第一名。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>棒球</span></span></p>
      <p>对于棒球投注，有效结果是比赛结束时获得的结果，包括任何加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
      <p>该投注预测哪支球队将在任何加时赛结束时赢得比赛：</p>
      <p>1. 表示主队胜利；</p>
      <p>2. 表示客队胜利。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘</span></p>
      <p>投注内容是预测在任何加时赛结束时哪支球队将赢得比赛，同时考虑分配给两支球队之一的让分（以分数表示）。</p>
      <p>投注结果的确定方法是从被分配了让分的球队在场上取得的得分中减去让分值。</p>
      <p>示例 A</p>
      <p>纽约 - 洛杉矶 15-8（纽约让 5.5 分）</p>
      <p>获胜结果 1（15 - 5.5 = 10.5 –&gt; 最终结果 10.5 - 8 因此为 1）</p>
      <p>示例 B</p>
      <p>纽约 – 洛杉矶 15 – 12（纽约让 5.5 分）</p>
      <p>获胜结果 2（15 - 5.5 = 9.5 –&gt; 最终结果 9.5 - 12 因此为 2）</p>
      <p><span style={{ color: "#ff0000" }}>1X2（不包括加时赛）</span></p>
      <p>本投注采用传统的1X2投注方式，预测比赛结果。任何加时赛均不参与投注。</p>
      <p><span style={{ color: "#ff0000" }}>T/T + 大小/大（包括加时赛）</span></p>
      <p>该投注同时预测比赛胜负，以及两队总得分是高于还是低于预设指数。任何加时赛也将被纳入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>小/大</span></p>
      <p>投注内容是预测一场比赛的总得分是否会超过预先设定的限额（从 6.5 到 12.5）。</p>
      <p>在低于假设的情况下，预测比赛的最高得分为 6、7、8……12；在高于假设的情况下，预测两队得分总和等于或大于 7、8、9……13。有效结果是任何加时赛（延长局）结束时的结果。</p>
      <p><span style={{ color: "#ff0000" }}>球队 1 低于/高于</span></p>
      <p>该投注预测的是第一队在一场比赛中获得的总分数。任何加时赛也将被计入报告的得分范围。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 2 队</span></p>
      <p>该投注预测的是第 2 队在比赛中获得的总分数。任何加时赛也将被计入报告的得分范围。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 1° 局</span></p>
      <p>该投注根据传统的 1x2 方法预测哪支球队赢得第一局。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 1&deg; 局</span></p>
      <p>该投注预测比赛第一局中两队的得分总和是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>5 局后 1X2</span></p>
      <p>此投注预测第五局结束时的比赛结果。如果比赛在第五局结束前中断或延期，则适用ADM规则。</p>
      <p><span style={{ color: "#ff0000" }}>5 局后低于/高于</span></p>
      <p>此投注预测第五局结束时比赛比分是否会高于或低于特定让分。如果比赛在未完成前五局的情况下直接中断，且未取得可确认的结果，则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>胜利边缘带</span></p>
      <p>该投注预测在任何加时赛结束时两支球队中哪一支将赢得比赛的分数差。</p>
      <p><span style={{ color: "#ff0000" }}>加时局是/否</span></p>
      <p>该投注预测比赛是否将以加时赛结束。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数</span></p>
      <p>该投注预测在任何加时赛结束时两队所得分数的总和是奇数还是偶数。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>沙滩足球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>投注包括预测哪支球队将赢得某项锦标赛或哪位球员将赢得某个排名。</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
      <p>此投注预测常规时间（不包括加时赛）结束时的结果。可能的结果是 1（主队获胜）、X（平局）和 2（客队获胜）。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 x,5</span></p>
      <p>您必须预测比赛期间常规时间内的总进球数是高于（大于）还是低于（小于）所提供的让分盘口。加时赛除外。</p>
      <p><span style={{ color: "#ff0000" }}>头对头让分盘</span></p>
      <p>本投注预测常规时间（不包括加时赛）结束时哪支球队领先。结果将根据所选球队的总进球数加上让分盘口得出。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>沙滩排球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>实时得分低于/高于</span></p>
      <p>投注内容是预测比赛结束时的最终得分总和（因此将所玩盘数累积的所有得分相加）是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>底线/线迹设置 1</span></p>
      <p>投注内容是预测第一局比赛的最终得分是低于还是高于某个值。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p>示例：</p>
      <p>客户投注第二局比赛得分超过38.5分。如果该局比赛以21-18结束，则投注获胜，因为该局总得分为39分。如果该局比赛以21-15结束，则投注失败，因为该局总得分为36分。</p>
      <p><span style={{ color: "#ff0000" }}>底线/线迹设置 2</span></p>
      <p>投注内容是预测第二组比赛的最终得分是低于还是高于某个值。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p>示例：</p>
      <p>客户投注第二局比赛得分超过38.5分。如果该局比赛以21-18结束，则投注获胜，因为该局总得分为39分。如果该局比赛以21-15结束，则投注失败，因为该局总得分为36分。</p>
      <p><span style={{ color: "#ff0000" }}>底线/线迹设置 3</span></p>
      <p>投注内容是预测第三局比赛的最终得分是低于还是高于某个值。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p>示例：</p>
      <p>客户投注第二局比赛得分超过38.5分。如果该局比赛以21-18结束，则投注获胜，因为该局总得分为39分。如果该局比赛以21-15结束，则投注失败，因为该局总得分为36分。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于会面点</span></p>
      <p>投注内容是预测比赛结束时的最终得分总和（因此将所玩盘数累积的所有得分相加）是低于还是高于某个值。</p>
      <p>示例：</p>
      <p>这里有一个示例，其中值 [n] 为 92.5：</p>
      <p>客户投注比赛得分超过92.5分。如果比赛以21-19、17-21和15-12结束，则投注获胜，因为比赛总得分为105分。如果比赛以21-8、12-21和15-8结束，则投注失败，因为比赛总得分为85分。</p>
      <p><span style={{ color: "#ff0000" }}>奇偶设置 1</span></p>
      <p>本市场预测第一局比赛的总得分是“单数”还是“双数”。因此，市场预测的结果有两种。总分将根据该局比赛双方的得分计算得出。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p>示例：</p>
      <p>客户投注第二盘总分“单”。如果第二盘比赛结果为21-16，则该投注为赢，因为第二盘总分是37分。如果投注“双”，则该投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>奇偶设置 2</span></p>
      <p>本市场预测第二局比赛的总得分是“单数”还是“双数”。因此，市场预测的结果有两种。总分将根据该局比赛双方的得分计算得出。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p>示例：</p>
      <p>客户投注第二盘总分“单”。如果第二盘比赛结果为21-16，则该投注为赢，因为第二盘总分是37分。如果投注“双”，则该投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>奇偶设置 3</span></p>
      <p>本市场预测第三局比赛的总得分是“单数”还是“双数”。因此，市场预测的结果有两种。总分将根据该局比赛两队的得分计算。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p>示例：</p>
      <p>客户投注第二盘总分“单”。如果第二盘比赛结果为21-16，则该投注为赢，因为第二盘总分是37分。如果投注“双”，则该投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>现场对决</span></p>
      <p>你必须预测一场比赛的获胜者。</p>
      <p><span style={{ color: "#ff0000" }}>头对头让分直播</span></p>
      <p>您需要将投注中指定的让分盘口与两队最终总得分相结合，预测比赛的胜负。弱势球队将获得正让分，而强势球队将获得负让分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T SET 1 HANDICAP</span></p>
      <p>此盘口预测在第一盘比赛中，选定球队的得分将应用给定让分[n]后，每支球队的得分。此盘口有两种可能的结果。</p>
      <p>[n] 的值在不同比赛中会有所不同，代表分配给弱势球队的优势分数。弱势球队将获得正让分，而强势球队将获得负让分。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p>示例：</p>
      <p>客户投注意大利队在第二盘让分-3.5分。如果意大利队以21-17赢得第二盘，则投注为赢，因为应用让分后，意大利队以17.5比17获胜。如果意大利队以21-18获胜，则投注为输，因为应用让分后，意大利队以17.5比18输掉比赛。</p>
      <p><span style={{ color: "#ff0000" }}>T/T SET 2 HANDICAP</span></p>
      <p>此盘口预测在第二盘比赛中，选定球队的得分将应用给定让分[n]后，每支球队的得分。此盘口有两种可能的结果。</p>
      <p>[n] 的值在不同比赛中会有所不同，代表分配给弱势球队的优势分数。弱势球队将获得正让分，而强势球队将获得负让分。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p>示例：</p>
      <p>客户投注意大利队在第二盘让分-3.5分。如果意大利队以21-17赢得第二盘，则投注为赢，因为应用让分后，意大利队以17.5比17获胜。如果意大利队以21-18获胜，则投注为输，因为应用让分后，意大利队以17.5比18输掉比赛。</p>
      <p><span style={{ color: "#ff0000" }}>T/T SET 3 HANDICAP</span></p>
      <p>此盘口预测在第三盘比赛中，将给定的让分[n]应用于所选球队的得分后，每支球队的得分。此盘口有两种可能的结果。</p>
      <p>[n] 的值在不同比赛中会有所不同，代表分配给弱势球队的优势分数。弱势球队将获得正让分，而强势球队将获得负让分。</p>
      <p>如果该盘比赛未进行，则投注无效。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>冬季两项</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>赌注包括预测哪位滑雪运动员将赢得单场比赛或特定赛事。</p>
      <p>注意：如果名单中的运动员或队伍未参加比赛，或在比赛期间因任何原因退出比赛，则对该特定运动员或队伍的投注将被视为失败，并且投注将不予退还。</p>
      <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
      <p>该投注用于预测特定运动员是否会在特定比赛中进入前三名。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>本投注预测在两名参赛选手中，哪位选手将根据比赛结束时的排名获得最佳名次。投注的条件是：参赛选手必须参与两种结果的比赛，并且至少有一种结果在同一场比赛中结束。否则，投注将被退还。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>台球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>您必须预测特定锦标赛的获胜选手或队伍。出于投注目的，如果所选选手或队伍未参加锦标赛或因任何原因中途退赛，则已接受的投注将被视为失败，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 会议</span></p>
      <p>您必须预测比赛的获胜者。只有当比赛未进行、选手中途退赛或比赛中断但已宣布获胜者时，投注才会退还，投注仍将被视为有效。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>五人制足球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>1X2</span></p>
      <p>投注包括在常规时间结束时（包括任何恢复时间）对特定比赛的预测。</p>
      <p>如果符号 1，则预测第一个被提议的球队将获胜；如果符号 2，则预测第二个被提议的球队将获胜；如果符号 X，则预测该队将打平。</p>
      <p>可以接受 1X2 让分投注类型。</p>
      <p><span style={{ color: "#ff0000" }}>让分盘口对决</span></p>
      <p>荷官为两支球队中的一支指定一个小数让分，这样对于投注来说，就不会出现平局。</p>
      <p><span style={{ color: "#ff0000" }}>小/大</span></p>
      <p>它用于预测一场比赛中进球总数是高于还是低于预先设定的限制（点差）。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 4.5</span></p>
      <p>投注在于确定在一场特定的比赛中，进球数是少于 4.5 个（低于）还是多于 4.5 个（高于）。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 5.5</span></p>
      <p>投注在于确定在一场特定的比赛中，进球数是少于 5.5 个（低于）还是多于 5.5 个（高于）。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 6.5</span></p>
      <p>投注在于确定在一场特定的比赛中，进球数是少于 6.5 个（低于）还是多于 6.5 个（高于）。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 7.5</span></p>
      <p>投注在于确定在一场特定的比赛中，进球数是少于 7.5 个（低于）还是多于 7.5 个（高于）。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 8.5</span></p>
      <p>投注在于确定在一场特定的比赛中，进球数是少于 8.5 个（低于）还是多于 8.5 个（高于）。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 9.5</span></p>
      <p>投注在于确定在一场特定的比赛中，进球数是少于 9.5 个（低于）还是多于 9.5 个（高于）。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数</span></p>
      <p>投注内容是确定某场比赛结束时的进球数是奇数还是偶数。如果结果为 0-0，则为奇数。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>骑自行车</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>投注内容是预测将赢得单场公路赛或分段赛的自行车手或队伍。</p>
      <p>注意：如果某位自行车手或车队未参加比赛，则对该自行车手的投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>最佳榜单</span></p>
      <p>投注内容是预测在建议名单中哪个自行车手或车队将获得最佳名次。</p>
      <p>注意：如果某个自行车手或车队没有参加比赛，则对该自行车手或车队的投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>骑手赢得的赛段</span></p>
      <p>该方法用于预测在特定赛段比赛（例如环意自行车赛、环法自行车赛等）中，自行车手将赢得的确切赛段数，并从以下 5 个选项中选择一个：</p>
      <p>无舞台；</p>
      <p>第一阶段；</p>
      <p>2个阶段；</p>
      <p>3个阶段；</p>
      <p>4个阶段；</p>
      <p>5 个阶段或更多阶段。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>该赌注预测在两名被提议的自行车手之间，哪一位将在比赛结束时取得最佳名次。</p>
      <p>注意：投注的有效性取决于两种结果（例如：车手）的参与情况，以及至少有一种结果在同一场比赛中结束。否则，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>平均速度</span></p>
      <p>投注内容是预测比赛的平均速度将落在 AMMS 提出的列表所指示的哪个范围内。</p>
      <p>这些乐队是：</p>
      <p>&lt;= 39</p>
      <p>&gt;39 &lt;=40</p>
      <p>&gt;40 &lt;=41</p>
      <p>&gt;41 &lt;=42</p>
      <p>&gt;42</p>
      <p>注意：上述乐队根据比赛类型进行修改。</p>
      <p><span style={{ color: "#ff0000" }}>意大利自行车选手登上领奖台</span></p>
      <p>该赌注预测在特定比赛中，获得前三名的意大利籍自行车运动员的数量。</p>
      <p><span style={{ color: "#ff0000" }}>讲台 - 放置 是 / 否</span></p>
      <p>该赌注预测一名自行车运动员是否会在特定比赛中获得前三名。</p>
      <p>注意：如果自行车手或车队未参加比赛，已接受的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>获胜自行车队</span></p>
      <p>该赌注预测哪个自行车手的队伍将赢得比赛。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>板球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>您必须预测在所提议的队伍中哪支队伍将赢得相关赛事。</p>
      <p><span style={{ color: "#ff0000" }}>头对头比赛结果</span></p>
      <p>您必须预测哪支球队将赢得比赛。“超级赛”的最终结果将计入投注。只要至少有一个球被投出，投注即视为有效。</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
      <p>您必须预测哪支球队将赢得比赛。至少有一个球被投出，投注才有效。如果比赛以“平局”结束，则将适用并列规则，投注平局将被视为输。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>卷发</span></span></p>
      <p><span style={{ color: "#ff0000" }}>正面交锋结果</span></p>
      <p>您需要预测哪支球队将赢得比赛。任何加时赛也将被计入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>头对头让分盘</span></p>
      <p>您必须通过在最终结果上加上或减去投注中指定的让分来预测比赛结果。任何加时赛也将被计入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>投注包括预测在比赛或体育赛事中排名第一的球队。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>您必须预测两支被提名的队伍中哪一支会在某项赛事结束时获得更好的排名。</p>
      <p><span style={{ color: "#ff0000" }}>无 X 获胜者</span></p>
      <p>投注内容是预测在提议的队伍中哪支队伍将在赛事结束时获得最佳名次，同时从列表中排除某个特定结果。</p>
      <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
      <p>该投注预测一支球队是否会在某项赛事的排名中位居前三名。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者是/否</span></p>
      <p>投注内容是预测所提议的队伍是否会赢得（是结果）或不会赢得（否结果）某个事件。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者组</span></p>
      <p>投注内容是预测在列表中所示的队伍中，哪支队伍将根据赛事分类取得最佳名次。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>骑马</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>此投注用于预测特定比赛或赛事的获胜者。如果名单上的运动员或队伍未参加比赛，或在比赛期间因任何原因退出，则针对该特定运动员或队伍的投注将被视为失败，且投注金额不予退还。</p>
      <p><span style={{ color: "#ff0000" }}>奥运冠军</span></p>
      <p>它包括在已公布名单中的队伍中预测哪支队伍将赢得金牌。</p>
      <p>注意：如果已公布名单中的某支球队未参加比赛或在比赛期间退出，则对该球队的投注将被视为失败，因此投注将不予退还。</p>
      <p>如果两支或两支以上的队伍成绩相同，则获胜者的份额必须除以第一名完成比赛的参赛者人数。</p>
      <p>示例：</p>
      <p>两队比分分别为 2.20 和 3.00 平。</p>
      <p>赔率将除以 2，因此分别变为 1.10 和 1.50。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者是/否</span></p>
      <p>投注内容是预测拟议的运动员或团队是否会赢得（是结果）或不会赢得（否结果）特定的比赛/赛事。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 金牌</span></p>
      <p>你必须预测所指示的两个国家中哪一个将赢得更多金牌。</p>
      <p><span style={{ color: "#ff0000" }}>奖牌榜冠军</span></p>
      <p>您必须预测哪个国家将在特定项目的奖牌榜上夺冠（获奖者将根据所获奖牌的重要性来确定）。如果建议的结果列表中未包含所有可能的结果，则将始终包含“其他”项。</p>
      <p><span style={{ color: "#ff0000" }}>无 X 获胜者</span></p>
      <p>投注方式是通过排除列表中的某个特定结果来预测哪位运动员或哪支队伍将在比赛或体育赛事中排名第一。如果列表中未包含所有可能的结果，则始终会包含“其他”选项。</p>
      <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
      <p>投注内容是预测某个运动员或团队是否会在特定比赛或赛事中名列前三。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>投注内容是预测在两个提议之间，根据比赛/赛事结束时的排名，哪位运动员或队伍将取得最佳名次。</p>
      <p>注意：投注的有效性取决于参与两种结果的比赛，以及至少有一种结果在同一场比赛中结束。否则，投注将被退还。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>美式足球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
      <p>投注内容是预测在加时赛结束时哪支球队将赢得比赛：</p>
      <p>1. 表示主队胜利；</p>
      <p>2. 表示客队胜利。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘</span></p>
      <p>投注是根据分配给两支球队之一的让分（以分数表示）预测在加时赛结束时哪支球队将赢得比赛。</p>
      <p>投注结果的确定方法是从被分配了让分的球队在场上取得的得分中减去让分值。</p>
      <p>示例 A：</p>
      <p>巴尔的摩小马队 - 达拉斯 25 - 18（巴尔的摩让分 5.5 分）</p>
      <p>获胜结果 1（25- 5.5 =19.5 –&gt; 最终结果 19.5 -18 因此为 1）</p>
      <p>示例 B：</p>
      <p>巴尔的摩小马队 - 达拉斯 25 – 22（巴尔的摩让分 5.5 分）</p>
      <p>获胜结果 2（25- 5.5 =19.5 –&gt; 最终结果 19.5 -22 因此为 2）</p>
      <p><span style={{ color: "#ff0000" }}>1X2 NFL</span></p>
      <p>投注包括预测比赛的最终结果，包括任何加时赛，按照以下方法：</p>
      <p>- 签 1 表示主队获胜，且分差大于 5 分；</p>
      <p>- X 符号表示平局，或者两队其中一队以小于或等于 5 分的分差获胜；</p>
      <p>- 签 2 表示客队获胜，且分差大于 5 分。</p>
      <p>示例 A</p>
      <p>纽约巨人队 - 底特律雄狮队 28-20：获胜比分：1</p>
      <p>示例 B</p>
      <p>纽约巨人队 - 底特律雄狮队 28-25：获胜结果：X</p>
      <p>示例 C</p>
      <p>纽约巨人队 - 底特律雄狮队 23-29：获胜比分：2</p>
      <p><span style={{ color: "#ff0000" }}>1X2 常规时间</span></p>
      <p>投注包括通过传统的 1x2 方法预测常规时间结束时的比赛结果：符号 1 表示主队获胜；符号 X 表示平局；符号 2 表示客队获胜。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>双重机会</span></p>
      <p>投注内容是预测比赛的最终结果是主队获胜还是在常规时间（不包括加时赛）结束时打平。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会出局</span></p>
      <p>投注内容是预测比赛的最终结果是客队获胜还是在常规时间（不包括加时赛）结束时打平。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会进/出</span></p>
      <p>投注内容是预测比赛的最终结果是在常规时间（不包括加时赛）结束时主队获胜还是客队获胜。</p>
      <p><span style={{ color: "#ff0000" }}>大小匹配</span></p>
      <p>投注内容为预测某项赛事结束时，双方总得分是高于还是低于预设分差。任何加时赛也将被计入报告。</p>
      <p><span style={{ color: "#ff0000" }}>大小盘主场</span></p>
      <p>本投注预测一队在比赛中的总得分是低于还是高于某个数值。任何加时赛也将被计入报告。</p>
      <p><span style={{ color: "#ff0000" }}>客人人数不足/过多</span></p>
      <p>本投注预测第二队在比赛中的总得分是低于还是高于特定值。任何加时赛也将被计入报告。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数</span></p>
      <p>投注内容是预测比赛（包括加时赛）期间两队得分的总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>单/偶数庄家</span></p>
      <p>该投注用于预测一场比赛（包括加时赛）中球队 1 的得分总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数客人</span></p>
      <p>该投注用于预测比赛（包括加时赛）期间第 2 队得分的总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 1° 时间</span></p>
      <p>投注方式是，通过在上半场结束时的结果上加上或减去投注中所示的让分，来预测哪支球队将在上半场结束时领先。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 1°时间</span></p>
      <p>该投注预测哪支球队将赢得比赛的上半场。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 1° 时间</span></p>
      <p>投注内容是预测在给定事件的上半场结束时，总得分是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>上半场单/双</span></p>
      <p>投注内容是预测一场比赛上半场两队得分的总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘 2° 时间</span></p>
      <p>本投注预测哪支球队将赢得比赛下半场，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑下半场的得分，不考虑加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 2°时间</span></p>
      <p>此投注预测比赛下半场的结果。提供三种可能的结果：1（主队领先）、2（客队领先）、X（下半场结束时两队打平）。投注仅考虑下半场的比分，不考虑加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 2° 时间</span></p>
      <p>本投注预测比赛下半场两队总分是低于（低于预设让分）还是高于（高于预设让分）。投注仅考虑下半场的得分，不考虑加时赛的得分。</p>
      <p><span style={{ color: "#ff0000" }}>下半场单/双</span></p>
      <p>本投注预测比赛下半场两队总得分是单数还是双数。投注仅考虑下半场的得分，不考虑加时赛的得分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 1° 第四</span></p>
      <p>投注内容是预测哪支球队将赢得比赛的第一节，结果将通过将让分盘口应用于所选球队的总得分来确定</p>
      <p><span style={{ color: "#ff0000" }}>1X2 第一节（不弃牌）</span></p>
      <p>该投注用于预测比赛第一节的最终结果。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 1° 第四</span></p>
      <p>该投注预测比赛第一节结束时，总得分是高于还是低于预先设定的差距。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 1° 第四宫</span></p>
      <p>该投注预测比赛第一节结束时，第一队的总得分是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>第四位嘉宾低于/高于 1°</span></p>
      <p>该投注预测比赛第一节结束时，第二队的总得分是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 1° 第四达阵</span></p>
      <p>该投注预测比赛第一节中两队的总达阵次数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数 1° 第四</span></p>
      <p>该投注预测比赛第一节两队的得分总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 2° 第四</span></p>
      <p>此投注预测哪支球队将赢得比赛的第二节，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑第二节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 第二节（不弃牌）</span></p>
      <p>该投注用于预测比赛第二节的最终结果。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 2° 第四</span></p>
      <p>该投注预测比赛第二节结束时，总得分是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数 2° 第四</span></p>
      <p>该投注预测比赛第二节两队的得分总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 3° 第四</span></p>
      <p>此投注预测哪支球队将赢得比赛的第三节，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑第三节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 第三节（无弃牌）</span></p>
      <p>该投注用于预测比赛第三节的最终结果。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 3° 第四</span></p>
      <p>该投注预测比赛第三节结束时，总得分是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数 3° 第四</span></p>
      <p>该投注预测一场比赛第三节中两队的得分总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 4° 第四</span></p>
      <p>本投注预测哪支球队将赢得比赛的第四节，结果将根据所选球队的总得分加上让分盘口得出。投注仅考虑第四节的得分，不考虑加时赛的得分。</p>
      <p><span style={{ color: "#ff0000" }}>第 4 节 1X2（不弃牌）</span></p>
      <p>此投注预测比赛第四节的最终结果。投注仅考虑第四节比赛，不考虑加时赛的比分。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 4° 第四</span></p>
      <p>本投注预测比赛第四节结束时，双方总得分是高于还是低于预设分差。投注仅参考第四节比赛，加时赛的得分不予考虑。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数 4° 第四</span></p>
      <p>本投注预测比赛第四节两队得分总和为单数还是双数。投注仅参考第四节比赛，加时赛得分不予考虑。</p>
      <p><span style={{ color: "#ff0000" }}>最高分季度</span></p>
      <p>投注内容是通过将两队得分相加来预测比赛哪一节得分最多。投注结果有 5 种：第一节、第二节、第三节、第四节、平局（所有节的得分相同或两个或两个以上节的得分相同且高于其他节的得分）。</p>
      <p><span style={{ color: "#ff0000" }}>部分/最终</span></p>
      <p>投注包括预测上半场的结果以及比赛的最终结果，出于投注目的，仅考虑常规时间结束时的结果。</p>
      <p><span style={{ color: "#ff0000" }}>胜负差距</span></p>
      <p>投注内容是预测加时赛结束时两支球队中哪一支将赢得比赛的分数差。</p>
      <p>投注包括 6 个主队获胜的乐队和 6 个客队获胜的乐队：</p>
      <p>A(1-5); A(6-10); A(11-15); A(16-20); A(21-25); A(&gt;25);</p>
      <p>B(1-5); B(6-10); B(11-15); B(16-20); B(21-25); B(&gt;25).</p>
      <p><span style={{ color: "#ff0000" }}>胜负差距（7 种结果）</span></p>
      <p>该投注预测两队在任意加时赛结束时，哪一方将赢得比赛，分差是多少。共有 7 种可能的结果：</p>
      <p>A（1-7）</p>
      <p>A (8-14)</p>
      <p>A（&gt;14）</p>
      <p>绘制</p>
      <p>B（1-7）</p>
      <p>B（8-14）</p>
      <p>B（&gt;14）</p>
      <p><span style={{ color: "#ff0000" }}>加时赛是/否</span></p>
      <p>投注内容是预测比赛是否会进入加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>首次触地得分</span></p>
      <p>该投注预测在一场比赛中（包括加时赛）率先得分的球队。</p>
      <p><span style={{ color: "#ff0000" }}>最后一次触地得分</span></p>
      <p>该投注预测在一场比赛（包括加时赛）中哪支球队将获得最后一次触地得分。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于达阵</span></p>
      <p>该投注预测一场比赛中（包括加时赛）两队的总达阵数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于主场达阵</span></p>
      <p>该投注预测一支球队在一场比赛中（包括加时赛）的达阵总数是否高于或低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于达阵嘉宾</span></p>
      <p>该投注预测一场比赛中（包括加时赛）第二队的总达阵次数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于达阵球员</span></p>
      <p>该投注旨在预测一名球员在一场比赛中（包括加时赛）的达阵总数是否高于或低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>第一个射门得分</span></p>
      <p>该投注预测在一场比赛中（包括加时赛）率先进球（三分球）的球队。</p>
      <p><span style={{ color: "#ff0000" }}>最后一射门得分</span></p>
      <p>该投注预测在一场比赛（包括加时赛）中射入最后一个球的球队。</p>
      <p><span style={{ color: "#ff0000" }}>射门得分低于/高于</span></p>
      <p>该投注预测一场比赛中（包括加时赛）两队射门得分的总数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>主场进球数低于/高于</span></p>
      <p>该投注预测一队在一场比赛中（包括加时赛）的进球总数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>射门得分嘉宾大小分</span></p>
      <p>该投注预测一场比赛中（包括加时赛）第二队射入的球门总数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>首攻低于/高于</span></p>
      <p>该投注旨在预测一场比赛中的首攻总数是否高于或低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>率先得分的球队</span></p>
      <p>投注内容是预测在比赛中以任何方式（包括加时赛）率先进球的球队。</p>
      <p><span style={{ color: "#ff0000" }}>最后得分的球队</span></p>
      <p>该投注预测哪支球队将在比赛中以任何方式（包括加时赛）获得最后一分。</p>
      <p><span style={{ color: "#ff0000" }}>率先得分并获胜的球队</span></p>
      <p>投注内容是预测先得分的球队是否也会赢得比赛，包括加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>主队先得分获胜</span></p>
      <p>投注内容是预测第一队是否会率先进球并赢得比赛（包括任何加时赛）。</p>
      <p><span style={{ color: "#ff0000" }}>客队先入球获胜</span></p>
      <p>投注内容是预测第 2 队是否会率先进球并赢得比赛（包括任何加时赛）。</p>
      <p><span style={{ color: "#ff0000" }}>主队上下半场均获胜</span></p>
      <p>投注内容是预测主队在两个常规时间段（不包括加时赛）内是否能比对方球队得分更多。</p>
      <p><span style={{ color: "#ff0000" }}>客队上下半场均获胜</span></p>
      <p>投注内容是预测客队在两个常规时间段（不包括加时赛）内是否能比对方球队得分更多。</p>
      <p><span style={{ color: "#ff0000" }}>第一个实现方法（6 个结果）</span></p>
      <p>投注内容是预测球队 1 或球队 2 将以哪种方式获得比赛的第一分，包括加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>第一个实现方法（3 个结果）</span></p>
      <p>投注内容是预测比赛（包括加时赛）第一分的得分方式。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 码完成跑动</span></p>
      <p>该投注预测两名球员中哪一人在一场比赛（包括加时赛）中完成最多的冲球码数。</p>
      <p><span style={{ color: "#ff0000" }}>少于/超过码数且完成跑垒</span></p>
      <p>该投注预测一场比赛中（包括加时赛）两队完成的总冲球码数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>传球完成的短码/长码</span></p>
      <p>该投注旨在预测一场比赛中（包括加时赛）两队传球完成的总码数是大于还是小于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 营业额</span></p>
      <p>本投注预测比赛（包括加时赛）的总失误次数是高于还是低于预设的差距。失误是指由于对手抢回球权或拦截而导致的丢球。</p>
      <p><span style={{ color: "#ff0000" }}>球员接球数低于/高于</span></p>
      <p>投注内容是预测一名球员在一场比赛中（包括任何加时赛）收到的传球次数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>球员跑动完成的码数少于/超过</span></p>
      <p>该投注用于预测某场比赛（包括加时赛）中某位球员冲刺的码数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>球员传球完成的码数少于/超过</span></p>
      <p>该投注用于预测一名球员在一场比赛中（包括加时赛）传球完成的总码数是高于还是低于预先设定的差距。</p>
      <p><span style={{ color: "#ff0000" }}>触地标记是/否</span></p>
      <p>该投注旨在预测一名球员在特定赛事（包括加时赛）中是否会至少达阵一次。</p>
      <p>是 = 至少达阵一次</p>
      <p>NO = 没有得分</p>
      <p>如果投注达阵的球员未参加比赛（我们所说的“参加”指实际上场的球员），则该投注将被退还。如果球员参加了比赛，即使只参加了有限的一段时间，基于假设比分的投注也将被确认。</p>
      <p><span style={{ color: "#ff0000" }}>首个进球球员触地得分</span></p>
      <p>本投注预测在预先设定的名单中，哪位球员在比赛（包括加时赛）中率先进球达阵。名单中还包含“其他”字样，表示首球达阵由名单中未出现的球员得分；“无达阵”则表示首球达阵未得分。如果名单中的球员未上场，则已接受的投注将被视为输球，因此投注不予退还。</p>
      <p><span style={{ color: "#ff0000" }}>最后一标记触地得分</span></p>
      <p>本投注预测在预先设定的名单中，比赛（包括加时赛）最后达阵得分的球员。名单中还包含“其他”字样，表示最后达阵得分的球员不在名单中；“无达阵”字样表示未达阵得分。如果名单中的球员未上场，则已接受的投注将被视为输掉，因此投注不予退还。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>飞镖</span></span></p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
      <p>你必须预测哪位选手将赢得比赛。此项服务仅适用于预计平局的锦标赛。</p>
      <p><span style={{ color: "#ff0000" }}>头对头比赛结果</span></p>
      <p>你必须预测哪位选手会赢得比赛。此项功能仅适用于预计不会出现平局的锦标赛。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>高尔夫</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>赌注在于预测哪位高尔夫球手将赢得比赛。</p>
      <p>得分最高的球队</p>
      <p>投注在于确定两支球队中哪支将获得最高分。投注者选择符号 1，预测欧洲球队得分更高；选择符号 2，预测美国球队得分更高；选择符号 X，预测两支球队得分相同。</p>
      <p><span style={{ color: "#ff0000" }}>杯赛冠军</span></p>
      <p>投注内容是确定哪支球队在赛事结束时将赢得奖杯。请注意，如果出现平局，奖杯将授予持有者。</p>
      <p><span style={{ color: "#ff0000" }}>一杆进洞</span></p>
      <p>投注内容是确定比赛期间是否会至少有一杆进洞。结果有两种：是 - 否。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>高尔夫球手中的赢家</span></p>
      <p>投注目标在于确定两位高尔夫球手中哪一位的成绩更高。结果有三种可能：1 – X – 2。</p>
      <p><span style={{ color: "#ff0000" }}>高尔夫球手得分</span></p>
      <p>投注内容是确定高尔夫球手的得分。共有三种可能的结果：0 到 1.5；2 到 3.5；大于或等于 4。</p>
      <p><span style={{ color: "#ff0000" }}>最佳球员国籍 X</span></p>
      <p>您需要预测哪位特定国籍的球员将在锦标赛结束时获得最佳排名。如果名单上的球员未参加锦标赛，则已接受的投注将被视为失败，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 球员</span></p>
      <p>您必须预测两位高尔夫球手中哪一位将在最终排名中获得最佳名次，或者比赛结束时两位选手的击球数是否相同（X 符号）。任何附加赛均不予计入。投注有效期为两位选手均须参加比赛，否则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 在会议中</span></p>
      <p>该赌注预测两名高尔夫球手之间的比赛结果。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者组</span></p>
      <p>该投注预测哪位高尔夫球手将在锦标赛结束时获得最佳名次。如果名单上的高尔夫球手未参赛或因任何原因退出，则该选手的投注将被视为失败，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>当天 1X2 球员</span></p>
      <p>您必须预测两位选手中哪一位将在特定比赛日结束时获得最佳名次，或者在比赛结束时两位选手的杆数是否相同。投注时，两位选手都必须在指定日期参加比赛，否则投注将被退还。排名报告仅考虑指定日期的排名。</p>
      <p><span style={{ color: "#ff0000" }}>通过“是/否”筛选</span></p>
      <p>您需要预测特定高尔夫球手或球队是否晋级，并进入赛事的下一阶段。如果高尔夫球手未参加比赛，则投注将被退还，其他情况下投注仍然有效。</p>
      <p><span style={{ color: "#ff0000" }}>锦标赛一杆进洞是/否</span></p>
      <p>你必须预测在一场比赛结束时是否至少有一名高尔夫球手能够一杆进洞。</p>
      <p><span style={{ color: "#ff0000" }}>第一轮比赛后的领先者</span></p>
      <p>您必须预测在特定赛事第一天（第一轮）结束时取得最佳名次的高尔夫球手。如果高尔夫球手在第一天未参赛或退出比赛，则投注将被视为输，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 展览</span></p>
      <p>您必须预测两位选手中哪一位会赢得比赛。如果投注的比赛因任何原因未能进行，将退款。</p>
      <p><span style={{ color: "#ff0000" }}>玩家赢得至少一场大型锦标赛 是/否</span></p>
      <p>您必须预测某位特定球员是否会在特定年份赢得大满贯赛事。如果该球员未参加全部四场大满贯赛事，则与该球员相关的投注将被退还。在其他所有情况下，投注均有效。</p>
      <p><span style={{ color: "#ff0000" }}>玩家在重大锦标赛中的胜利次数</span></p>
      <p>您必须预测特定球员在指定年份赢得的四场大满贯赛事的准确数量。如果该球员未能参加全部四场大满贯赛事，则与该球员相关的投注将被退还。在所有其他情况下，投注仍然有效。</p>
      <p><span style={{ color: "#ff0000" }}>放在顶部 X 是/否</span></p>
      <p>您需要预测某位特定的高尔夫球手是否会在锦标赛的最终排名中名列前X位。如果该高尔夫球手未参赛，投注将被退还，其他情况下投注仍然有效。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>曲棍球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
      <p>投注内容是预测加时赛和点球大战结束时比赛的获胜者。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘</span></p>
      <p>投注内容是预测加时赛和点球大战结束时比赛的获胜者，同时考虑到指定的相对让分。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 结果</span></p>
      <p>投注内容是预测常规时间（实际 60 分钟，分为 3 个半场）结束时的比赛结果。</p>
      <p>1 表示主队获胜</p>
      <p>X 表示平局。</p>
      <p>2 表示客队胜利。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 让分盘</span></p>
      <p>投注内容是预测常规时间结束时赛事的结果，同时考虑分配给两支球队之一的让分（以进球数表示）。</p>
      <p>投注结果通过从被分配让分的球队在场上取得的得分中减去让分值来确定：</p>
      <p>1（带 H）表示主队获胜</p>
      <p>X（带 H）绘制</p>
      <p>2（带 H）客队胜利。</p>
      <p>示例</p>
      <p>博尔扎诺曲棍球 - 米兰曲棍球 7 - 4（博尔扎诺让分 2.5 分）</p>
      <p>获胜结果 1（7-2.5 = 4.5 –&gt; 最终结果 4.5 - 4 因此为 1）</p>
      <p>示例</p>
      <p>博尔扎诺曲棍球 – 米兰曲棍球 7 – 5（博尔扎诺让 2.5 分）</p>
      <p>获胜结果 2（7-2.5 =4.5 –&gt; 最终结果 4.5 - 5 因此为 2）</p>
      <p><span style={{ color: "#ff0000" }}>双重机会</span></p>
      <p>此投注预测比赛最终结果为主队获胜或平局。有效结果是常规时间结束时的结果。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会出局</span></p>
      <p>此投注预测比赛最终结果是客队获胜还是平局。有效结果是常规时间结束时的结果。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会进/出</span></p>
      <p>投注内容为预测比赛最终结果为主队或客队获胜。有效结果是常规时间结束时的比赛结果。</p>
      <p><span style={{ color: "#ff0000" }}>大小匹配</span></p>
      <p>本投注预测一场比赛的总进球数是低于（小于）还是高于（大于）预设的限额。任何加时赛和点球决胜制都将计入投注范围（如果发生点球决胜制，获胜球队将获得一球，并计入其得分）。</p>
      <p><span style={{ color: "#ff0000" }}>大小盘主场</span></p>
      <p>本投注预测主队在比赛中的总进球数是低于（小于）还是高于（大于）预设的限额。加时赛和点球大战均包含在内（如果发生点球大战，获胜球队将获得一球以增加其得分）。</p>
      <p><span style={{ color: "#ff0000" }}>客人人数不足/过多</span></p>
      <p>此投注预测客队在比赛中的总进球数是低于（小于）还是高于（大于）预设的限额。加时赛和点球大战均包含在内（如果发生点球大战，获胜球队将获得一球以增加其得分）。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球</span></p>
      <p>投注内容是预测在比赛的常规时间内两支球队是否都会进球（进球）或者两支球队中至少有一支不会进球（无进球）。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 结果 + 大小匹配</span></p>
      <p>本投注同时预测比赛结果以及两队总得分是否会高于或低于预设指数。投注仅考虑常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 1° 阶段</span></p>
      <p>本投注将投注中指定的进球数让分盘口应用于第一节的最终结果，预测第一节的获胜者。弱势球队获得正让分，而热门球队获得负让分。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 1°周期</span></p>
      <p>投注内容为预测第一节比赛结束时的结果。投注 1 表示预测第一支球队获胜，投注 2 表示预测第二支球队获胜，投注 X 表示预测平局。</p>
      <p><span style={{ color: "#ff0000" }}>第 1 节比赛有双重机会</span></p>
      <p>投注内容是预测第一阶段的结果是主队获胜还是平局。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会出局 1° 节</span></p>
      <p>投注内容是预测第一阶段的结果是客队平局还是胜利。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会 IN/OUT 1° 周期</span></p>
      <p>投注内容是预测第一阶段的比赛结果是主队获胜还是客队获胜。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 1° 节</span></p>
      <p>投注内容是预测比赛第一阶段的总进球数是低于（低于）还是高于（高于）预先设定的限度。</p>
      <p><span style={{ color: "#ff0000" }}>主队 1° 节大小分</span></p>
      <p>投注内容是预测主队在第一阶段的总进球数是低于（低于）还是高于（高于）预先设定的限额。</p>
      <p><span style={{ color: "#ff0000" }}>客队 1&deg; 比赛阶段低于/高于</span></p>
      <p>投注内容是预测主队在第一阶段的总进球数是低于（低于）还是高于（高于）预先设定的限额。</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球 1° 节</span></p>
      <p>投注内容是预测在比赛的第一阶段，两支球队是否都会进球（进球）或者两支球队中至少有一支不会进球（无进球）。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数 1° 周期</span></p>
      <p>该投注预测比赛第一阶段两队的进球总数是单数还是双数。</p>
      <p><span style={{ color: "#ff0000" }}>第一节打进第一个球</span></p>
      <p>投注内容是预测哪支球队将率先进球或比赛第一阶段是否没有进球。</p>
      <p><span style={{ color: "#ff0000" }}>第一节打进最后一球</span></p>
      <p>投注内容是预测哪支球队将打进最后一球或比赛第一阶段是否没有进球。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘 2° 阶段</span></p>
      <p>此投注将投注中指定的进球数让分盘口应用于最终结果，预测第二节的获胜者。投注仅考虑比赛第二节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 2°周期</span></p>
      <p>此投注预测比赛第二节的结果。投注仅考虑比赛第二节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>第 2 阶段双重机会</span></p>
      <p>本投注预测第二节比赛结果为主队获胜还是平局。投注仅考虑第二节比赛的比分。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会出局 2° 节</span></p>
      <p>本投注预测客队在第二节的比赛结果是平局还是胜利。投注仅考虑第二节的比分。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会 IN/OUT 2° 周期</span></p>
      <p>本投注预测第二节比赛结果为主队还是客队获胜。投注仅考虑比赛第二节的比分。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 2° 节</span></p>
      <p>本投注预测比赛第二节前半段的总进球数是低于（低于）还是高于（高于）预设的上限。投注仅考虑比赛第二节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球 2° 节</span></p>
      <p>此投注预测比赛第二节期间两队是否均会进球（进球）或至少有一支球队不会进球（无进球）。投注仅考虑比赛第二节的得分。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数 2° 周期</span></p>
      <p>此投注预测比赛第二节两队进球总数为单数还是双数。投注仅考虑比赛第二节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>第二节攻入第一球</span></p>
      <p>本投注预测哪支球队将率先进球或比赛第二节是否没有进球。投注仅考虑比赛第二节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>第二节打进最后一球</span></p>
      <p>本投注预测哪支球队将打进最后一球，或比赛第二节是否没有进球。投注仅考虑比赛第二节的得分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 3° 阶段</span></p>
      <p>此投注将投注中指定的进球数让分盘口应用于最终结果，预测第三节的获胜者。投注仅考虑比赛第三节的得分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 3°周期</span></p>
      <p>此投注预测比赛第三节的结果。投注仅考虑比赛第三节的得分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>第 3 节双重机会</span></p>
      <p>本投注预测第三节比赛结果为主队获胜还是平局。投注仅考虑第三节比赛的得分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会出局 3° 节</span></p>
      <p>此投注预测第三节比赛的结果是客队平局还是胜利。投注仅考虑第三节的比分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>双重机会 IN/OUT 3° 周期</span></p>
      <p>本投注预测第三节比赛结果为主队还是客队获胜。投注仅考虑第三节比赛的比分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 3° 节</span></p>
      <p>本投注预测比赛前三节的总进球数是低于（低于）还是高于（高于）预设的限额。投注仅考虑比赛第三节的得分，不包括加时赛和点球大战。</p>
      <p><br /> </p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球 3° 节</span></p>
      <p>本投注预测比赛第三节期间两队是否均会进球（进球）或至少有一方不进球（无进球）。投注仅考虑第三节的得分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数 3° 周期</span></p>
      <p>本投注预测比赛第三节两队进球总数为单数还是双数。投注仅考虑比赛第三节的得分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>第 3 节攻入第一球</span></p>
      <p>本投注预测哪支球队将率先进球或比赛第三节是否没有进球。投注仅考虑比赛第三节的得分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>第三节打进最后一球</span></p>
      <p>本投注预测哪支球队将打进最后一球，或比赛第三节是否没有进球。投注仅考虑比赛第三节的得分，不包括加时赛和点球大战。</p>
      <p><span style={{ color: "#ff0000" }}>胜利幅度</span></p>
      <p>本投注预测哪支球队将获胜以及胜负比分。投注仅考虑常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>进球最多的时段</span></p>
      <p>投注内容是通过将两队的得分加起来来预测哪个时段的得分最多。将提供 4 种可能的结果：第 1 时段、第 2 时段、第 3 时段（不包括加时赛和点球大战）和平局，平局发生在所有时段得分相同或两个时段得分相同但高于另一个时段时。</p>
      <p><span style={{ color: "#ff0000" }}>进球 1°</span></p>
      <p>该投注旨在预测哪支球队将在比赛的常规时间内率先进球。</p>
      <p>1 预测主队将先进球</p>
      <p>X 预测两队在常规时间内均不会得分（常规时间内 0-0）</p>
      <p>2 预测客队将先进球</p>
      <p><span style={{ color: "#ff0000" }}>精确结果</span></p>
      <p>投注内容为预测比赛的准确结果。有效结果是常规时间结束时的结果。</p>
      <p><span style={{ color: "#ff0000" }}>总目标</span></p>
      <p>投注内容是预测一场比赛中的进球数，包括加时赛和点球大战，从以下范围中选择一个：</p>
      <p>0-2</p>
      <p>3-4</p>
      <p>5-6</p>
      <p>7-8</p>
      <p>大于 8</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数</span></p>
      <p>投注内容是预测比赛结束时（包括加时赛和点球大战）的总进球数是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>主队单/双</span></p>
      <p>投注内容是预测比赛结束时主队的总进球数（包括加时赛和点球大战）是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>客队奇数/双数</span></p>
      <p>该投注预测比赛结束时客队的总进球数（包括加时赛和点球大战）是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>大小盘比赛直播</span></p>
      <p><span>投注内容是预测一场比赛中进球总数是低于（低于）还是高于（高于）预先设定的限度。</span></p>
      <p><span>出于投注目的，任何加时赛和点球大战均不予考虑。</span></p>
      <p><span style={{ color: "#ff0000" }}>Casa Live 上下</span></p>
      <p><span>投注内容是预测一场比赛中主队的总进球数是低于（低于）还是高于（高于）预先设定的限额。</span></p>
      <p><span>出于投注目的，任何加时赛和点球大战均不予考虑。</span></p>
      <p><span style={{ color: "#ff0000" }}>嘉宾直播低于/高于</span></p>
      <p><span>该投注用于预测一场比赛中客队的总进球数是低于（低于）还是高于（高于）预先设定的限额。</span></p>
      <p><span>出于投注目的，任何加时赛和点球大战均不予考虑。</span></p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>游泳</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>在游泳比赛中，只允许投注获胜者，即预测在已公布名单中的游泳运动员中，哪一位将赢得比赛。</p>
      <p>注意：如果公布名单中的游泳运动员未参加比赛或在比赛中退出比赛，则对他的投注将被视为失败，因此投注将不予退还。</p>
      <p>如果 2 名或以上运动员到达时成绩相同，则获胜者的份额必须除以最先到达的运动员人数</p>
      <p>示例</p>
      <p>两名运动员并列完成比赛，赔率分别为 2.20 和 3.00。</p>
      <p>赔率将除以 2，因此分别变为 1.10 和 1.50。</p>
      <p><span style={{ color: "#ff0000" }}>奥运冠军</span></p>
      <p>它包括在已公布名单中的运动员中预测哪位运动员将赢得金牌。</p>
      <p>注意：如果公布名单中的运动员未参加比赛或在比赛中退出比赛，则对其接受的投注将被视为失败，因此投注将不予退还。</p>
      <p>如果两名或两名以上运动员到达时人数相同，则获胜者的配额必须除以最先到达的运动员人数</p>
      <p>示例：</p>
      <p>两名运动员并列完成比赛，赔率分别为 2.20 和 3.00。</p>
      <p>赔率将除以 2，因此分别变为 1.10 和 1.50。</p>
      <p><span style={{ color: "#ff0000" }}>现场获胜</span></p>
      <p>此市场预测特定比赛的获胜者。客户投注所选游泳运动员将在比赛中获得第一名。该比赛可以是预赛或任何其他类型的比赛，例如半决赛或决赛。可能的结果数量取决于参赛人数。</p>
      <p><span style={{ color: "#ff0000" }}>小组冠军</span></p>
      <p>投注内容是预测在列表中列出的运动员或团队中，哪个将根据比赛/赛事结束时的排名获得最佳名次。</p>
      <p>如果公布名单中的运动员或队伍没有参赛或退出比赛，则对他的投注将被视为失败，因此不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
      <p>投注包括通过从列表中排除某个特定结果来预测哪个运动员、队伍或国家将在比赛或体育赛事中名列第一。</p>
      <p>如果公布名单中的运动员或参赛队伍未参赛或在比赛中途退赛，则针对该运动员或参赛队伍的投注将被视为失败，且不予退款。如果公布名单中未包含所有可能的结果，则“其他”选项将始终包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者是/否</span></p>
      <p>投注内容是预测拟议的运动员或团队是否会赢得（是结果）或不会赢得（否结果）特定的比赛/赛事。</p>
      <p><span style={{ color: "#ff0000" }}>预赛获胜者</span></p>
      <p>投注内容是预测在特定比赛预赛中取得最佳成绩的运动员或队伍。</p>
      <p>注意：如果公布名单中的游泳运动员或队伍没有参加预赛，则对他的投注将被视为失败，因此投注将不予退还。</p>
      <p>如果 2 名或以上运动员到达时成绩相同，则获胜者的份额必须除以最先到达的运动员人数</p>
      <p>示例</p>
      <p>两名运动员并列完成比赛，赔率分别为 2.20 和 3.00。</p>
      <p>赔率将除以 2，因此分别变为 1.10 和 1.50。</p>
      <p><span style={{ color: "#ff0000" }}>奖牌获得者</span></p>
      <p>您必须预测哪个国家将成为特定项目奖牌榜的获胜者。</p>
      <p>排名将按以下顺序考虑：</p>
      <p>赢得的金牌数量；</p>
      <p>赢得的银牌数量；</p>
      <p>获得的铜牌数量；</p>
      <p>如果公布名单中的运动员或参赛队伍未参赛或在比赛中途退赛，则针对该运动员或参赛队伍的投注将被视为失败，且不予退款。如果公布名单中未包含所有可能的结果，则“其他”选项将始终包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>无 X 奖牌榜获胜者</span></p>
      <p>您必须通过从名单中排除特定队伍来预测哪个国家将成为特定项目奖牌榜的获胜者</p>
      <p>排名将按以下顺序考虑：</p>
      <p>赢得的金牌数量；</p>
      <p>赢得的银牌数量；</p>
      <p>获得的铜牌数量；</p>
      <p>如果公布名单中的运动员或参赛队伍未参赛或在比赛中途退赛，则针对该运动员或参赛队伍的投注将被视为失败，且不予退款。如果公布名单中未包含所有可能的结果，则“其他”选项将始终包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>比赛 x 和比赛 y 的获胜者</span></p>
      <p>您必须预测特定运动员或队伍将赢得两场特定的独立比赛。投注的有效性取决于该运动员或队伍是否参加了所投注的两场比赛，否则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
      <p>该投注用于预测某位运动员是否会在特定比赛或赛事中名列前三。</p>
      <p><span style={{ color: "#ff0000" }}>运动员国家 x 登上领奖台 是/否</span></p>
      <p>投注内容是预测某个国籍的至少一名运动员是否会在特定比赛中获得前三名。</p>
      <p><span style={{ color: "#ff0000" }}>世界纪录是/否</span></p>
      <p>您需要预测在特定比赛中是否会创造新的世界纪录，从而打破之前的纪录。在预赛阶段创造的任何纪录也会被纳入投注考虑范围。</p>
      <p><span style={{ color: "#ff0000" }}>世界纪录是/否运动员 - 团队</span></p>
      <p>您必须预测在特定比赛中，特定运动员或特定队伍是否能够成功创造新的世界纪录，或打破之前的纪录。出于投注目的，任何在预赛阶段创下的纪录也会被考虑在内。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>投注内容是预测在两个提议之间，根据比赛/赛事结束时的排名，哪位运动员或队伍将取得最佳名次。</p>
      <p>注意：投注的有效性取决于参与两种结果的比赛，以及至少有一种结果在同一场比赛中结束。否则，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>合格是/否</span></p>
      <p>您必须预测特定运动员或队伍是否能通过淘汰赛阶段获得特定比赛的参赛资格。投注的有效性取决于该运动员或队伍是否参与了特定比赛的淘汰赛阶段，否则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 金牌</span></p>
      <p>你必须预测两名运动员或哪一支队伍将赢得更多金牌。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 总奖牌数</span></p>
      <p>你需要预测两名运动员或哪一支队伍将赢得更多奖牌。获胜者将根据所获奖牌（金牌、银牌和铜牌）的总和决定。</p>
      <p><span style={{ color: "#ff0000" }}>U/O Ori</span></p>
      <p>您必须预测特定运动员或团队赢得的金牌总数是否会低于（低于）或高于（高于）设定的限额。</p>
      <p><span style={{ color: "#ff0000" }}>U/O 奖牌</span></p>
      <p>您必须预测特定运动员或团队赢得的奖牌总数（金牌、银牌和铜牌）是否会低于（低于）或高于（高于）设定的限制。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>手球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘:</span></p>
      <p>荷官为两支球队中的一支指定一个小数让分，这样对于投注来说，就不会出现平局。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 匹配</span></p>
      <p>投注内容是预测常规时间结束时赛事的最终结果：</p>
      <p>1 表示主队先获胜；</p>
      <p>为了抽签；</p>
      <p>第二支客队取得第二场胜利</p>
      <p><span style={{ color: "#ff0000" }}>1X2 让分盘</span></p>
      <p>投注内容是预测常规时间结束时赛事的结果，同时考虑分配给两支球队之一的让分（以进球数表示）。</p>
      <p>投注结果通过从被分配让分的球队在场上取得的得分中减去让分值来确定：</p>
      <p>1（带 H）表示第一个被提议的队伍的胜利；</p>
      <p>X（与 H）绘制，</p>
      <p>2（带有 H）第二个被提议的队伍的胜利。</p>
      <p>示例</p>
      <p>普雷萨诺 -安科纳 27 – 22（普雷萨诺 4 球让分）</p>
      <p>获胜结果 1（27-4=23，最终结果 23 - 22，因此为 1）</p>
      <p>示例</p>
      <p>普雷萨诺 -安科纳 27 – 23（普雷萨诺 4 球让分）</p>
      <p>获胜结果 X（27-4=23，最终结果 23 - 23，因此 X）</p>
      <p>示例</p>
      <p>普雷萨诺 -安科纳 27 – 25（普雷萨诺 4 球让分）</p>
      <p>获胜结果 2（27-4=23，最终结果 23 - 25，因此为 2）</p>
      <p><span style={{ color: "#ff0000" }}>小/大</span></p>
      <p>投注内容是预测在特定赛事中，常规时间结束时两队的总进球数是低于（低于）还是高于（高于）特定值。</p>
      <p><span style={{ color: "#ff0000" }}>主队大小分</span></p>
      <p>本投注预测主队在比赛中的总得分将低于或高于特定值。出于报告目的，仅考虑常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>客队大小分</span></p>
      <p>本投注预测客队在比赛中的总得分将低于或高于特定值。出于报告目的，仅考虑常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 1° 时间</span></p>
      <p>投注内容是预测哪支球队将在上半场结束时领先，结果将通过将让分盘口应用于所选球队的总得分来确定。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 1° 时间</span></p>
      <p>您必须预测在给定事件中，上半场结束时两支球队的进球总数是否会低于（低于）或高于（高于）给定值。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数</span></p>
      <p>该投注预测一场比赛常规时间内两队的总得分是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>水球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
      <p>投注内容是预测常规时间结束时赛事的最终结果：</p>
      <p>1 表示主队获胜</p>
      <p>X 表示平局</p>
      <p>2 客队获胜。</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2 让球</span></p>
      <p>投注内容是预测常规时间结束时赛事的最终结果，同时考虑分配给两支球队之一的让分。</p>
      <p>示例 A：</p>
      <p>波西利波 – 佛罗伦萨 10 – 5（波西利波让 3 球）</p>
      <p>获胜结果 1：（10 -3=7 –&gt; 最终结果 7-5 因此为 1）</p>
      <p>示例 B：</p>
      <p>波西利波 – 佛罗伦萨 10 – 7（波西利波让 3 球）</p>
      <p>获胜结果 X（10-3=7 –最终结果 7 - 7 因此 X）</p>
      <p>示例 C：</p>
      <p>波西利波 – 佛罗伦萨 10 – 9（波西利波让 3 球）</p>
      <p>获胜结果 2（10-3=7 –&gt; 最终结果 7 – 9 因此为 2）</p>
      <p><span style={{ color: "#ff0000" }}>让分盘口对决</span></p>
      <p>荷官为两支球队中的一支指定一个小数让分，这样对于投注来说，就不会出现平局。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 13.5 &ndash; 16.5 &ndash; 19.5</span></p>
      <p>它用于预测常规时间结束时的总进球数是少于还是多于（13.5 – 16.5 – 19.5 个进球）。</p>
      <p>在低假设下，预测比赛最多有 13 - 16 19 个进球；在高假设下，预测进球数等于或超过 14 - 17 - 20</p>
      <p>注意：对于这种类型的投注，投注时有效的结果是常规时间结束时获得的结果。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>拳击</span></span></p>
      <p><span style={{ color: "#ff0000" }}>1X2 会议</span></p>
      <p>你必须预测比赛的最终结果。</p>
      <p><span style={{ color: "#ff0000" }}>回合数-小于/大于</span></p>
      <p>您必须预测比赛的总回合数是低于还是高于某个数值。在分配投注时，如果是半回合制比赛，将参考相应回合的分钟30秒来确定“低于”或“高于”投注的结果。如果比赛因任何原因中断且未结束，则出于投注目的，只有结果可确认的投注才会被报告，否则将被视为无效并退款。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>橄榄球</span></span></p>
      <p>对于橄榄球投注，有效结果是常规时间结束时获得的结果，即 80 分钟的比赛加上任何伤停补时。</p>
      <p>最终结果 1X2</p>
      <p>投注内容是预测常规时间（80 分钟加上伤停补时）结束时赛事的最终结果：</p>
      <p>1 - 表示主队胜利</p>
      <p>X - 抽签</p>
      <p>2 - 客队胜利。</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2 让分</span></p>
      <p>投注内容是预测常规时间结束时赛事的结果，同时考虑分配给两支球队之一的让分（以分数表示）。</p>
      <p>投注结果通过从被分配让分的球队在场上取得的得分中减去让分值来确定：1（带 H）表示主队胜利，X（带 H）表示平局，2（带 H）表示客队胜利。</p>
      <p>示例 A：</p>
      <p>意大利 - 威尔士 26 – 18（意大利让 7 分）</p>
      <p>获胜结果 1：（26-7=19 –&gt; 最终结果 19-18 所以 1）</p>
      <p>示例 B：</p>
      <p>意大利 - 威尔士 26 – 19（意大利让 7 分）</p>
      <p>获胜结果 X（26-7=19 –&gt; 最终结果 19-19 因此 X）</p>
      <p>示例 C：</p>
      <p>意大利 - 威尔士 26 – 20（意大利让 7 分）</p>
      <p>获胜结果 2：（26-7=19 –&gt; 最终结果 19-20，因此为 2）</p>
      <p><span style={{ color: "#ff0000" }}>胜负差距 17 场赛事</span></p>
      <p>该投注预测常规时间结束时两支球队中哪一支将赢得比赛的分数差。</p>
      <p>投注包括 8 场主队获胜的比赛（A）、8 场客队获胜的比赛（B）以及 1 场平局的比赛。</p>
      <p>接受投注的 17 种可能事件如下：</p>
      <p>1. 主队获胜，且分差在1至5分之间；</p>
      <p>2. 主队获胜，且分差在6至10分之间；</p>
      <p>3. 主队获胜，且分差在11至15分之间；</p>
      <p>4. 主队获胜，且分差在16至20分之间；</p>
      <p>5. 主队获胜，且分差在21至25分之间；</p>
      <p>6. 主队获胜，且分差在26至30分之间；</p>
      <p>7. 主队以31比35分的分差获胜；</p>
      <p>8. 主队获胜且分差大于36分；</p>
      <p>9. 客队以1至5分之间的分差获胜；</p>
      <p>10. 客队以6至10分之间的净胜分获胜；</p>
      <p>11. 客队以11至15分获胜；</p>
      <p>12. 客队获胜，且分差在 16 至 20 分之间；</p>
      <p>13. 客队以21至25分获胜；</p>
      <p>14. 客队以26至30分之间的分差获胜；</p>
      <p>15. 客队以31比35分获胜；</p>
      <p>16. 客队获胜，且分差大于36分；</p>
      <p>17. 绘制</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于</span></p>
      <p>该投注预测常规时间结束时两队的得分总和是否为：</p>
      <p>UNDER（小于或等于指示的价差）</p>
      <p>超过（高于指示点差）</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>橄榄球 A 7</span></span></p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
      <p>您必须预测哪支球队将在常规时间结束时赢得比赛。</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2 让分盘</span></p>
      <p>投注内容是预测常规时间结束时赛事的结果，同时考虑分配给两支球队之一的让分（以分数表示）。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋让分盘</span></p>
      <p>您需要将投注中显示的让分应用到最终结果中，以预测哪支球队将赢得比赛。任何加时赛均不计入投注范围。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数</span></p>
      <p>您必须预测一场比赛常规时间内两队的总得分是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>小/大</span></p>
      <p>您必须预测比赛常规时间内两队的总得分是低于（低于）还是高于（高于）某个值。</p>
      <p><span style={{ color: "#ff0000" }}>主场得分低于/高于</span></p>
      <p>您必须预测球队 1 在比赛常规时间内获得的总分数是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>客队积分低于/高于</span></p>
      <p>您必须预测第 2 队在比赛常规时间内获得的总分数是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于米</span></p>
      <p>您必须预测一场比赛常规时间内两队的总得分是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 Mete 球队 1</span></p>
      <p>您必须预测球队 1 在比赛常规时间内的总得分是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 Mete 队 2</span></p>
      <p>您必须预测第 2 队在比赛常规时间内的总得分是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 1°时间</span></p>
      <p>你必须预测哪支球队将赢得比赛的上半场。</p>
      <p><span style={{ color: "#ff0000" }}>上半场对决让分盘</span></p>
      <p>您必须通过将投注中显示的让分应用到上半场结束时取得的结果来预测哪支球队将赢得上半场比赛。</p>
      <p><span style={{ color: "#ff0000" }}>小于/大于 1° 时间</span></p>
      <p>您必须预测比赛上半场两队的总得分是低于（低于）还是高于（高于）某个值。</p>
      <p><span style={{ color: "#ff0000" }}>上半场单/双</span></p>
      <p>您必须预测比赛上半场的得分是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>得分最高的玩家</span></p>
      <p>您必须预测哪位球员将在锦标赛中得分最高。</p>
      <p><span style={{ color: "#ff0000" }}>得分最多的球员</span></p>
      <p>您必须预测哪位球员将在锦标赛中得分最多。</p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>投注包括预测在比赛或体育赛事中排名第一的球队。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者是/否</span></p>
      <p>投注内容是预测所提议的队伍是否会赢得（是结果）或不会赢得（否结果）某场比赛/赛事。</p>
      <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
      <p>投注是通过从列表中排除某个特定结果来预测在比赛或体育赛事中排名第一的球队。</p>
      <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
      <p>投注内容是预测在列表中所示的队伍中，哪支队伍将根据比赛/赛事结束时的排名获得最佳名次。</p>
      <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
      <p>该投注用于预测某支队伍是否会在特定比赛或赛事中名列前三。</p>
      <p><span style={{ color: "#ff0000" }}>正面交锋</span></p>
      <p>该投注旨在预测在两个提案中，哪支队伍将根据比赛/赛事结束时的排名取得最佳名次。</p>
      <p>注意：投注的认证以参与两种结果的比赛为条件，否则将退款。</p>
      <p><span style={{ color: "#ff0000" }}>可能的最终配对</span></p>
      <p>你必须预测哪一对球队将进入锦标赛决赛。</p>
      <p><span style={{ color: "#ff0000" }}>四分之一决赛 是/否</span></p>
      <p>您需要预测指定的球队是否会进入指定赛事的四分之一决赛。如果所选球队未参赛，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>半决赛是/否</span></p>
      <p>您需要预测指定队伍在特定赛事中是否会进入半决赛。如果所选队伍未参赛，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>最终答案为“是/否”</span></p>
      <p>您需要预测指定队伍在特定赛事中是否能晋级决赛。如果所选队伍未参赛，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>团队淘汰阶段</span></p>
      <p>你必须预测某支球队将在锦标赛的哪个阶段被淘汰。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>橄榄球联盟</span></span></p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
      <p>您必须预测哪支球队将在常规时间结束时赢得比赛。</p>
      <p><span style={{ color: "#ff0000" }}>头对头让分盘</span></p>
      <p>您必须预测常规时间结束时的比赛结果，并将投注中指示的点差加到或减去最终结果。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于会面点</span></p>
      <p>您必须预测比赛常规时间内两队的总得分是低于（低于）还是高于（高于）某个值。</p>
      <p><span style={{ color: "#ff0000" }}>上半场得分低于/高于</span></p>
      <p>您必须预测比赛上半场两队的总得分是低于（低于）还是高于（高于）某个值。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>奇数/偶数</span></p>
      <p>您必须预测一场比赛常规时间结束时两队得分的总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>上半场比分 1X2</span></p>
      <p>你必须预测比赛上半场的结果。</p>
      <p><span style={{ color: "#ff0000" }}>上半场头对头让分盘</span></p>
      <p>您必须通过将投注中指示的点差加上或减去上半场结束时获得的结果来预测哪支球队将赢得上半场比赛。</p>
      <p><span style={{ color: "#ff0000" }}>上半场单/双</span></p>
      <p>您必须预测一场比赛上半场结束时两队得分的总和是偶数还是奇数。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>乒乓球</span></span></p>
      <p><span style={{ color: "#ff0000" }}>正面交锋结果</span></p>
      <p>您必须预测哪位球员将赢得比赛。如果一名球员在比赛中退赛，则对该球员的投注将被视为输；反之，如果一名球员在比赛开始前退赛，则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>头对头赛 1</span></p>
      <p>您必须预测哪位选手将赢得第一盘。如果某位选手在第一盘比赛中退赛，则对该选手的投注将被视为输；反之，如果某位选手在第一盘比赛开始前退赛，则投注将被退还。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>凌空抽射</span></span></p>
      <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
      <p>投注是根据以下方法预测比赛的最终结果：</p>
      <p>1：主队获胜</p>
      <p>2：客队获胜</p>
      <p>示例：</p>
      <p>特雷维索 – 摩德纳 3-1 获胜结果：1</p>
      <p>特雷维索 – 摩德纳 2-3 获胜结果：2</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘</span></p>
      <p>本投注将投注中指定的盘口让分盘口应用于最终结果，预测比赛胜负。让分盘口会根据比赛情况而变化，弱势球队将获得正让分，而强势球队将获得负让分。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分</span></p>
      <p>该投注通过将投注中指示的点数差应用于最终结果来预测比赛的获胜者。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 套装 1</span></p>
      <p>该赌注预测第一盘的获胜者。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 套装 2</span></p>
      <p>该赌注预测第二盘的获胜者。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 设置 3</span></p>
      <p>该投注预测第三盘的获胜者</p>
      <p><span style={{ color: "#ff0000" }}>设置 4 是/否</span></p>
      <p>该投注用于预测某场比赛是否会进行第四盘。</p>
      <p><span style={{ color: "#ff0000" }}>设置 5 是/否</span></p>
      <p>该投注用于预测某场比赛是否会进行第五盘。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分盘 1</span></p>
      <p>该投注通过将投注中指示的点数让分应用于最终结果来预测比赛第一盘的获胜者。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于分数</span></p>
      <p>投注内容是预测比赛结束时的最终得分总和（因此将所玩盘数累积的所有得分相加）是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>球队 1 得分低于/高于</span></p>
      <p>该投注预测球队 1 在一场比赛中获得的总分数是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>球队得分低于/高于 2</span></p>
      <p>该投注预测球队 2 在一场比赛中获得的总分数是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于分数盘 X</span></p>
      <p>投注内容是预测某组比赛的最终得分是低于还是高于某个值。</p>
      <p>如果比赛暂停，则该组比赛的场上结果将用于确认投注。</p>
      <p><span style={{ color: "#ff0000" }}>第 1 组第 1 队得分大小</span></p>
      <p>该投注预测第一队在第一场比赛中得到的总分数是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>第 1 组第 2 队得分大小</span></p>
      <p>该投注预测第二队在第一场比赛中得到的总分数是低于还是高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数</span></p>
      <p>该投注预测比赛中两队得分的总和是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>主场单/双分数</span></p>
      <p>该投注预测比赛中第一队的总得分是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数客人积分</span></p>
      <p>该投注预测比赛中第 2 队的总得分是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>奇偶盘 1</span></p>
      <p>投注内容是预测第一盘比赛的总得分是偶数还是奇数。</p>
      <p><span style={{ color: "#ff0000" }}>投注 5</span></p>
      <p>投注内容是预测排球比赛的准确比分（以局数表示）。共有 6 种可能的选择：</p>
      <p>3-0；0-3</p>
      <p>3-1；1-3</p>
      <p>3-2；2-3</p>
      <p><span style={{ color: "#ff0000" }}>套装编号 (3/5)</span></p>
      <p>该投注用于预测一场比赛的总局数。</p>
      <p><span style={{ color: "#ff0000" }}>投注 7</span></p>
      <p>此投注用于预测比赛的最终结果（以局数表示）。此市场适用于采用7局3胜制的比赛。</p>
      <p><span style={{ color: "#ff0000" }}>套装编号 (4/7)</span></p>
      <p>此投注预测一场比赛的总局数。此市场适用于采用7局3胜制的比赛。</p>
      <p><span style={{ color: "#ff0000" }}>第一盘获胜者和比赛获胜者</span></p>
      <p>本投注预测首盘获胜者和比赛胜负的准确组合。如果比赛因任何原因取消或中断，已接受的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>比赛获胜者和低于/高于分数</span></p>
      <p>此投注同时预测比赛胜负，以及两队总得分将高于或低于预设指数。任何黄金组合均不参与此投注。</p>
      <p><span style={{ color: "#ff0000" }}>总计设置福利</span></p>
      <p>该投注用于预测一场比赛将有多少盘由优势决定。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>驾驶</span></span></p>
      <p>对于赛车投注，有效结果以官方联合会发布的结果为准。任何后续公布的排名变动均不视为投注有效。</p>
      <p>请注意，根据官方联合会的规定，侦察圈是比赛本身的一部分。</p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>该赌注预测哪位车手将赢得单场大奖赛。</p>
      <p>注意：如果车手未参加比赛，则对该参赛者的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 竞赛</span></p>
      <p>本投注预测在两名拟定车手之间，哪一位将根据比赛排名获得最佳名次。为了便于报告，即使比赛因任何原因未能完成，官方联合会发布的排名命令仍然有效，并且只有当其中一位或两位车手未参加比赛，或者两位车手在比赛结束时均未获得排名时，投注才会退还。</p>
      <p><span style={{ color: "#ff0000" }}>比赛组冠军</span></p>
      <p>投注内容为预测在名单中列出的车手中，哪位车手将根据比赛结束时的排名获得最佳名次。为了便于报告，即使比赛因任何原因未能完成，官方联合会发布的排名顺序仍然有效。如果公布名单中的车手未参赛或退出比赛，则已接受的投注将被视为失败；如果名单中所有车手在比赛结束时均未获得排名，则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>Scuderia del Vincente</span></p>
      <p>本投注预测单场比赛获胜车手所属的车队。如果该车队中没有任何车手参赛，则该车队的投注将被视为输掉。为了便于报告，请参考国际汽联发布的官方排名。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者的国籍</span></p>
      <p>该赌注预测将赢得单场大奖赛的车手的国籍。</p>
      <p>注意：如果车手未参加比赛，则对该参赛者的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>最快大奖赛圈速</span></p>
      <p>该赌注预测哪位车手将在大奖赛中跑出最快圈速。</p>
      <p>注意：如果车手未参加比赛，则对该参赛者的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>官方资格赛获胜者</span></p>
      <p>该投注旨在预测哪位车手将赢得官方排位赛。</p>
      <p>注意：如果车手未参加官方排位赛，则对该车手的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>电汇资格</span></p>
      <p>本投注预测在两位候选车手之间，哪一位将根据特定大奖赛的官方排位赛排名获得最佳名次。为了便于报告，即使排位赛因任何原因未能完成，官方联合会发布的排名顺序仍然有效。如果一位或两位车手未参加排位赛，或者在排位赛结束时均未获得排名，则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>资格赛小组冠军</span></p>
      <p>投注内容为预测在官方资格赛结束时，名单上车手将获得最佳排名。即使资格赛因任何原因未能完成，官方联合会发布的排名顺序仍然有效。如果已公布名单上的车手未参赛或退出比赛，则该车手的投注将被视为失败。如果名单上的任何车手在官方资格赛结束时均未获得排名，则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>Scuderia del Vincente 排位赛</span></p>
      <p>本投注预测赢得官方排位赛的车手所属车队。如果该车队无车手参赛，则该车队的投注将被视为输掉。为了便于报告，请参考国际汽联发布的官方排名。</p>
      <p><span style={{ color: "#ff0000" }}>自由练习获胜者 X</span></p>
      <p>投注内容为预测哪位候选车手将在某场自由练习赛中获胜。结果列表也包含“其他”结果。国际汽联提供的单圈时间和排名将作为官方参考。如果车手未参赛，则对该车手的投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>领奖台/已放置是/否</span></p>
      <p>该投注用于预测某位车手是否会在特定比赛中获得前三名。</p>
      <p><span style={{ color: "#ff0000" }}>领奖台秩序</span></p>
      <p>投注内容为预测比赛或赛事结束时领奖台的准确排名（按顺序排列为第一、第二、第三名）。如果已公布的车手名单中的车手未参赛或退出比赛，则已接受的投注将被视为有效，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>领奖台秩序混乱</span></p>
      <p>该投注旨在预测比赛结束时领奖台的组成，而不考虑所选车手的完成顺序。</p>
      <p><span style={{ color: "#ff0000" }}>前两个按顺序配对</span></p>
      <p>在“前两名车手组合”投注中，您需要预测大奖赛期间将获得冠亚军的车手组合，并从提供商提供的列表中进行选择。该列表还包括“其他”结果。即使比赛因任何原因未能完成，报告也将以国际汽联提供的排名顺序作为官方参考。</p>
      <p><span style={{ color: "#ff0000" }}>前两个未按顺序配对</span></p>
      <p>本投注预测比赛或赛事结束时领奖台上冠亚军的组成，不考虑所选车手的具体到达顺序。如果所选车手未参赛或退出比赛，则已接受的投注将被视为有效，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>排名前 6 位是/否</span></p>
      <p>本投注预测特定车手能否在大奖赛中获得前六名。投注时，所选车手必须参加比赛（绿灯亮时发车），否则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>积分飞行员是/否</span></p>
      <p>本投注预测某位车手在大奖赛中能否获得有效排名，从而获得世界锦标赛排名所需的积分（即他是否会排在第1至第10名之间）。投注要求所选车手必须参加比赛（绿灯亮时发车），否则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>积分队是/否</span></p>
      <p>该投注预测在大奖赛中，同一支车队的两辆单座赛车是否能获得有效名次，从而获得世界锦标赛排名所需的积分（即，它们将排在第 1 至第 10 名之间）</p>
      <p><span style={{ color: "#ff0000" }}>车队两位车手均获得单积分大奖赛 是/否</span></p>
      <p>本投注预测在大奖赛中，同一支车队的两辆赛车是否能获得有效名次，从而获得世界锦标赛排名所需的积分（即，它们将位列第1至第10名之间）。投注要求所选车队的两辆赛车必须参加比赛（绿灯亮时发车），且不得被负责赛事运营的官方机构宣布为“未发车”，否则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>分类为是/否</span></p>
      <p>投注内容是预测指定车手在比赛结束时是否会获得排名。要获得排名，车手必须完成获胜者所跑圈数的至少 90%（向下取整至最接近的整数圈数）。</p>
      <p>注意：投注的认证必须以投注可能对象的比赛参与为条件，否则将退还投注金。</p>
      示例 1：
      <p>意大利大奖赛：计划 70 圈。</p>
      <p>要获得评级，车手必须完成至少 63 圈。</p>
      示例 2：
      <p>意大利大奖赛：计划 70 圈。</p>
      <p>获胜者 60 完成的圈数。</p>
      <p>要获得评级，车手必须完成至少 54 圈。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于排名</span></p>
      <p>投注内容是预测完成大奖赛的车手数量是高于（超过）还是低于（低于）预定指数。根据国际汽联规定，车手必须完成至少 90% 的获胜圈数才能获得排名。</p>
      <p><span style={{ color: "#ff0000" }}>第一圈退赛车手低于/高于</span></p>
      <p>该赌注预测在比赛第一圈因任何原因退赛的车手总数是高于还是低于预先设定的指数。</p>
      <p><span style={{ color: "#ff0000" }}>车手在第一圈退赛</span></p>
      <p>在“第一圈退赛的车手数量”投注中，您需要预测在可用选项中，实际从起跑线出发，但在比赛第一圈结束前退赛的车手数量。</p>
      <p><span style={{ color: "#ff0000" }}>第一圈结束时领先</span></p>
      <p>投注内容为预测哪位车手（从列表中列出的车手中）将在特定比赛的第一圈（不包括侦察圈）结束时位居第一。如果列表中的车手未参加比赛，或因任何原因未完成第一圈而退出比赛，则针对该车手的投注将被视为输掉，且不予退还。如果发车时赛道上有安全车，则此市场的投注将被退还。如果由于比赛的最终中断而导致第一圈未完成，则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>首位退役飞行员</span></p>
      <p>本投注预测哪位车手将在比赛中率先退赛。获胜结果将参考车手退赛发生的圈数。如果同一圈有多位车手退赛，则适用并列规则。投注时，所选车手必须参加比赛（绿灯亮时发车），如果该车手完全未参加比赛或在侦察圈退赛，则该车手的投注将被视为输，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>第一支退役的球队</span></p>
      <p>此投注预测哪支车队将成为比赛中第一个确定退赛的车手。获胜结果将参考车手退赛发生的圈数。如果不同车队的车手在同一圈退赛，则适用并列规则。投注时，所选车队必须至少有一名车手参加比赛（绿灯亮时发车）。其他情况视为输，不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>国籍首位退役飞行员</span></p>
      <p>本投注预测比赛中首位最终退赛的车手的国籍。获胜结果将参考车手退赛所在的圈数。如果不同国籍的车手在同一圈退赛，则适用并列规则。投注时，至少有一名所选国籍的车手必须参加比赛（绿灯亮时发车）。其他情况视为输，不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>第一名/最后一名</span></p>
      <p>本投注同时预测在特定比赛中获胜的车手和排名垫底的车手。投注不考虑未分级的车手，以联盟发布的比赛分级为准。如果所选车手因任何原因退出比赛或未参加比赛，则投注将被视为失败，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>三元组是/否</span></p>
      <p>该投注预测在某场大奖赛中是否有车手能够获得杆位、大奖赛的胜利和最快圈速。</p>
      <p><span style={{ color: "#ff0000" }}>Hattrick 是/否飞行员</span></p>
      <p>该投注用于预测在某场大奖赛中某位车手是否能够获得杆位、大奖赛的胜利以及最快圈速。</p>
      <p><span style={{ color: "#ff0000" }}>安全车是/否</span></p>
      <p>该投注用于预测大奖赛期间（包括起跑）安全车是否会进入赛道（虚拟安全车不适用于该投注）。</p>
      <p><span style={{ color: "#ff0000" }}>进站速度更快</span></p>
      <p>该投注预测在大奖赛期间哪支车队将最快为车队的车手更换（全部）轮胎。</p>
      <p><span style={{ color: "#ff0000" }}>最佳单场大奖赛车手名单</span></p>
      <p>该投注旨在预测在 AAMS 提供的名单中哪位车手将在某场大奖赛中获得最佳最终名次。</p>
      <p><span style={{ color: "#ff0000" }}>单场 GP 胜利/开始</span></p>
      <p>投注内容是预测赢得某场大奖赛的车手从起跑线上的哪个位置起跑。</p>
      <p>您可以选择以下网格位置之一：</p>
      <p>杆位</p>
      <p>第二名</p>
      <p>第三名或第四名</p>
      <p>5°、6° 或 7° 位</p>
      <p>第 8 至第 13 名</p>
      <p>更多</p>
      <p><span style={{ color: "#ff0000" }}>F1 大奖赛直播</span></p>
      <p>该投注预测哪位车手将赢得单场大奖赛。投注时间大约为比赛结束前一圈。</p>
      <p><span style={{ color: "#ff0000" }}>比赛冠军的发动机制造商</span></p>
      <p>本投注预测单场比赛获胜车手所驾驶赛车的引擎制造商。如果该制造商的车手均未参赛，则该制造商的投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>首位在单场比赛中退赛的车手的引擎制造商</span></p>
      <p>本投注预测比赛中第一位最终退赛的车手的赛车引擎制造商。获胜结果将参考车手退赛所在的比赛圈数。如果同一圈有多辆搭载不同制造商引擎的赛车退赛，则适用并列规则。如果比赛（绿灯亮时发车）中没有搭载所选制造商引擎的赛车参赛，则投注将被视为输，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
      <p>该投注通过排除名单中的特定结果，预测哪位车手或车队将在比赛中获得第一名。如果已公布名单中的车手或车队未参加比赛或在比赛中途退赛，则已接受的投注将被视为失败，且不予退款。</p>
      <p><br /> </p>
      <p>&nbsp;</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>摩托车</span></span></p>
      <p>对于MotoGP的投注，有效结果以主管协会发布的结果为准。任何后续公布的排名变动均不视为投注有效。</p>
      <p><span style={{ color: "#ff0000" }}>获胜大奖赛</span></p>
      <p>该赌注预测哪位车手将赢得单场大奖赛。</p>
      <p>注意：如果车手未参加比赛，则对该参赛者的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 竞赛</span></p>
      <p>本投注预测在两位候选车手中，哪一位将根据单场大奖赛的排名获得最佳名次。如果一位或两位车手均未参赛，或比赛结束时两位车手均未获得排名，则投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者是/否</span></p>
      <p>赌注是预测车手是否会赢得比赛。</p>
      <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
      <p>投注内容是预测在列表中列出的运动员或团队中，哪个将根据比赛/赛事结束时的排名获得最佳名次。</p>
      <p>如果公布名单中的运动员或队伍没有参赛或退出比赛，则对他的投注将被视为失败，因此不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
      <p>投注方式是通过排除列表中的某个特定结果，预测哪位运动员或哪支队伍将在比赛或体育赛事中排名第一。如果已公布名单中的运动员或队伍未参加比赛或在比赛中退出，则针对该运动员或队伍的投注将被视为失败，且不予退款。如果所有可能的结果均未包含在建议的列表中，则始终会包含“其他”选项。</p>
      <p><span style={{ color: "#ff0000" }}>Scuderia del Vincente</span></p>
      <p>本投注预测哪位车手所属的车队将赢得单场比赛。如果该车队的车手均无一人参赛，则该车队的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>获胜者的国籍</span></p>
      <p>本投注预测单场大奖赛冠军车手的国籍。如果车手未参加比赛，则该车手的投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>官方资格赛获胜者</span></p>
      <p>投注内容是预测在建议名单中列出的车手当中，哪位将在官方排位赛中取得最佳时间。</p>
      <p>注意：如果车手未参加官方排位赛，则对该车手的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>电汇资格</span></p>
      <p>该投注旨在预测在特定比赛的官方排位赛中，两位车手之间的胜者。结果将考虑车手的成绩，但不包括车手在排位赛测试前受到的任何处罚。</p>
      <p>注意：投注的有效性取决于两种结果（例如：车手）的参与情况，以及至少有一种结果在同一场比赛中结束。否则，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>Scuderia del Vincente 排位赛</span></p>
      <p>此投注预测哪位车手的车队将赢得官方排位赛。如果该车队的车手均无参赛，则该车队的投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>获奖者国籍资格</span></p>
      <p>本投注预测赢得官方资格赛的车手的国籍。如果车手未参赛，则该车手的投注将被视为输。</p>
      <p><span style={{ color: "#ff0000" }}>优胜者组免费1</span></p>
      <p>投注内容为预测名单中列出的车手，将根据第一节自由赛结束时的排名获得最佳名次。如果已公布名单中的车手未参赛或退出比赛，则已接受的投注将被视为失败，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>优胜者组免费2</span></p>
      <p>本投注预测在公布的车手中，哪位车手将在第二次自由练习赛结束时获得最佳排名。如果公布的车手名单中的车手未参赛或退出比赛，则该车手的投注将被视为失败，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>优胜者组免费3</span></p>
      <p>本投注预测在已公布名单中的车手，在第三次自由练习赛结束时，根据排名获得最佳名次。如果已公布名单中的车手未参赛或退出比赛，则已接受的投注将被视为失败，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>是/否三元组</span></p>
      <p>该投注预测在某场大奖赛中是否有车手能够获得杆位、大奖赛的胜利和最快圈速。</p>
      <p><span style={{ color: "#ff0000" }}>分类为是/否</span></p>
      <p>该投注预测某位车手在比赛结束时是否会获得排名。如果车手未参加比赛，投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>放置在讲台上 是/否</span></p>
      <p>该投注用于预测某位车手是否会在特定比赛中获得前三名。</p>
      <p><span style={{ color: "#ff0000" }}>领奖台秩序</span></p>
      <p>投注内容是预测比赛或赛事结束时领奖台的准确排列顺序（按第一名、第二名、第三名的顺序排列）。</p>
      <p><span style={{ color: "#ff0000" }}>领奖台秩序混乱</span></p>
      <p>该投注旨在预测比赛结束时领奖台的组成，而不管所选车手的到达顺序如何。</p>
      <p><span style={{ color: "#ff0000" }}>按顺序配对第一和第二</span></p>
      <p>投注内容是预测比赛或赛事结束时领奖台上第一名和第二名的组成，并考虑准确的顺序。</p>
      <p><span style={{ color: "#ff0000" }}>第一对和第二对顺序错误</span></p>
      <p>投注内容是预测比赛或赛事结束时领奖台上第一名和第二名的组成，而不考虑具体顺序。</p>
      <p><span style={{ color: "#ff0000" }}>单积分团队大奖赛</span></p>
      <p>该投注预测在大奖赛中，同一支车队的两辆单座赛车是否能获得有效名次，从而获得世界锦标赛排名所需的积分（即，它们将排在第 1 至第 10 名之间）</p>
      <p><span style={{ color: "#ff0000" }}>最佳团体单曲大奖赛</span></p>
      <p>投注内容是预测在建议名单中的车手中，哪位车手将根据单场大奖赛的分类取得最佳名次。</p>
      <p>注意：如果车手未参加比赛，则对该参赛者的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>第一圈结束时领先</span></p>
      <p>投注内容是预测哪位车手将在比赛第一圈结束时率先冲过终点线。</p>
      <p>如果比赛重新开始，则投注时要考虑的报道仅与比赛的第一次开始有关。</p>
      <p><span style={{ color: "#ff0000" }}>最快大奖赛圈速</span></p>
      <p>该赌注预测哪位车手将在大奖赛中跑出最快圈速。</p>
      <p>注意：如果车手未参加比赛，则对该参赛者的投注将被视为输掉。</p>
      <p><span style={{ color: "#ff0000" }}>比赛冠军的发动机制造商</span></p>
      <p>本投注预测单场比赛获胜车手所拥有摩托车引擎的制造商。如果该制造商的车手均未参赛，则该制造商的投注将被视为失败。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>首位在单场比赛中退赛的车手的引擎制造商</span></p>
      <p>本投注预测比赛中第一位最终退赛的车手的摩托车引擎制造商。获胜结果取决于退赛发生的圈数。如果同一圈内有多辆搭载不同制造商引擎的摩托车退赛，则适用并列规则。如果比赛（绿灯亮时发车）中没有搭载所选制造商引擎的摩托车参赛，则投注将被视为输，且不予退款。</p>
      <p><span style={{ color: "#ff0000" }}>摩托车 MOTOGP 直播</span></p>
      <p>在摩托车投注中，还提供实时的 LIVE 投注，赔率在比赛期间会发生变化。</p>
      <p><span style={{ color: "#ff0000" }}>现场获胜</span></p>
      <p>该赌注预测哪位车手将赢得单场大奖赛。</p>
      <p>大约在终点线前 1 圈即可接受投注。</p>
      <p><span style={{ color: "#ff0000" }}>官方直播资格赛获胜者</span></p>
      <p>该投注旨在预测哪位车手将在特定大奖赛的官方资格赛结束时获得第一名。</p>
      <p>比赛接受将在杆位（官方资格）最后一次练习赛结束后约 30 秒关闭。</p>
      <p><span style={{ color: "#ff0000" }}>团体最佳</span></p>
      <p>投注内容是预测在建议名单中的车手中，哪位车手将根据单场大奖赛的分类取得最佳名次。</p>
      <p>大约在终点线前 1 圈即可接受投注。</p>
      <p>注意：如果车手未参加比赛，则对该参赛者的投注将被视为输掉。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>意大利乐透投注</span></span></p>
      <p><span style={{ color: "#ff0000" }}>批次 [X] 已提取</span></p>
      <p>（适用于：第一次抽签、第二次抽签、第三次抽签、第四次抽签、第五次抽签）</p>
      <p>对于这种类型的赌注，您必须预测抽取的相对数字属于哪个组（从 1 到 30、从 31 到 60 和从 61 到 90）。</p>
      <p><span style={{ color: "#ff0000" }}>U/O 轮组 [X]</span></p>
      <p>对于此类投注，您必须预测指定轮盘上抽取的数字总和是低于（小于）还是高于（大于）指定的参考值。百搭号码（或奖励球）不包含在内。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}>乐透集团快乐号码 [X]</span></p>
      <p>对于这种类型的赌注，您必须预测抽出的第一个 Jolly 号码（或奖金球）属于哪个组。</p>
      <p><span style={{ color: "#ff0000" }}>乐透单双轮</span></p>
      <p>对于此类投注，您必须预测参考轮盘上所有数字的总和是单数还是双数。百搭数字（或奖励球）不包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>最高抽签结果</span></p>
      <p>对于此类投注，您必须预测轮盘上抽出的第一个数字和最后一个数字中哪个数字最大。百搭数字（或奖励球）不包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>轮盘彩票中奖/输奖</span></p>
      <p>对于此类投注，您必须预测哪个轮盘的数字总和最高（赢家）和/或哪个轮盘的数字总和最低（输家）。百搭号码（或奖励球）如有，则不包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>乐透特别比赛</span></p>
      <p>对于此类投注，您必须预测赛事中哪个轮盘的开奖号码总和最高。百搭号码（或奖励球）不包含在内。</p>
      <p><span style={{ color: "#ff0000" }}>意大利晚期乐透投注</span></p>
      <p><span style={{ color: "#ff0000" }}>[x]迟到</span></p>
      <p>（适用于：第一个迟到者、第二个迟到者、第三个迟到者、第四个迟到者）</p>
      <p>对于此类投注，您必须预测指定的号码是否会在参考轮盘中出现。活动结束后的抽奖将被考虑。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>娱乐活动</span></span></p>
      <p><span style={{ color: "#ff0000" }}>获胜</span></p>
      <p>此投注用于预测特定娱乐活动的获胜者。如果所选参赛者从一开始就未参赛或在活动期间因任何原因退出，则已接受的投注将被视为失败，且投注金不予退还。如果并非所有参赛者都已提供，则“其他”项目也将包含在内。有关报告，请参阅相关活动官方网站发布的官方报告。</p>
      <p><br /> </p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>PADEL</span></span></p>
      <p><span style={{ color: "#ff0000" }}>T/T 匹配</span></p>
      <p>投注内容为预测哪位或哪对选手将赢得比赛。如果一位或一对选手在比赛中退赛，则对该选手或该对选手的投注将被视为输。如果比赛至少第一分尚未打出，投注将被退还。就报告而言，相关赛事组织者发布的规则和官方数据将有效。所有未提及的事项，均适用现行部长令的规定。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 设置</span></p>
      <p>投注内容为预测比赛中哪两名或哪一对选手将赢得第x盘。如果该名选手或一对选手在第x盘期间退赛，则对该名选手或一对选手的投注将被视为输掉；如果该名选手在第x盘开始前退赛，则投注将被退还。出于报告目的，以赛事组织机构在相关比赛结束时发布的信息为准。所有未提及的事项，均适用现行部长令的规定。</p>
      <p><span style={{ color: "#ff0000" }}>投注 3</span></p>
      <p>投注为三局两胜制比赛的最终比分，包含四种结果：2-0、2-1、1-2、0-2。如果比赛未进行或永久中断，则赛局投注将被退还。出于报告目的，相关赛事组织者发布的规则和官方数据将作为参考。所有未提及的事项，均适用现行部长令的规定。</p>
      <p><span style={{ color: "#ff0000" }}>U/O 游戏</span></p>
      <p>本投注预测参考比赛中的局数总和将低于（低于）还是高于（高于）预设值。如果比赛决胜盘进行超级抢七，则在报告时，该局将被视为单局比赛。如果比赛中出现一名或两名球员退赛，则只有结果可确定，投注才有效，否则将退还投注金。在报告时，参考赛事组织者发布的规则和官方数据将作为依据。所有未提及的事项，均适用现行部长令的规定。</p>
      <p><span style={{ color: "#ff0000" }}>T/T SET X GAME Y</span></p>
      <p>本投注预测比赛中哪两名或哪一对选手将赢得第 x 盘第 y 局。如果两名或哪一对选手中的一人在 y 局开始前退出比赛，则相关投注将被退还。但是，如果一名或一对选手在第 y 局进行过程中退出比赛，则视为输家。本投注以比赛组织者发布的规则和官方数据为准。所有未尽事宜，均适用现行部长令的规定。</p>

    </>

  )
}